var map = {
	"./": [
		72812,
		9
	],
	"./App": [
		4805,
		9
	],
	"./App.css": [
		44050,
		9,
		44050
	],
	"./App.jsx": [
		4805,
		9
	],
	"./App.test": [
		55653,
		9,
		76457,
		55653
	],
	"./App.test.js": [
		55653,
		9,
		76457,
		55653
	],
	"./Desktop.css": [
		70983,
		9,
		70983
	],
	"./Mobile.css": [
		55765,
		9,
		55765
	],
	"./animate.css": [
		65214,
		9,
		65214
	],
	"./assets/Clover/clover.png": [
		92087,
		1,
		92087
	],
	"./assets/Clover/cloverflex.jpg": [
		19454,
		1,
		19454
	],
	"./component/Appointment/AppoimentBlockTime/AppointmentBlockTimeAlert": [
		57639,
		9,
		57639
	],
	"./component/Appointment/AppoimentBlockTime/AppointmentBlockTimeAlert.jsx": [
		57639,
		9,
		57639
	],
	"./component/Appointment/AppoimentBlockTime/AppointmentBlockTimeForm": [
		80943,
		9,
		85867,
		87369,
		80943
	],
	"./component/Appointment/AppoimentBlockTime/AppointmentBlockTimeForm.jsx": [
		80943,
		9,
		85867,
		87369,
		80943
	],
	"./component/Appointment/AppointmentCalendar/AgendaView": [
		7611,
		9,
		77425,
		54590,
		846,
		7611
	],
	"./component/Appointment/AppointmentCalendar/AgendaView.jsx": [
		7611,
		9,
		77425,
		54590,
		846,
		7611
	],
	"./component/Appointment/AppointmentCalendar/CurrentTimeIndicator": [
		14699,
		9,
		14699
	],
	"./component/Appointment/AppointmentCalendar/CurrentTimeIndicator.jsx": [
		14699,
		9,
		14699
	],
	"./component/Appointment/AppointmentCalendar/Filter/AddNew": [
		64982,
		9,
		64982
	],
	"./component/Appointment/AppointmentCalendar/Filter/AddNew.jsx": [
		64982,
		9,
		64982
	],
	"./component/Appointment/AppointmentCalendar/Filter/AgendaFilter": [
		45005,
		9,
		45005
	],
	"./component/Appointment/AppointmentCalendar/Filter/AgendaFilter.jsx": [
		45005,
		9,
		45005
	],
	"./component/Appointment/AppointmentCalendar/Filter/DateSelect": [
		13679,
		9,
		87369,
		13679
	],
	"./component/Appointment/AppointmentCalendar/Filter/DateSelect.jsx": [
		13679,
		9,
		87369,
		13679
	],
	"./component/Appointment/AppointmentCalendar/Filter/StaffDropdown": [
		17990,
		9,
		17990
	],
	"./component/Appointment/AppointmentCalendar/Filter/StaffDropdown.jsx": [
		17990,
		9,
		17990
	],
	"./component/Appointment/AppointmentCalendar/StaffCalendarColumn": [
		89596,
		9,
		85867,
		59221,
		846,
		89596
	],
	"./component/Appointment/AppointmentCalendar/StaffCalendarColumn.jsx": [
		89596,
		9,
		85867,
		59221,
		846,
		89596
	],
	"./component/Appointment/AppointmentStatus/AppointmentStatus": [
		94715,
		9,
		846,
		94715
	],
	"./component/Appointment/AppointmentStatus/AppointmentStatus.jsx": [
		94715,
		9,
		846,
		94715
	],
	"./component/Appointment/AppointmentStatus/AppointmentStatusDropdown": [
		66276,
		9,
		846,
		66276
	],
	"./component/Appointment/AppointmentStatus/AppointmentStatusDropdown.jsx": [
		66276,
		9,
		846,
		66276
	],
	"./component/Appointment/AppointmentType": [
		41245,
		9,
		41245
	],
	"./component/Appointment/AppointmentType.jsx": [
		41245,
		9,
		41245
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientCard": [
		48885,
		9,
		97914,
		59221,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		10169
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientCard.jsx": [
		48885,
		9,
		97914,
		59221,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		10169
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientCardTabInfo/ClientAppointmentsHistory": [
		79152,
		9,
		846,
		79152
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientCardTabInfo/ClientAppointmentsHistory.jsx": [
		79152,
		9,
		846,
		79152
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientCardTabInfo/ClientGeneralInfo": [
		84734,
		9,
		84734
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientCardTabInfo/ClientGeneralInfo.jsx": [
		84734,
		9,
		84734
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientCardTabInfo/ClientInvoicesHistory": [
		63378,
		9,
		63378
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientCardTabInfo/ClientInvoicesHistory.jsx": [
		63378,
		9,
		63378
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientCardTabInfo/ClientLoyaltyInfo": [
		39904,
		9,
		9540,
		39904
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientCardTabInfo/ClientLoyaltyInfo.jsx": [
		39904,
		9,
		9540,
		39904
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientCardTabInfo/useDivHeight": [
		42870,
		9,
		42870
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientCardTabInfo/useDivHeight.jsx": [
		42870,
		9,
		42870
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientQuickSearch": [
		36070,
		9,
		59221,
		70712,
		81344
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientQuickSearch.jsx": [
		36070,
		9,
		59221,
		70712,
		81344
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientSearchListResult": [
		80292,
		9,
		59221,
		70712,
		98758
	],
	"./component/Appointment/CreateAppointment/ClientColumn/ClientSearchListResult.jsx": [
		80292,
		9,
		59221,
		70712,
		98758
	],
	"./component/Appointment/CreateAppointment/ClientColumn/DateCard": [
		45180,
		9,
		45180
	],
	"./component/Appointment/CreateAppointment/ClientColumn/DateCard.jsx": [
		45180,
		9,
		45180
	],
	"./component/Appointment/CreateAppointment/ConfirmAppointmentModal": [
		30170,
		9,
		30170
	],
	"./component/Appointment/CreateAppointment/ConfirmAppointmentModal.jsx": [
		30170,
		9,
		30170
	],
	"./component/Appointment/CreateAppointment/CreateAppointmentContainer": [
		766,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		14893,
		766,
		54230
	],
	"./component/Appointment/CreateAppointment/CreateAppointmentContainer.jsx": [
		766,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		14893,
		766,
		54230
	],
	"./component/Appointment/CreateAppointment/DateSelectDropdown": [
		65617,
		9,
		87369,
		65617
	],
	"./component/Appointment/CreateAppointment/DateSelectDropdown.jsx": [
		65617,
		9,
		87369,
		65617
	],
	"./component/Appointment/CreateAppointment/DurationSelectDropdown": [
		72069,
		9,
		85867,
		72069
	],
	"./component/Appointment/CreateAppointment/DurationSelectDropdown.jsx": [
		72069,
		9,
		85867,
		72069
	],
	"./component/Appointment/CreateAppointment/NewAppointmentAlert": [
		28377,
		9,
		28377
	],
	"./component/Appointment/CreateAppointment/NewAppointmentAlert.jsx": [
		28377,
		9,
		28377
	],
	"./component/Appointment/CreateAppointment/NewAppointmentForm": [
		14893,
		9,
		97914,
		85867,
		14893,
		65777
	],
	"./component/Appointment/CreateAppointment/NewAppointmentForm.jsx": [
		14893,
		9,
		97914,
		85867,
		14893,
		65777
	],
	"./component/Appointment/CreateAppointment/SelectServiceModal": [
		44250,
		9,
		44250
	],
	"./component/Appointment/CreateAppointment/SelectServiceModal.jsx": [
		44250,
		9,
		44250
	],
	"./component/Appointment/CreateAppointment/SelectStaffModal": [
		47383,
		9,
		47383
	],
	"./component/Appointment/CreateAppointment/SelectStaffModal.jsx": [
		47383,
		9,
		47383
	],
	"./component/Appointment/CreateAppointment/StaffNotice": [
		82578,
		9,
		82578
	],
	"./component/Appointment/CreateAppointment/StaffNotice.jsx": [
		82578,
		9,
		82578
	],
	"./component/Appointment/CreateAppointment/StaffSelectDropdown": [
		70433,
		9,
		70433
	],
	"./component/Appointment/CreateAppointment/StaffSelectDropdown.jsx": [
		70433,
		9,
		70433
	],
	"./component/Appointment/CreateAppointment/StarttimeSelectDropdown": [
		58180,
		9,
		85867,
		58180
	],
	"./component/Appointment/CreateAppointment/StarttimeSelectDropdown.jsx": [
		58180,
		9,
		85867,
		58180
	],
	"./component/Appointment/CreateWalkedinAppointment/CreateWalkedinAppointmentContainer": [
		94106,
		9,
		97914,
		85867,
		59221,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		94106,
		17385
	],
	"./component/Appointment/CreateWalkedinAppointment/CreateWalkedinAppointmentContainer.jsx": [
		94106,
		9,
		97914,
		85867,
		59221,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		94106,
		17385
	],
	"./component/Appointment/CreateWalkedinAppointment/WalkinForm": [
		21395,
		9,
		97914,
		85867,
		21395
	],
	"./component/Appointment/CreateWalkedinAppointment/WalkinForm.jsx": [
		21395,
		9,
		97914,
		85867,
		21395
	],
	"./component/Appointment/DuplicateService/DuplicateAppointmentAlert": [
		97513,
		9,
		97513
	],
	"./component/Appointment/DuplicateService/DuplicateAppointmentAlert.jsx": [
		97513,
		9,
		97513
	],
	"./component/Appointment/DuplicateService/DuplicateServiceModel": [
		94514,
		9,
		87369,
		94514
	],
	"./component/Appointment/DuplicateService/DuplicateServiceModel.jsx": [
		94514,
		9,
		87369,
		94514
	],
	"./component/Appointment/EditAppointment/EditAppointmentContainer": [
		72854,
		9,
		97914,
		85867,
		59221,
		87369,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		14893,
		72854,
		30405
	],
	"./component/Appointment/EditAppointment/EditAppointmentContainer.jsx": [
		72854,
		9,
		97914,
		85867,
		59221,
		87369,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		14893,
		72854,
		30405
	],
	"./component/Appointment/RebookAppointment/RebookAppointmentContainer": [
		63810,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		14893,
		63810,
		31849
	],
	"./component/Appointment/RebookAppointment/RebookAppointmentContainer.jsx": [
		63810,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		14893,
		63810,
		31849
	],
	"./component/Appointment/ViewAppointment/AppoinmentFooterActions": [
		68456,
		9,
		68456
	],
	"./component/Appointment/ViewAppointment/AppoinmentFooterActions.jsx": [
		68456,
		9,
		68456
	],
	"./component/Appointment/ViewAppointment/AppointmentDetail": [
		94349,
		9,
		85867,
		59221,
		93141,
		846,
		47393,
		76702,
		79881,
		87753,
		76422,
		94349,
		34097
	],
	"./component/Appointment/ViewAppointment/AppointmentDetail.jsx": [
		94349,
		9,
		85867,
		59221,
		93141,
		846,
		47393,
		76702,
		79881,
		87753,
		76422,
		94349,
		34097
	],
	"./component/Appointment/ViewAppointment/AppointmentEditStaff": [
		76422,
		9,
		76422,
		32411
	],
	"./component/Appointment/ViewAppointment/AppointmentEditStaff.jsx": [
		76422,
		9,
		76422,
		32411
	],
	"./component/Appointment/ViewAppointment/AppointmentHistory": [
		97344,
		9,
		97344
	],
	"./component/Appointment/ViewAppointment/AppointmentHistory.jsx": [
		97344,
		9,
		97344
	],
	"./component/Appointment/ViewAppointment/AppointmentImages": [
		9276,
		9,
		47393,
		33210
	],
	"./component/Appointment/ViewAppointment/AppointmentImages.jsx": [
		9276,
		9,
		47393,
		33210
	],
	"./component/Appointment/ViewAppointment/AppointmentReview": [
		76650,
		9,
		59221,
		79881,
		87753,
		58067
	],
	"./component/Appointment/ViewAppointment/AppointmentReview.jsx": [
		76650,
		9,
		59221,
		79881,
		87753,
		58067
	],
	"./component/Appointment/ViewAppointment/CancelAppointmentModal": [
		94713,
		9,
		94713
	],
	"./component/Appointment/ViewAppointment/CancelAppointmentModal.jsx": [
		94713,
		9,
		94713
	],
	"./component/Appointment/ViewAppointment/NoShowModal": [
		70884,
		9,
		70884
	],
	"./component/Appointment/ViewAppointment/NoShowModal.jsx": [
		70884,
		9,
		70884
	],
	"./component/Appointment/ViewAppointment/PrintAppointmentDetails": [
		15995,
		9,
		93141,
		15995
	],
	"./component/Appointment/ViewAppointment/PrintAppointmentDetails.jsx": [
		15995,
		9,
		93141,
		15995
	],
	"./component/Appointment/ViewAppointment/ResponseModal": [
		87753,
		9,
		59221,
		79881,
		87753,
		54832
	],
	"./component/Appointment/ViewAppointment/ResponseModal.jsx": [
		87753,
		9,
		59221,
		79881,
		87753,
		54832
	],
	"./component/Appointment/ViewAppointment/ViewAppointmentContainer": [
		54022,
		9,
		97914,
		85867,
		59221,
		93141,
		846,
		70712,
		9540,
		47393,
		11542,
		76702,
		90115,
		79881,
		48885,
		87753,
		76422,
		94349,
		74233
	],
	"./component/Appointment/ViewAppointment/ViewAppointmentContainer.jsx": [
		54022,
		9,
		97914,
		85867,
		59221,
		93141,
		846,
		70712,
		9540,
		47393,
		11542,
		76702,
		90115,
		79881,
		48885,
		87753,
		76422,
		94349,
		74233
	],
	"./component/Appointment/ViewAppointment/ViewAppointmentDrawer": [
		13520,
		9,
		97914,
		85867,
		59221,
		93141,
		846,
		70712,
		47393,
		76702,
		25434,
		90115,
		79881,
		87753,
		35467,
		76422,
		94349,
		34178
	],
	"./component/Appointment/ViewAppointment/ViewAppointmentDrawer.jsx": [
		13520,
		9,
		97914,
		85867,
		59221,
		93141,
		846,
		70712,
		47393,
		76702,
		25434,
		90115,
		79881,
		87753,
		35467,
		76422,
		94349,
		34178
	],
	"./component/Appointment/ViewAppointment/useAppointmentMenuItems": [
		97826,
		9,
		97826
	],
	"./component/Appointment/ViewAppointment/useAppointmentMenuItems.jsx": [
		97826,
		9,
		97826
	],
	"./component/CheckedIn/CheckedInContainer": [
		55392,
		9,
		9540,
		20300,
		97787,
		55392
	],
	"./component/CheckedIn/CheckedInContainer.jsx": [
		55392,
		9,
		9540,
		20300,
		97787,
		55392
	],
	"./component/CheckedIn/CheckedInFilter": [
		57274,
		9,
		9540,
		57274
	],
	"./component/CheckedIn/CheckedInFilter.jsx": [
		57274,
		9,
		9540,
		57274
	],
	"./component/CheckedIn/CheckedInStaffList": [
		97787,
		9,
		20300,
		97787
	],
	"./component/CheckedIn/CheckedInStaffList.jsx": [
		97787,
		9,
		20300,
		97787
	],
	"./component/Checkout/AddAppointmentForInvoice": [
		71089,
		9,
		87369,
		71089
	],
	"./component/Checkout/AddAppointmentForInvoice.jsx": [
		71089,
		9,
		87369,
		71089
	],
	"./component/Checkout/AddDiscountAfterTax": [
		8529,
		9,
		77425,
		97914,
		30910
	],
	"./component/Checkout/AddDiscountAfterTax.jsx": [
		8529,
		9,
		77425,
		97914,
		30910
	],
	"./component/Checkout/AddGiftCardToSale": [
		58960,
		9,
		77425,
		97914,
		87369,
		58960
	],
	"./component/Checkout/AddGiftCardToSale.jsx": [
		58960,
		9,
		77425,
		97914,
		87369,
		58960
	],
	"./component/Checkout/AddItemToSale": [
		83181,
		9,
		85867,
		83181
	],
	"./component/Checkout/AddItemToSale.jsx": [
		83181,
		9,
		85867,
		83181
	],
	"./component/Checkout/AddLoyaltyProgram": [
		96620,
		9,
		97914,
		9540,
		71443,
		96620
	],
	"./component/Checkout/AddLoyaltyProgram.jsx": [
		96620,
		9,
		97914,
		9540,
		71443,
		96620
	],
	"./component/Checkout/AddProductToSale": [
		3163,
		9,
		3163
	],
	"./component/Checkout/AddProductToSale.jsx": [
		3163,
		9,
		3163
	],
	"./component/Checkout/AddTipModal": [
		65160,
		9,
		77425,
		97914,
		65160
	],
	"./component/Checkout/AddTipModal.jsx": [
		65160,
		9,
		77425,
		97914,
		65160
	],
	"./component/Checkout/BalanceDetail": [
		96640,
		9,
		77425,
		97914,
		96640
	],
	"./component/Checkout/BalanceDetail.jsx": [
		96640,
		9,
		77425,
		97914,
		96640
	],
	"./component/Checkout/CardPaymentModal/CloverPayment": [
		80666,
		9,
		80666
	],
	"./component/Checkout/CardPaymentModal/CloverPayment.jsx": [
		80666,
		9,
		80666
	],
	"./component/Checkout/CardPaymentModal/PoyntPayment": [
		63293,
		9,
		42104,
		63293
	],
	"./component/Checkout/CardPaymentModal/PoyntPayment.jsx": [
		63293,
		9,
		42104,
		63293
	],
	"./component/Checkout/CardPaymentModal/SelectPaymentTerminalModal": [
		45048,
		9,
		85867,
		361,
		42104,
		82146,
		51215,
		6474
	],
	"./component/Checkout/CardPaymentModal/SelectPaymentTerminalModal.jsx": [
		45048,
		9,
		85867,
		361,
		42104,
		82146,
		51215,
		6474
	],
	"./component/Checkout/CardPaymentModal/TerminalOptions": [
		51215,
		9,
		85867,
		361,
		42104,
		82146,
		51215,
		39297
	],
	"./component/Checkout/CardPaymentModal/TerminalOptions.jsx": [
		51215,
		9,
		85867,
		361,
		42104,
		82146,
		51215,
		39297
	],
	"./component/Checkout/CardPaymentModal/TerminalsSection": [
		11737,
		9,
		11737
	],
	"./component/Checkout/CardPaymentModal/TerminalsSection.jsx": [
		11737,
		9,
		11737
	],
	"./component/Checkout/CheckoutContainer": [
		1798,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		70712,
		9540,
		361,
		42104,
		71443,
		18630,
		90115,
		82146,
		51215,
		35467,
		74851,
		1798
	],
	"./component/Checkout/CheckoutContainer.jsx": [
		1798,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		70712,
		9540,
		361,
		42104,
		71443,
		18630,
		90115,
		82146,
		51215,
		35467,
		74851,
		1798
	],
	"./component/Checkout/GiftCardPaymentForm": [
		49299,
		9,
		97914,
		49299
	],
	"./component/Checkout/GiftCardPaymentForm.jsx": [
		49299,
		9,
		97914,
		49299
	],
	"./component/Checkout/PaymentColumn": [
		74851,
		9,
		97914,
		85867,
		59221,
		70712,
		9540,
		361,
		42104,
		71443,
		18630,
		90115,
		82146,
		51215,
		35467,
		74851
	],
	"./component/Checkout/PaymentColumn.jsx": [
		74851,
		9,
		97914,
		85867,
		59221,
		70712,
		9540,
		361,
		42104,
		71443,
		18630,
		90115,
		82146,
		51215,
		35467,
		74851
	],
	"./component/Checkout/PromotionsCheckout": [
		25117,
		9,
		25117
	],
	"./component/Checkout/PromotionsCheckout.jsx": [
		25117,
		9,
		25117
	],
	"./component/Checkout/SaleForm": [
		13748,
		9,
		77425,
		97914,
		13748
	],
	"./component/Checkout/SaleForm.jsx": [
		13748,
		9,
		77425,
		97914,
		13748
	],
	"./component/Checkout/SplitPaymentModal": [
		12242,
		9,
		12242
	],
	"./component/Checkout/SplitPaymentModal.jsx": [
		12242,
		9,
		12242
	],
	"./component/Client/BlockClientModal/BlockClientModal": [
		7975,
		9,
		7975
	],
	"./component/Client/BlockClientModal/BlockClientModal.jsx": [
		7975,
		9,
		7975
	],
	"./component/Client/ClientDetails/ClientAppointments": [
		58307,
		9,
		846,
		58307
	],
	"./component/Client/ClientDetails/ClientAppointments.jsx": [
		58307,
		9,
		846,
		58307
	],
	"./component/Client/ClientDetails/ClientContactCard": [
		35467,
		9,
		97914,
		59221,
		70712,
		90115,
		35467,
		49702
	],
	"./component/Client/ClientDetails/ClientContactCard.jsx": [
		35467,
		9,
		97914,
		59221,
		70712,
		90115,
		35467,
		49702
	],
	"./component/Client/ClientDetails/ClientGeneralInfo": [
		12330,
		9,
		89949
	],
	"./component/Client/ClientDetails/ClientGeneralInfo.jsx": [
		12330,
		9,
		89949
	],
	"./component/Client/ClientDetails/ClientStatistics": [
		4748,
		9,
		4748
	],
	"./component/Client/ClientDetails/ClientStatistics.jsx": [
		4748,
		9,
		4748
	],
	"./component/Client/ClientDetails/ClientType": [
		6657,
		9,
		97914,
		6657
	],
	"./component/Client/ClientDetails/ClientType.jsx": [
		6657,
		9,
		97914,
		6657
	],
	"./component/Client/ClientDetails/DateCard": [
		61014,
		9,
		61014
	],
	"./component/Client/ClientDetails/DateCard.jsx": [
		61014,
		9,
		61014
	],
	"./component/Client/ClientDetails/LoyaltyProgramCard": [
		83192,
		9,
		97914,
		9540,
		83192
	],
	"./component/Client/ClientDetails/LoyaltyProgramCard.jsx": [
		83192,
		9,
		97914,
		9540,
		83192
	],
	"./component/Client/ClientDetails/LoyaltyProgramDetail": [
		1125,
		9,
		9540,
		1125
	],
	"./component/Client/ClientDetails/LoyaltyProgramDetail.jsx": [
		1125,
		9,
		9540,
		1125
	],
	"./component/Client/ClientDetails/LoyaltyProgramForm": [
		1920,
		9,
		97914,
		1920
	],
	"./component/Client/ClientDetails/LoyaltyProgramForm.jsx": [
		1920,
		9,
		97914,
		1920
	],
	"./component/Client/ClientDetails/UpdateClientModal": [
		70159,
		9,
		59221,
		70712,
		14319
	],
	"./component/Client/ClientDetails/UpdateClientModal.jsx": [
		70159,
		9,
		59221,
		70712,
		14319
	],
	"./component/Client/ClientSearch/ClientFilterForm": [
		79039,
		9,
		77425,
		97914,
		87369,
		12536,
		79039
	],
	"./component/Client/ClientSearch/ClientFilterForm.jsx": [
		79039,
		9,
		77425,
		97914,
		87369,
		12536,
		79039
	],
	"./component/Client/ClientSearch/ClientSearchBox": [
		40903,
		9,
		77425,
		97914,
		59221,
		87369,
		12536,
		63284,
		75436
	],
	"./component/Client/ClientSearch/ClientSearchBox.jsx": [
		40903,
		9,
		77425,
		97914,
		59221,
		87369,
		12536,
		63284,
		75436
	],
	"./component/Client/ClientSearch/ClientSearchResult": [
		21504,
		9,
		77425,
		59221,
		54590,
		21504
	],
	"./component/Client/ClientSearch/ClientSearchResult.jsx": [
		21504,
		9,
		77425,
		59221,
		54590,
		21504
	],
	"./component/Client/CreateClient/ClientForm": [
		15021,
		9,
		59221,
		70712,
		84541
	],
	"./component/Client/CreateClient/ClientForm.jsx": [
		15021,
		9,
		59221,
		70712,
		84541
	],
	"./component/Client/CreateClient/CreateClientModal": [
		4924,
		9,
		59221,
		70712,
		26030
	],
	"./component/Client/CreateClient/CreateClientModal.jsx": [
		4924,
		9,
		59221,
		70712,
		26030
	],
	"./component/Client/RemoveClientModal/RemoveClientModal": [
		3791,
		9,
		3791
	],
	"./component/Client/RemoveClientModal/RemoveClientModal.jsx": [
		3791,
		9,
		3791
	],
	"./component/Client/RequiredDepositModal/RequiredDepositModal": [
		46393,
		9,
		46393
	],
	"./component/Client/RequiredDepositModal/RequiredDepositModal.jsx": [
		46393,
		9,
		46393
	],
	"./component/Client/SimpleClientCard/SimpleClientCard": [
		48103,
		7,
		48103
	],
	"./component/Client/SimpleClientCard/SimpleClientCard.jsx": [
		48103,
		7,
		48103
	],
	"./component/FastCheckout/Checkout/AddDiscountAfterTaxFastCheckout": [
		23483,
		9,
		77425,
		97914,
		23483
	],
	"./component/FastCheckout/Checkout/AddDiscountAfterTaxFastCheckout.jsx": [
		23483,
		9,
		77425,
		97914,
		23483
	],
	"./component/FastCheckout/Checkout/AddGiftCardToSaleFastCheckout": [
		76845,
		9,
		77425,
		97914,
		87369,
		76845
	],
	"./component/FastCheckout/Checkout/AddGiftCardToSaleFastCheckout.jsx": [
		76845,
		9,
		77425,
		97914,
		87369,
		76845
	],
	"./component/FastCheckout/Checkout/AddItemToSaleFastCheckout": [
		43300,
		9,
		85867,
		43300
	],
	"./component/FastCheckout/Checkout/AddItemToSaleFastCheckout.jsx": [
		43300,
		9,
		85867,
		43300
	],
	"./component/FastCheckout/Checkout/AddProductToSaleFastCheckout": [
		31588,
		9,
		31588
	],
	"./component/FastCheckout/Checkout/AddProductToSaleFastCheckout.jsx": [
		31588,
		9,
		31588
	],
	"./component/FastCheckout/Checkout/AddTipModalFastCheckout": [
		58117,
		9,
		77425,
		97914,
		58117
	],
	"./component/FastCheckout/Checkout/AddTipModalFastCheckout.jsx": [
		58117,
		9,
		77425,
		97914,
		58117
	],
	"./component/FastCheckout/Checkout/BalanceDetailFastCheckout": [
		82813,
		9,
		77425,
		97914,
		82813
	],
	"./component/FastCheckout/Checkout/BalanceDetailFastCheckout.jsx": [
		82813,
		9,
		77425,
		97914,
		82813
	],
	"./component/FastCheckout/Checkout/CheckoutContainerForNoAppointment": [
		90102,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		12959,
		82146,
		51215,
		30394,
		54155,
		27563
	],
	"./component/FastCheckout/Checkout/CheckoutContainerForNoAppointment.jsx": [
		90102,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		12959,
		82146,
		51215,
		30394,
		54155,
		27563
	],
	"./component/FastCheckout/Checkout/CloverPaymentFastCheckout": [
		10393,
		9,
		10393
	],
	"./component/FastCheckout/Checkout/CloverPaymentFastCheckout.jsx": [
		10393,
		9,
		10393
	],
	"./component/FastCheckout/Checkout/GiftCardPaymentFormFastCheckout": [
		49182,
		9,
		97914,
		49182
	],
	"./component/FastCheckout/Checkout/GiftCardPaymentFormFastCheckout.jsx": [
		49182,
		9,
		97914,
		49182
	],
	"./component/FastCheckout/Checkout/PaymentColumnFastCheckout": [
		30394,
		9,
		97914,
		85867,
		361,
		42104,
		82146,
		51215,
		30394,
		87741
	],
	"./component/FastCheckout/Checkout/PaymentColumnFastCheckout.jsx": [
		30394,
		9,
		97914,
		85867,
		361,
		42104,
		82146,
		51215,
		30394,
		87741
	],
	"./component/FastCheckout/Checkout/PromotionsFastCheckout": [
		2938,
		9,
		2938
	],
	"./component/FastCheckout/Checkout/PromotionsFastCheckout.jsx": [
		2938,
		9,
		2938
	],
	"./component/FastCheckout/Checkout/SaleFormFastCheckout": [
		54155,
		9,
		77425,
		97914,
		54155,
		74040
	],
	"./component/FastCheckout/Checkout/SaleFormFastCheckout.jsx": [
		54155,
		9,
		77425,
		97914,
		54155,
		74040
	],
	"./component/FastCheckout/Checkout/SplitPaymentModal": [
		54993,
		9,
		54993
	],
	"./component/FastCheckout/Checkout/SplitPaymentModal.jsx": [
		54993,
		9,
		54993
	],
	"./component/FastCheckout/Invoice/AddPaymentFastCheckout": [
		39358,
		9,
		97914,
		361,
		82146,
		39358
	],
	"./component/FastCheckout/Invoice/AddPaymentFastCheckout.jsx": [
		39358,
		9,
		97914,
		361,
		82146,
		39358
	],
	"./component/FastCheckout/Invoice/InvoiceContainerFastCheckout": [
		44985,
		9,
		97914,
		85867,
		93141,
		361,
		42104,
		82146,
		51215,
		30394,
		62366,
		53501
	],
	"./component/FastCheckout/Invoice/InvoiceContainerFastCheckout.jsx": [
		44985,
		9,
		97914,
		85867,
		93141,
		361,
		42104,
		82146,
		51215,
		30394,
		62366,
		53501
	],
	"./component/FastCheckout/Invoice/InvoiceGiftcardsEmailsFormFastCheckout": [
		76638,
		9,
		76638
	],
	"./component/FastCheckout/Invoice/InvoiceGiftcardsEmailsFormFastCheckout.jsx": [
		76638,
		9,
		76638
	],
	"./component/FastCheckout/Invoice/InvoiceGiftcardsEmailsModalFastCheckout": [
		68057,
		9,
		68057
	],
	"./component/FastCheckout/Invoice/InvoiceGiftcardsEmailsModalFastCheckout.jsx": [
		68057,
		9,
		68057
	],
	"./component/FastCheckout/Invoice/InvoicePaperFastCheckout": [
		23686,
		9,
		23686
	],
	"./component/FastCheckout/Invoice/InvoicePaperFastCheckout.jsx": [
		23686,
		9,
		23686
	],
	"./component/FastCheckout/Invoice/InvoicePaymentColumnFastCheckout": [
		6668,
		9,
		97914,
		85867,
		93141,
		361,
		42104,
		82146,
		51215,
		30394,
		62366,
		66516
	],
	"./component/FastCheckout/Invoice/InvoicePaymentColumnFastCheckout.jsx": [
		6668,
		9,
		97914,
		85867,
		93141,
		361,
		42104,
		82146,
		51215,
		30394,
		62366,
		66516
	],
	"./component/FastCheckout/Invoice/InvoiceStatusColumnFastCheckout": [
		62366,
		9,
		85867,
		93141,
		62366,
		17781
	],
	"./component/FastCheckout/Invoice/InvoiceStatusColumnFastCheckout.jsx": [
		62366,
		9,
		85867,
		93141,
		62366,
		17781
	],
	"./component/FastCheckout/Invoice/InvoiceStatusFastCheckout": [
		39804,
		9,
		39804
	],
	"./component/FastCheckout/Invoice/InvoiceStatusFastCheckout.jsx": [
		39804,
		9,
		39804
	],
	"./component/FastCheckout/Invoice/RefundPaymentsModalFastCheckout": [
		50509,
		9,
		50509
	],
	"./component/FastCheckout/Invoice/RefundPaymentsModalFastCheckout.jsx": [
		50509,
		9,
		50509
	],
	"./component/GiftCardHistory/GiftCardHistoryForm": [
		73183,
		9,
		77425,
		97914,
		54590,
		87369,
		73183
	],
	"./component/GiftCardHistory/GiftCardHistoryForm.jsx": [
		73183,
		9,
		77425,
		97914,
		54590,
		87369,
		73183
	],
	"./component/GiftCardHistory/GiftCardHistoryHistory": [
		4945,
		9,
		77425,
		54590,
		4945
	],
	"./component/GiftCardHistory/GiftCardHistoryHistory.jsx": [
		4945,
		9,
		77425,
		54590,
		4945
	],
	"./component/GiftCardHistory/GiftCardHistoryList": [
		93953,
		9,
		77425,
		97914,
		54590,
		87369,
		73183,
		93953
	],
	"./component/GiftCardHistory/GiftCardHistoryList.jsx": [
		93953,
		9,
		77425,
		97914,
		54590,
		87369,
		73183,
		93953
	],
	"./component/GiftCardHistory/GiftCardHistorySearchBox": [
		68110,
		9,
		77425,
		97914,
		54590,
		87369,
		73183,
		68110
	],
	"./component/GiftCardHistory/GiftCardHistorySearchBox.jsx": [
		68110,
		9,
		77425,
		97914,
		54590,
		87369,
		73183,
		68110
	],
	"./component/History/AiCallHistory/AiCallDetails": [
		16486,
		9,
		59221,
		20691,
		16486
	],
	"./component/History/AiCallHistory/AiCallDetails.jsx": [
		16486,
		9,
		59221,
		20691,
		16486
	],
	"./component/History/AiCallHistory/AiCalls": [
		8867,
		9,
		77425,
		85867,
		59221,
		54590,
		20691,
		8867
	],
	"./component/History/AiCallHistory/AiCalls.jsx": [
		8867,
		9,
		77425,
		85867,
		59221,
		54590,
		20691,
		8867
	],
	"./component/History/Appointments/DownloadAppointmentListButton": [
		29725,
		9,
		29725
	],
	"./component/History/Appointments/DownloadAppointmentListButton.jsx": [
		29725,
		9,
		29725
	],
	"./component/History/Appointments/HistoryAppointmentByDate": [
		7140,
		9,
		77425,
		54590,
		7140
	],
	"./component/History/Appointments/HistoryAppointmentByDate.jsx": [
		7140,
		9,
		77425,
		54590,
		7140
	],
	"./component/History/Appointments/HistoryAppointmentByStatus": [
		38410,
		9,
		77425,
		54590,
		846,
		38410
	],
	"./component/History/Appointments/HistoryAppointmentByStatus.jsx": [
		38410,
		9,
		77425,
		54590,
		846,
		38410
	],
	"./component/History/Appointments/HistoryAppointmentByType": [
		96720,
		9,
		77425,
		54590,
		96720
	],
	"./component/History/Appointments/HistoryAppointmentByType.jsx": [
		96720,
		9,
		77425,
		54590,
		96720
	],
	"./component/History/Appointments/HistoryAppointmentTable": [
		73083,
		9,
		77425,
		54590,
		846,
		73083
	],
	"./component/History/Appointments/HistoryAppointmentTable.jsx": [
		73083,
		9,
		77425,
		54590,
		846,
		73083
	],
	"./component/History/Appointments/NewHistoryAppointment": [
		75079,
		9,
		77425,
		54590,
		846,
		75079,
		6032
	],
	"./component/History/Appointments/NewHistoryAppointment.jsx": [
		75079,
		9,
		77425,
		54590,
		846,
		75079,
		6032
	],
	"./component/History/Charts/HistoryBarChart": [
		85862,
		9,
		26989,
		17867,
		82291,
		85862
	],
	"./component/History/Charts/HistoryBarChart.jsx": [
		85862,
		9,
		26989,
		17867,
		82291,
		85862
	],
	"./component/History/Charts/HistoryPieChart": [
		74553,
		9,
		26989,
		17867,
		60163,
		74553
	],
	"./component/History/Charts/HistoryPieChart.jsx": [
		74553,
		9,
		26989,
		17867,
		60163,
		74553
	],
	"./component/History/Filter/HistoryDateInputSelect": [
		50276,
		9,
		87369,
		50276
	],
	"./component/History/Filter/HistoryDateInputSelect.jsx": [
		50276,
		9,
		87369,
		50276
	],
	"./component/History/Filter/HistoryDateMonthSelect": [
		51534,
		9,
		87369,
		51534
	],
	"./component/History/Filter/HistoryDateMonthSelect.jsx": [
		51534,
		9,
		87369,
		51534
	],
	"./component/History/Filter/HistoryDateRangeSelect": [
		4667,
		9,
		87369,
		4667
	],
	"./component/History/Filter/HistoryDateRangeSelect.jsx": [
		4667,
		9,
		87369,
		4667
	],
	"./component/History/Filter/HistoryDateSelect": [
		13086,
		9,
		87369,
		13086
	],
	"./component/History/Filter/HistoryDateSelect.jsx": [
		13086,
		9,
		87369,
		13086
	],
	"./component/History/Filter/HistorySearchButton": [
		18738,
		9,
		18738
	],
	"./component/History/Filter/HistorySearchButton.jsx": [
		18738,
		9,
		18738
	],
	"./component/History/HistoryAppointments": [
		29715,
		9,
		77425,
		54590,
		846,
		26989,
		17867,
		60163,
		64927,
		29715
	],
	"./component/History/HistoryAppointments.jsx": [
		29715,
		9,
		77425,
		54590,
		846,
		26989,
		17867,
		60163,
		64927,
		29715
	],
	"./component/History/HistoryContainer": [
		42888,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		93141,
		846,
		26989,
		17867,
		82291,
		20691,
		27841,
		10370,
		56672,
		18872,
		79881,
		87753,
		6124,
		51190,
		30893,
		75079,
		42888
	],
	"./component/History/HistoryContainer.jsx": [
		42888,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		93141,
		846,
		26989,
		17867,
		82291,
		20691,
		27841,
		10370,
		56672,
		18872,
		79881,
		87753,
		6124,
		51190,
		30893,
		75079,
		42888
	],
	"./component/History/HistoryInvoices": [
		3993,
		9,
		77425,
		54590,
		26989,
		17867,
		60163,
		3993
	],
	"./component/History/HistoryInvoices.jsx": [
		3993,
		9,
		77425,
		54590,
		26989,
		17867,
		60163,
		3993
	],
	"./component/History/HistoryPayments": [
		44072,
		9,
		77425,
		54590,
		26989,
		17867,
		60163,
		44072
	],
	"./component/History/HistoryPayments.jsx": [
		44072,
		9,
		77425,
		54590,
		26989,
		17867,
		60163,
		44072
	],
	"./component/History/HistoryReport": [
		33251,
		9,
		77425,
		54590,
		33251
	],
	"./component/History/HistoryReport.jsx": [
		33251,
		9,
		77425,
		54590,
		33251
	],
	"./component/History/HistoryReportPrintButton": [
		84754,
		9,
		77425,
		54590,
		93141,
		84754
	],
	"./component/History/HistoryReportPrintButton.jsx": [
		84754,
		9,
		77425,
		54590,
		93141,
		84754
	],
	"./component/History/HistoryRevenues/DepositDetails": [
		68563,
		9,
		97914,
		20691,
		68563
	],
	"./component/History/HistoryRevenues/DepositDetails.jsx": [
		68563,
		9,
		97914,
		20691,
		68563
	],
	"./component/History/HistoryRevenues/GiftCardPaymentDetails": [
		2155,
		9,
		77425,
		54590,
		93141,
		2155
	],
	"./component/History/HistoryRevenues/GiftCardPaymentDetails.jsx": [
		2155,
		9,
		77425,
		54590,
		93141,
		2155
	],
	"./component/History/HistoryRevenues/GiftCardReportDetail": [
		86014,
		9,
		77425,
		54590,
		93141,
		86014
	],
	"./component/History/HistoryRevenues/GiftCardReportDetail.jsx": [
		86014,
		9,
		77425,
		54590,
		93141,
		86014
	],
	"./component/History/HistoryRevenues/HistoryDeposits": [
		51190,
		9,
		77425,
		97914,
		85867,
		54590,
		93141,
		20691,
		51190,
		73668
	],
	"./component/History/HistoryRevenues/HistoryDeposits.jsx": [
		51190,
		9,
		77425,
		97914,
		85867,
		54590,
		93141,
		20691,
		51190,
		73668
	],
	"./component/History/HistoryRevenues/HistoryDiscounts": [
		45195,
		9,
		77425,
		85867,
		54590,
		93141,
		45195
	],
	"./component/History/HistoryRevenues/HistoryDiscounts.jsx": [
		45195,
		9,
		77425,
		85867,
		54590,
		93141,
		45195
	],
	"./component/History/HistoryRevenues/HistoryGiftCard": [
		18351,
		9,
		77425,
		54590,
		93141,
		18351
	],
	"./component/History/HistoryRevenues/HistoryGiftCard.jsx": [
		18351,
		9,
		77425,
		54590,
		93141,
		18351
	],
	"./component/History/HistoryRevenues/HistoryInvoices": [
		34127,
		9,
		77425,
		85867,
		54590,
		93141,
		34127
	],
	"./component/History/HistoryRevenues/HistoryInvoices.jsx": [
		34127,
		9,
		77425,
		85867,
		54590,
		93141,
		34127
	],
	"./component/History/HistoryRevenues/HistorySaleByPayment": [
		93527,
		9,
		77425,
		54590,
		93141,
		93527
	],
	"./component/History/HistoryRevenues/HistorySaleByPayment.jsx": [
		93527,
		9,
		77425,
		54590,
		93141,
		93527
	],
	"./component/History/HistoryRevenues/HistorySalesByDate": [
		49996,
		9,
		77425,
		85867,
		54590,
		93141,
		49996
	],
	"./component/History/HistoryRevenues/HistorySalesByDate.jsx": [
		49996,
		9,
		77425,
		85867,
		54590,
		93141,
		49996
	],
	"./component/History/HistoryRevenues/HistorySalesByMenu": [
		20921,
		9,
		77425,
		85867,
		54590,
		93141,
		20921
	],
	"./component/History/HistoryRevenues/HistorySalesByMenu.jsx": [
		20921,
		9,
		77425,
		85867,
		54590,
		93141,
		20921
	],
	"./component/History/HistoryRevenues/HistorySalesByProduct": [
		59927,
		9,
		77425,
		85867,
		54590,
		93141,
		59927
	],
	"./component/History/HistoryRevenues/HistorySalesByProduct.jsx": [
		59927,
		9,
		77425,
		85867,
		54590,
		93141,
		59927
	],
	"./component/History/HistoryRevenues/HistorySalesByStaff": [
		6124,
		9,
		77425,
		97914,
		54590,
		93141,
		27841,
		6124,
		18758
	],
	"./component/History/HistoryRevenues/HistorySalesByStaff.jsx": [
		6124,
		9,
		77425,
		97914,
		54590,
		93141,
		27841,
		6124,
		18758
	],
	"./component/History/HistoryRevenues/HistorySalesByStore": [
		93441,
		9,
		77425,
		54590,
		93141,
		10370,
		93441
	],
	"./component/History/HistoryRevenues/HistorySalesByStore.jsx": [
		93441,
		9,
		77425,
		54590,
		93141,
		10370,
		93441
	],
	"./component/History/HistoryRevenues/HistoryTaxes": [
		29108,
		9,
		77425,
		54590,
		93141,
		29108
	],
	"./component/History/HistoryRevenues/HistoryTaxes.jsx": [
		29108,
		9,
		77425,
		54590,
		93141,
		29108
	],
	"./component/History/HistoryRevenues/HistoryTips": [
		96201,
		9,
		77425,
		85867,
		54590,
		93141,
		27841,
		96201
	],
	"./component/History/HistoryRevenues/HistoryTips.jsx": [
		96201,
		9,
		77425,
		85867,
		54590,
		93141,
		27841,
		96201
	],
	"./component/History/HistoryRevenues/NewHistoryRevenue": [
		30893,
		9,
		77425,
		97914,
		85867,
		54590,
		93141,
		20691,
		27841,
		10370,
		18872,
		6124,
		51190,
		30893,
		63330
	],
	"./component/History/HistoryRevenues/NewHistoryRevenue.jsx": [
		30893,
		9,
		77425,
		97914,
		85867,
		54590,
		93141,
		20691,
		27841,
		10370,
		18872,
		6124,
		51190,
		30893,
		63330
	],
	"./component/History/HistoryRevenues/ProductReportDetails": [
		93320,
		9,
		77425,
		54590,
		93141,
		93320
	],
	"./component/History/HistoryRevenues/ProductReportDetails.jsx": [
		93320,
		9,
		77425,
		54590,
		93141,
		93320
	],
	"./component/History/HistoryRevenues/StaffCommissionForm": [
		41012,
		9,
		77425,
		97914,
		41012
	],
	"./component/History/HistoryRevenues/StaffCommissionForm.jsx": [
		41012,
		9,
		77425,
		97914,
		41012
	],
	"./component/History/HistoryRevenues/StaffReportDetail": [
		94148,
		9,
		77425,
		54590,
		93141,
		27841,
		94148
	],
	"./component/History/HistoryRevenues/StaffReportDetail.jsx": [
		94148,
		9,
		77425,
		54590,
		93141,
		27841,
		94148
	],
	"./component/History/HistoryRevenues/StaffReportDetailByDate": [
		33603,
		9,
		77425,
		54590,
		93141,
		27841,
		33603
	],
	"./component/History/HistoryRevenues/StaffReportDetailByDate.jsx": [
		33603,
		9,
		77425,
		54590,
		93141,
		27841,
		33603
	],
	"./component/History/HistoryRevenues/StaffReportDetailByDateReceipt": [
		92683,
		9,
		77425,
		54590,
		93141,
		92683
	],
	"./component/History/HistoryRevenues/StaffReportDetailByDateReceipt.jsx": [
		92683,
		9,
		77425,
		54590,
		93141,
		92683
	],
	"./component/History/HistoryRevenues/StaffReportDetailByInvoice": [
		95438,
		9,
		77425,
		54590,
		93141,
		27841,
		95438
	],
	"./component/History/HistoryRevenues/StaffReportDetailByInvoice.jsx": [
		95438,
		9,
		77425,
		54590,
		93141,
		27841,
		95438
	],
	"./component/History/HistoryRevenues/StaffReportDetailByInvoiceReceipt": [
		25364,
		9,
		77425,
		54590,
		93141,
		25364
	],
	"./component/History/HistoryRevenues/StaffReportDetailByInvoiceReceipt.jsx": [
		25364,
		9,
		77425,
		54590,
		93141,
		25364
	],
	"./component/History/HistoryRevenues/StaffReportDetailByInvoiceSalesDetail": [
		86623,
		9,
		77425,
		54590,
		86623
	],
	"./component/History/HistoryRevenues/StaffReportDetailByInvoiceSalesDetail.jsx": [
		86623,
		9,
		77425,
		54590,
		86623
	],
	"./component/History/HistoryRevenues/StaffReportProductSaleDetail": [
		89116,
		9,
		77425,
		54590,
		93141,
		27841,
		89116
	],
	"./component/History/HistoryRevenues/StaffReportProductSaleDetail.jsx": [
		89116,
		9,
		77425,
		54590,
		93141,
		27841,
		89116
	],
	"./component/History/HistoryRevenues/useFetchGiftCardData": [
		80504,
		9,
		80504
	],
	"./component/History/HistoryRevenues/useFetchGiftCardData.js": [
		80504,
		9,
		80504
	],
	"./component/History/HistoryRevenues/useFetchStaffData": [
		27648,
		9,
		27648
	],
	"./component/History/HistoryRevenues/useFetchStaffData.js": [
		27648,
		9,
		27648
	],
	"./component/History/HistoryReviews": [
		7598,
		9,
		59221,
		26989,
		17867,
		82291,
		56672,
		79881,
		87753,
		99852
	],
	"./component/History/HistoryReviews.jsx": [
		7598,
		9,
		59221,
		26989,
		17867,
		82291,
		56672,
		79881,
		87753,
		99852
	],
	"./component/History/HistorySales": [
		82305,
		9,
		77425,
		54590,
		846,
		26989,
		17867,
		60163,
		82305
	],
	"./component/History/HistorySales.jsx": [
		82305,
		9,
		77425,
		54590,
		846,
		26989,
		17867,
		60163,
		82305
	],
	"./component/Invoice/AddPayment": [
		2675,
		9,
		97914,
		361,
		82146,
		2675
	],
	"./component/Invoice/AddPayment.jsx": [
		2675,
		9,
		97914,
		361,
		82146,
		2675
	],
	"./component/Invoice/CloverReceiptPrint": [
		29532,
		9,
		85867,
		29532
	],
	"./component/Invoice/CloverReceiptPrint.jsx": [
		29532,
		9,
		85867,
		29532
	],
	"./component/Invoice/EditInvoice/EditInvoiceAddDiscountAfterTax": [
		30112,
		9,
		77425,
		97914,
		30112
	],
	"./component/Invoice/EditInvoice/EditInvoiceAddDiscountAfterTax.jsx": [
		30112,
		9,
		77425,
		97914,
		30112
	],
	"./component/Invoice/EditInvoice/EditInvoiceAddItemToSale": [
		40127,
		9,
		85867,
		40127
	],
	"./component/Invoice/EditInvoice/EditInvoiceAddItemToSale.jsx": [
		40127,
		9,
		85867,
		40127
	],
	"./component/Invoice/EditInvoice/EditInvoiceAddProductToSale": [
		1085,
		9,
		1085
	],
	"./component/Invoice/EditInvoice/EditInvoiceAddProductToSale.jsx": [
		1085,
		9,
		1085
	],
	"./component/Invoice/EditInvoice/EditInvoiceAddTipModal": [
		57702,
		9,
		77425,
		97914,
		57702
	],
	"./component/Invoice/EditInvoice/EditInvoiceAddTipModal.jsx": [
		57702,
		9,
		77425,
		97914,
		57702
	],
	"./component/Invoice/EditInvoice/EditInvoiceBalanceDetail": [
		79038,
		9,
		77425,
		97914,
		79038
	],
	"./component/Invoice/EditInvoice/EditInvoiceBalanceDetail.jsx": [
		79038,
		9,
		77425,
		97914,
		79038
	],
	"./component/Invoice/EditInvoice/EditInvoiceCloverPayment": [
		30634,
		9,
		30634
	],
	"./component/Invoice/EditInvoice/EditInvoiceCloverPayment.jsx": [
		30634,
		9,
		30634
	],
	"./component/Invoice/EditInvoice/EditInvoiceContainer": [
		48232,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		48618,
		82146,
		51215,
		79038,
		48232
	],
	"./component/Invoice/EditInvoice/EditInvoiceContainer.jsx": [
		48232,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		48618,
		82146,
		51215,
		79038,
		48232
	],
	"./component/Invoice/EditInvoice/EditInvoicePaymentColumn": [
		22845,
		9,
		97914,
		85867,
		361,
		42104,
		48618,
		82146,
		51215,
		22845
	],
	"./component/Invoice/EditInvoice/EditInvoicePaymentColumn.jsx": [
		22845,
		9,
		97914,
		85867,
		361,
		42104,
		48618,
		82146,
		51215,
		22845
	],
	"./component/Invoice/EditInvoice/EditInvoiceSaleForm": [
		43154,
		9,
		77425,
		97914,
		43154
	],
	"./component/Invoice/EditInvoice/EditInvoiceSaleForm.jsx": [
		43154,
		9,
		77425,
		97914,
		43154
	],
	"./component/Invoice/InvoiceContainer": [
		69864,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		9540,
		361,
		42104,
		71443,
		18630,
		90115,
		82146,
		51215,
		35467,
		74851,
		21753,
		17288
	],
	"./component/Invoice/InvoiceContainer.jsx": [
		69864,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		9540,
		361,
		42104,
		71443,
		18630,
		90115,
		82146,
		51215,
		35467,
		74851,
		21753,
		17288
	],
	"./component/Invoice/InvoiceGiftcardsEmailsForm": [
		77171,
		9,
		77171
	],
	"./component/Invoice/InvoiceGiftcardsEmailsForm.jsx": [
		77171,
		9,
		77171
	],
	"./component/Invoice/InvoiceGiftcardsEmailsModal": [
		11494,
		9,
		11494
	],
	"./component/Invoice/InvoiceGiftcardsEmailsModal.jsx": [
		11494,
		9,
		11494
	],
	"./component/Invoice/InvoicePaper": [
		27595,
		9,
		27595
	],
	"./component/Invoice/InvoicePaper.jsx": [
		27595,
		9,
		27595
	],
	"./component/Invoice/InvoicePaymentColumn": [
		66685,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		9540,
		361,
		42104,
		71443,
		18630,
		90115,
		82146,
		51215,
		35467,
		74851,
		21753,
		71996
	],
	"./component/Invoice/InvoicePaymentColumn.jsx": [
		66685,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		9540,
		361,
		42104,
		71443,
		18630,
		90115,
		82146,
		51215,
		35467,
		74851,
		21753,
		71996
	],
	"./component/Invoice/InvoiceStatus": [
		89131,
		9,
		89131
	],
	"./component/Invoice/InvoiceStatus.jsx": [
		89131,
		9,
		89131
	],
	"./component/Invoice/InvoiceStatusColumn": [
		21753,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		90115,
		35467,
		21753,
		57587
	],
	"./component/Invoice/InvoiceStatusColumn.jsx": [
		21753,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		90115,
		35467,
		21753,
		57587
	],
	"./component/Invoice/RefundPaymentsModal": [
		83085,
		9,
		5466
	],
	"./component/Invoice/RefundPaymentsModal.jsx": [
		83085,
		9,
		5466
	],
	"./component/MetaSocialMedia/CreateSocialPostModal": [
		23101,
		9,
		57692,
		26851,
		23101
	],
	"./component/MetaSocialMedia/CreateSocialPostModal.jsx": [
		23101,
		9,
		57692,
		26851,
		23101
	],
	"./component/MetaSocialMedia/MetaCalendar": [
		39978,
		9,
		77425,
		87369,
		47393,
		79638,
		11736
	],
	"./component/MetaSocialMedia/MetaCalendar.jsx": [
		39978,
		9,
		77425,
		87369,
		47393,
		79638,
		11736
	],
	"./component/MetaSocialMedia/MetaLogIn": [
		32774,
		9,
		32774
	],
	"./component/MetaSocialMedia/MetaLogIn.jsx": [
		32774,
		9,
		32774
	],
	"./component/MetaSocialMedia/MetaPostDetail": [
		91245,
		9,
		91245
	],
	"./component/MetaSocialMedia/MetaPostDetail.jsx": [
		91245,
		9,
		91245
	],
	"./component/MetaSocialMedia/MetaPostHistory": [
		26080,
		9,
		26080
	],
	"./component/MetaSocialMedia/MetaPostHistory.jsx": [
		26080,
		9,
		26080
	],
	"./component/MetaSocialMedia/MetaPosts": [
		64747,
		9,
		57692,
		26851,
		69938,
		98213,
		47338,
		64747
	],
	"./component/MetaSocialMedia/MetaPosts.jsx": [
		64747,
		9,
		57692,
		26851,
		69938,
		98213,
		47338,
		64747
	],
	"./component/MetaSocialMedia/MetaSocialMediaDetail": [
		27114,
		9,
		77425,
		87369,
		47393,
		57692,
		26851,
		69938,
		79638,
		98213,
		3462,
		47338,
		27114
	],
	"./component/MetaSocialMedia/MetaSocialMediaDetail.jsx": [
		27114,
		9,
		77425,
		87369,
		47393,
		57692,
		26851,
		69938,
		79638,
		98213,
		3462,
		47338,
		27114
	],
	"./component/MetaSocialMedia/MetaSocialMediaRequest": [
		43805,
		9,
		66186
	],
	"./component/MetaSocialMedia/MetaSocialMediaRequest.jsx": [
		43805,
		9,
		66186
	],
	"./component/MetaSocialMedia/SocialPostCard": [
		47338,
		9,
		69938,
		98213,
		47338
	],
	"./component/MetaSocialMedia/SocialPostCard.jsx": [
		47338,
		9,
		69938,
		98213,
		47338
	],
	"./component/Report/AppointmentGraphReport": [
		53798,
		9,
		26989,
		17867,
		82291,
		53798
	],
	"./component/Report/AppointmentGraphReport.jsx": [
		53798,
		9,
		26989,
		17867,
		82291,
		53798
	],
	"./component/Report/Billing/BillingContainer": [
		2071,
		9,
		77425,
		59221,
		54590,
		93141,
		20691,
		74030,
		2071
	],
	"./component/Report/Billing/BillingContainer.jsx": [
		2071,
		9,
		77425,
		59221,
		54590,
		93141,
		20691,
		74030,
		2071
	],
	"./component/Report/Billing/BillingDetailsColumn": [
		35074,
		9,
		77425,
		59221,
		54590,
		93141,
		74030,
		35074
	],
	"./component/Report/Billing/BillingDetailsColumn.jsx": [
		35074,
		9,
		77425,
		59221,
		54590,
		93141,
		74030,
		35074
	],
	"./component/Report/Billing/BillingHistoryColumn": [
		18240,
		9,
		18240
	],
	"./component/Report/Billing/BillingHistoryColumn.jsx": [
		18240,
		9,
		18240
	],
	"./component/Report/Billing/CreditCardForm": [
		44686,
		9,
		44686
	],
	"./component/Report/Billing/CreditCardForm.jsx": [
		44686,
		9,
		44686
	],
	"./component/Report/Billing/UpdatePaymentMethodModal": [
		71442,
		9,
		77425,
		20691,
		71442
	],
	"./component/Report/Billing/UpdatePaymentMethodModal.jsx": [
		71442,
		9,
		77425,
		20691,
		71442
	],
	"./component/Report/Billing/VoidChequeCaForm": [
		81304,
		9,
		81304
	],
	"./component/Report/Billing/VoidChequeCaForm.jsx": [
		81304,
		9,
		81304
	],
	"./component/Report/Billing/VoidChequeUsForm": [
		81808,
		9,
		81808
	],
	"./component/Report/Billing/VoidChequeUsForm.jsx": [
		81808,
		9,
		81808
	],
	"./component/Report/Billing/visa-mastercard-logos.jpg": [
		20068,
		1,
		20068
	],
	"./component/Report/ClientsStats/ClientsStatsByLastVisit": [
		1298,
		9,
		26989,
		17867,
		60163,
		1298
	],
	"./component/Report/ClientsStats/ClientsStatsByLastVisit.jsx": [
		1298,
		9,
		26989,
		17867,
		60163,
		1298
	],
	"./component/Report/ClientsStats/ClientsStatsByType": [
		14359,
		9,
		26989,
		17867,
		60163,
		14359
	],
	"./component/Report/ClientsStats/ClientsStatsByType.jsx": [
		14359,
		9,
		26989,
		17867,
		60163,
		14359
	],
	"./component/Report/ClientsStats/NewClientsStatsByMonth": [
		19275,
		9,
		26989,
		17867,
		82291,
		19275
	],
	"./component/Report/ClientsStats/NewClientsStatsByMonth.jsx": [
		19275,
		9,
		26989,
		17867,
		82291,
		19275
	],
	"./component/Report/MonthlyBillingReport": [
		93171,
		9,
		93141,
		93171
	],
	"./component/Report/MonthlyBillingReport.jsx": [
		93171,
		9,
		93141,
		93171
	],
	"./component/Report/SaleGraphReport": [
		47188,
		9,
		26989,
		17867,
		82291,
		47188
	],
	"./component/Report/SaleGraphReport.jsx": [
		47188,
		9,
		26989,
		17867,
		82291,
		47188
	],
	"./component/Report/SaleStatisticReport": [
		94306,
		9,
		94306
	],
	"./component/Report/SaleStatisticReport.jsx": [
		94306,
		9,
		94306
	],
	"./component/Settings/AiReceptionist/AiOnlineSchedule/AiHourForm": [
		22965,
		9,
		22965
	],
	"./component/Settings/AiReceptionist/AiOnlineSchedule/AiHourForm.jsx": [
		22965,
		9,
		22965
	],
	"./component/Settings/AiReceptionist/AiOnlineSchedule/AiOnlineHour": [
		1186,
		9,
		77425,
		1186
	],
	"./component/Settings/AiReceptionist/AiOnlineSchedule/AiOnlineHour.jsx": [
		1186,
		9,
		77425,
		1186
	],
	"./component/Settings/AiReceptionist/AiOnlineSchedule/AiOnlineSchedule": [
		94391,
		9,
		77425,
		94391
	],
	"./component/Settings/AiReceptionist/AiOnlineSchedule/AiOnlineSchedule.jsx": [
		94391,
		9,
		77425,
		94391
	],
	"./component/Settings/AiReceptionist/AiOnlineSchedule/AiTransferHour": [
		18202,
		9,
		77425,
		18202
	],
	"./component/Settings/AiReceptionist/AiOnlineSchedule/AiTransferHour.jsx": [
		18202,
		9,
		77425,
		18202
	],
	"./component/Settings/AiReceptionist/AiPolicyAlert": [
		90758,
		9,
		90758
	],
	"./component/Settings/AiReceptionist/AiPolicyAlert.jsx": [
		90758,
		9,
		90758
	],
	"./component/Settings/AiReceptionist/AiReceptionistGeneral": [
		79377,
		9,
		85867,
		59221,
		79377,
		23374
	],
	"./component/Settings/AiReceptionist/AiReceptionistGeneral.jsx": [
		79377,
		9,
		85867,
		59221,
		79377,
		23374
	],
	"./component/Settings/AiReceptionist/ForwardingInstruction": [
		17355,
		9,
		17355
	],
	"./component/Settings/AiReceptionist/ForwardingInstruction.jsx": [
		17355,
		9,
		17355
	],
	"./component/Settings/AiReceptionist/RulesForAnswering": [
		32480,
		9,
		26989,
		65701,
		22947,
		32480
	],
	"./component/Settings/AiReceptionist/RulesForAnswering.jsx": [
		32480,
		9,
		26989,
		65701,
		22947,
		32480
	],
	"./component/Settings/AiReceptionist/RulesForm": [
		92519,
		9,
		26989,
		65701,
		92519
	],
	"./component/Settings/AiReceptionist/RulesForm.jsx": [
		92519,
		9,
		26989,
		65701,
		92519
	],
	"./component/Settings/Appointments/AppointmentConfirmationForm": [
		9047,
		9,
		59221,
		9047,
		47890
	],
	"./component/Settings/Appointments/AppointmentConfirmationForm.jsx": [
		9047,
		9,
		59221,
		9047,
		47890
	],
	"./component/Settings/Appointments/BusinessLinks": [
		17448,
		9,
		93141,
		91614,
		17448
	],
	"./component/Settings/Appointments/BusinessLinks.jsx": [
		17448,
		9,
		93141,
		91614,
		17448
	],
	"./component/Settings/ClientType/ClientTypeCategory": [
		1285,
		9,
		97914,
		1285
	],
	"./component/Settings/ClientType/ClientTypeCategory.jsx": [
		1285,
		9,
		97914,
		1285
	],
	"./component/Settings/ClientType/ClientTypePoint": [
		92115,
		9,
		97914,
		92115
	],
	"./component/Settings/ClientType/ClientTypePoint.jsx": [
		92115,
		9,
		97914,
		92115
	],
	"./component/Settings/Clover/NewCloverTerminals": [
		37158,
		9,
		77425,
		97914,
		54590,
		37158
	],
	"./component/Settings/Clover/NewCloverTerminals.jsx": [
		37158,
		9,
		77425,
		97914,
		54590,
		37158
	],
	"./component/Settings/Clover/PayModal": [
		79505,
		9,
		361,
		82146,
		79505
	],
	"./component/Settings/Clover/PayModal.js": [
		79505,
		9,
		361,
		82146,
		79505
	],
	"./component/Settings/Deposit/DepositClients": [
		53125,
		9,
		77425,
		59221,
		54590,
		53125
	],
	"./component/Settings/Deposit/DepositClients.jsx": [
		53125,
		9,
		77425,
		59221,
		54590,
		53125
	],
	"./component/Settings/Deposit/DepositServices": [
		17009,
		9,
		77425,
		54590,
		17009
	],
	"./component/Settings/Deposit/DepositServices.jsx": [
		17009,
		9,
		77425,
		54590,
		17009
	],
	"./component/Settings/Deposit/GeneralSettings": [
		85308,
		9,
		97914,
		85308
	],
	"./component/Settings/Deposit/GeneralSettings.jsx": [
		85308,
		9,
		97914,
		85308
	],
	"./component/Settings/Deposit/SpecialSettings": [
		5073,
		9,
		77425,
		59221,
		54590,
		5073
	],
	"./component/Settings/Deposit/SpecialSettings.jsx": [
		5073,
		9,
		77425,
		59221,
		54590,
		5073
	],
	"./component/Settings/Flyers/FlyersItem": [
		4848,
		9,
		87369,
		47393,
		20300,
		92902
	],
	"./component/Settings/Flyers/FlyersItem.jsx": [
		4848,
		9,
		87369,
		47393,
		20300,
		92902
	],
	"./component/Settings/GiftCard/GiftCardDetails": [
		77933,
		9,
		77425,
		97914,
		54590,
		87369,
		6761,
		77933
	],
	"./component/Settings/GiftCard/GiftCardDetails.jsx": [
		77933,
		9,
		77425,
		97914,
		54590,
		87369,
		6761,
		77933
	],
	"./component/Settings/GiftCard/GiftCardFilter": [
		58641,
		9,
		58641
	],
	"./component/Settings/GiftCard/GiftCardFilter.jsx": [
		58641,
		9,
		58641
	],
	"./component/Settings/GiftCard/GiftCardForm": [
		35969,
		9,
		77425,
		97914,
		87369,
		35969
	],
	"./component/Settings/GiftCard/GiftCardForm.jsx": [
		35969,
		9,
		77425,
		97914,
		87369,
		35969
	],
	"./component/Settings/GiftCard/GiftCardHistory": [
		94703,
		9,
		77425,
		54590,
		94703
	],
	"./component/Settings/GiftCard/GiftCardHistory.jsx": [
		94703,
		9,
		77425,
		54590,
		94703
	],
	"./component/Settings/GiftCard/GiftCardList": [
		82851,
		9,
		82851
	],
	"./component/Settings/GiftCard/GiftCardList.jsx": [
		82851,
		9,
		82851
	],
	"./component/Settings/GoogleProfile/GoogleAccounts/GoogleAccounts": [
		80412,
		9,
		77425,
		54590,
		80412
	],
	"./component/Settings/GoogleProfile/GoogleAccounts/GoogleAccounts.jsx": [
		80412,
		9,
		77425,
		54590,
		80412
	],
	"./component/Settings/GoogleProfile/GoogleGeneralInfo/GoogleAddressAutoComplete": [
		61956,
		9,
		87086,
		61956
	],
	"./component/Settings/GoogleProfile/GoogleGeneralInfo/GoogleAddressAutoComplete.jsx": [
		61956,
		9,
		87086,
		61956
	],
	"./component/Settings/GoogleProfile/GoogleGeneralInfo/GoogleGeneralInfo": [
		21959,
		9,
		87086,
		44340
	],
	"./component/Settings/GoogleProfile/GoogleGeneralInfo/GoogleGeneralInfo.jsx": [
		21959,
		9,
		87086,
		44340
	],
	"./component/Settings/GoogleProfile/GoogleHour/GoogleHour": [
		75704,
		9,
		75704
	],
	"./component/Settings/GoogleProfile/GoogleHour/GoogleHour.jsx": [
		75704,
		9,
		75704
	],
	"./component/Settings/GoogleProfile/GoogleHour/GoogleHourSelect": [
		87512,
		9,
		87512
	],
	"./component/Settings/GoogleProfile/GoogleHour/GoogleHourSelect.jsx": [
		87512,
		9,
		87512
	],
	"./component/Settings/GoogleProfile/GoogleReviews/GoogleResponseModal": [
		32515,
		9,
		79881,
		32515
	],
	"./component/Settings/GoogleProfile/GoogleReviews/GoogleResponseModal.jsx": [
		32515,
		9,
		79881,
		32515
	],
	"./component/Settings/GoogleProfile/GoogleReviews/GoogleReviews": [
		83240,
		9,
		47393,
		32769,
		79881,
		83240,
		95508
	],
	"./component/Settings/GoogleProfile/GoogleReviews/GoogleReviews.jsx": [
		83240,
		9,
		47393,
		32769,
		79881,
		83240,
		95508
	],
	"./component/Settings/Holidays/HolidaysApppointments": [
		99589,
		9,
		99589
	],
	"./component/Settings/Holidays/HolidaysApppointments.jsx": [
		99589,
		9,
		99589
	],
	"./component/Settings/Holidays/HolidaysForm": [
		63567,
		9,
		77425,
		87369,
		63567,
		65708
	],
	"./component/Settings/Holidays/HolidaysForm.jsx": [
		63567,
		9,
		77425,
		87369,
		63567,
		65708
	],
	"./component/Settings/Holidays/HolidaysList": [
		58065,
		9,
		58065
	],
	"./component/Settings/Holidays/HolidaysList.jsx": [
		58065,
		9,
		58065
	],
	"./component/Settings/Hours/HourForm": [
		97930,
		9,
		97930
	],
	"./component/Settings/Hours/HourForm.jsx": [
		97930,
		9,
		97930
	],
	"./component/Settings/Hours/HoursSelect": [
		5585,
		9,
		5585
	],
	"./component/Settings/Hours/HoursSelect.jsx": [
		5585,
		9,
		5585
	],
	"./component/Settings/Hours/StaffHours": [
		13,
		9,
		13
	],
	"./component/Settings/Hours/StaffHours.jsx": [
		13,
		9,
		13
	],
	"./component/Settings/Loyalty/CheckInSettings": [
		73033,
		9,
		85867,
		73033
	],
	"./component/Settings/Loyalty/CheckInSettings.jsx": [
		73033,
		9,
		85867,
		73033
	],
	"./component/Settings/Loyalty/LoyaltyConfig": [
		60271,
		9,
		77425,
		60271
	],
	"./component/Settings/Loyalty/LoyaltyConfig.jsx": [
		60271,
		9,
		77425,
		60271
	],
	"./component/Settings/Loyalty/LoyaltyFlyers": [
		12620,
		9,
		47393,
		57692,
		26851,
		49578
	],
	"./component/Settings/Loyalty/LoyaltyFlyers.jsx": [
		12620,
		9,
		47393,
		57692,
		26851,
		49578
	],
	"./component/Settings/Loyalty/LoyaltyForm": [
		72119,
		9,
		77425,
		97914,
		72119
	],
	"./component/Settings/Loyalty/LoyaltyForm.jsx": [
		72119,
		9,
		77425,
		97914,
		72119
	],
	"./component/Settings/Menu/CategoryColumn": [
		82250,
		9,
		20300,
		82250
	],
	"./component/Settings/Menu/CategoryColumn.jsx": [
		82250,
		9,
		20300,
		82250
	],
	"./component/Settings/Menu/CategoryForm": [
		41714,
		9,
		41714
	],
	"./component/Settings/Menu/CategoryForm.jsx": [
		41714,
		9,
		41714
	],
	"./component/Settings/Menu/CategoryList": [
		51252,
		9,
		20300,
		51252
	],
	"./component/Settings/Menu/CategoryList.jsx": [
		51252,
		9,
		20300,
		51252
	],
	"./component/Settings/Menu/CategoryModal": [
		71157,
		9,
		71157
	],
	"./component/Settings/Menu/CategoryModal.jsx": [
		71157,
		9,
		71157
	],
	"./component/Settings/Menu/ComboDetailContainer": [
		65126,
		9,
		97914,
		85867,
		89456,
		40689,
		52545,
		84480
	],
	"./component/Settings/Menu/ComboDetailContainer.jsx": [
		65126,
		9,
		97914,
		85867,
		89456,
		40689,
		52545,
		84480
	],
	"./component/Settings/Menu/ComboDetailForm": [
		52545,
		9,
		97914,
		85867,
		52545,
		9391
	],
	"./component/Settings/Menu/ComboDetailForm.jsx": [
		52545,
		9,
		97914,
		85867,
		52545,
		9391
	],
	"./component/Settings/Menu/ComboResources": [
		18129,
		9,
		97914,
		89456,
		40689,
		18129
	],
	"./component/Settings/Menu/ComboResources.jsx": [
		18129,
		9,
		97914,
		89456,
		40689,
		18129
	],
	"./component/Settings/Menu/ComboServiceForm": [
		573,
		9,
		97914,
		573
	],
	"./component/Settings/Menu/ComboServiceForm.jsx": [
		573,
		9,
		97914,
		573
	],
	"./component/Settings/Menu/MenuContainer": [
		28816,
		9,
		85867,
		20300,
		41871,
		79358
	],
	"./component/Settings/Menu/MenuContainer.jsx": [
		28816,
		9,
		85867,
		20300,
		41871,
		79358
	],
	"./component/Settings/Menu/ResourcesList": [
		40689,
		9,
		97914,
		89456,
		40689
	],
	"./component/Settings/Menu/ResourcesList.jsx": [
		40689,
		9,
		97914,
		89456,
		40689
	],
	"./component/Settings/Menu/ServiceAddOnsList": [
		54754,
		9,
		85867,
		54754
	],
	"./component/Settings/Menu/ServiceAddOnsList.jsx": [
		54754,
		9,
		85867,
		54754
	],
	"./component/Settings/Menu/ServiceColumn": [
		34177,
		9,
		85867,
		20300,
		41871,
		46447
	],
	"./component/Settings/Menu/ServiceColumn.jsx": [
		34177,
		9,
		85867,
		20300,
		41871,
		46447
	],
	"./component/Settings/Menu/ServiceDetailContainer": [
		68863,
		9,
		97914,
		85867,
		89456,
		40689,
		29362,
		71753
	],
	"./component/Settings/Menu/ServiceDetailContainer.jsx": [
		68863,
		9,
		97914,
		85867,
		89456,
		40689,
		29362,
		71753
	],
	"./component/Settings/Menu/ServiceDetailForm": [
		29362,
		9,
		97914,
		85867,
		29362,
		31772
	],
	"./component/Settings/Menu/ServiceDetailForm.jsx": [
		29362,
		9,
		97914,
		85867,
		29362,
		31772
	],
	"./component/Settings/Menu/ServiceList": [
		41871,
		9,
		85867,
		20300,
		41871,
		40527
	],
	"./component/Settings/Menu/ServiceList.jsx": [
		41871,
		9,
		85867,
		20300,
		41871,
		40527
	],
	"./component/Settings/Menu/ServiceResources": [
		56084,
		9,
		97914,
		89456,
		40689,
		56084
	],
	"./component/Settings/Menu/ServiceResources.jsx": [
		56084,
		9,
		97914,
		89456,
		40689,
		56084
	],
	"./component/Settings/Menu/ServiceStaffDuration": [
		34809,
		9,
		85867,
		34809
	],
	"./component/Settings/Menu/ServiceStaffDuration.jsx": [
		34809,
		9,
		85867,
		34809
	],
	"./component/Settings/Menu/ServiceStaffDurationForm": [
		87359,
		9,
		85867,
		87359
	],
	"./component/Settings/Menu/ServiceStaffDurationForm.jsx": [
		87359,
		9,
		85867,
		87359
	],
	"./component/Settings/Menu/ServiceStaffs": [
		49186,
		9,
		49186
	],
	"./component/Settings/Menu/ServiceStaffs.jsx": [
		49186,
		9,
		49186
	],
	"./component/Settings/Menu/ServiceTaxes": [
		19164,
		9,
		19164
	],
	"./component/Settings/Menu/ServiceTaxes.jsx": [
		19164,
		9,
		19164
	],
	"./component/Settings/NewGiftCard/GiftCardForm": [
		68965,
		9,
		77425,
		97914,
		54590,
		68965
	],
	"./component/Settings/NewGiftCard/GiftCardForm.jsx": [
		68965,
		9,
		77425,
		97914,
		54590,
		68965
	],
	"./component/Settings/PaymentIntegration/TerminalOrderModal": [
		82804,
		9,
		47393,
		69938,
		68594
	],
	"./component/Settings/PaymentIntegration/TerminalOrderModal.jsx": [
		82804,
		9,
		47393,
		69938,
		68594
	],
	"./component/Settings/Poynt/PoyntTerminals": [
		84926,
		9,
		77425,
		54590,
		84926
	],
	"./component/Settings/Poynt/PoyntTerminals.jsx": [
		84926,
		9,
		77425,
		54590,
		84926
	],
	"./component/Settings/Products/ProductCaregoryColumn": [
		40962,
		9,
		85867,
		20300,
		32172,
		40962
	],
	"./component/Settings/Products/ProductCaregoryColumn.jsx": [
		40962,
		9,
		85867,
		20300,
		32172,
		40962
	],
	"./component/Settings/Products/ProductCategoryForm": [
		32172,
		9,
		85867,
		32172
	],
	"./component/Settings/Products/ProductCategoryForm.jsx": [
		32172,
		9,
		85867,
		32172
	],
	"./component/Settings/Products/ProductCategoryList": [
		3078,
		9,
		20300,
		3078
	],
	"./component/Settings/Products/ProductCategoryList.jsx": [
		3078,
		9,
		20300,
		3078
	],
	"./component/Settings/Products/ProductForm": [
		36264,
		9,
		97914,
		85867,
		59221,
		36264
	],
	"./component/Settings/Products/ProductForm.jsx": [
		36264,
		9,
		97914,
		85867,
		59221,
		36264
	],
	"./component/Settings/Products/ProductList": [
		50986,
		9,
		20300,
		50986
	],
	"./component/Settings/Products/ProductList.jsx": [
		50986,
		9,
		20300,
		50986
	],
	"./component/Settings/Products/ProductManage/ProductHistory": [
		19323,
		9,
		19323
	],
	"./component/Settings/Products/ProductManage/ProductHistory.jsx": [
		19323,
		9,
		19323
	],
	"./component/Settings/Products/ProductManage/ProductStock": [
		22141,
		9,
		97914,
		22141
	],
	"./component/Settings/Products/ProductManage/ProductStock.jsx": [
		22141,
		9,
		97914,
		22141
	],
	"./component/Settings/Products/ProductManage/ProductSupplierInfo": [
		44499,
		9,
		59221,
		66880
	],
	"./component/Settings/Products/ProductManage/ProductSupplierInfo.jsx": [
		44499,
		9,
		59221,
		66880
	],
	"./component/Settings/Products/ProductManageModal": [
		62024,
		9,
		97914,
		59221,
		62024
	],
	"./component/Settings/Products/ProductManageModal.jsx": [
		62024,
		9,
		97914,
		59221,
		62024
	],
	"./component/Settings/Promotions/DefaultEmailPromotion/DefaultClientEmailFilter": [
		30882,
		9,
		97914,
		87369,
		30882
	],
	"./component/Settings/Promotions/DefaultEmailPromotion/DefaultClientEmailFilter.jsx": [
		30882,
		9,
		97914,
		87369,
		30882
	],
	"./component/Settings/Promotions/DefaultEmailPromotion/DefaultPromotionEmailPreviewer": [
		13653,
		9,
		97914,
		87369,
		13653,
		89476
	],
	"./component/Settings/Promotions/DefaultEmailPromotion/DefaultPromotionEmailPreviewer.jsx": [
		13653,
		9,
		97914,
		87369,
		13653,
		89476
	],
	"./component/Settings/Promotions/EmailPromotion/ClientEmailFilter": [
		33386,
		9,
		97914,
		87369,
		57692,
		12179,
		33386,
		96524
	],
	"./component/Settings/Promotions/EmailPromotion/ClientEmailFilter.jsx": [
		33386,
		9,
		97914,
		87369,
		57692,
		12179,
		33386,
		96524
	],
	"./component/Settings/Promotions/EmailPromotion/PromotionEmailPreviewer": [
		35485,
		9,
		97914,
		87369,
		9540,
		57692,
		26851,
		12179,
		57332,
		11032,
		33386,
		35485
	],
	"./component/Settings/Promotions/EmailPromotion/PromotionEmailPreviewer.jsx": [
		35485,
		9,
		97914,
		87369,
		9540,
		57692,
		26851,
		12179,
		57332,
		11032,
		33386,
		35485
	],
	"./component/Settings/Promotions/PromotionsAutoSms": [
		7179,
		9,
		7179
	],
	"./component/Settings/Promotions/PromotionsAutoSms.jsx": [
		7179,
		9,
		7179
	],
	"./component/Settings/Promotions/PromotionsAutoSmsDetail": [
		24644,
		9,
		59221,
		24644
	],
	"./component/Settings/Promotions/PromotionsAutoSmsDetail.jsx": [
		24644,
		9,
		59221,
		24644
	],
	"./component/Settings/Promotions/PromotionsClientFilter": [
		516,
		9,
		97914,
		87369,
		57692,
		12179,
		21317,
		516
	],
	"./component/Settings/Promotions/PromotionsClientFilter.jsx": [
		516,
		9,
		97914,
		87369,
		57692,
		12179,
		21317,
		516
	],
	"./component/Settings/Promotions/PromotionsDetails": [
		70457,
		9,
		77425,
		97914,
		85867,
		54590,
		87369,
		57692,
		12179,
		21317,
		70457,
		11578
	],
	"./component/Settings/Promotions/PromotionsDetails.jsx": [
		70457,
		9,
		77425,
		97914,
		85867,
		54590,
		87369,
		57692,
		12179,
		21317,
		70457,
		11578
	],
	"./component/Settings/Promotions/PromotionsForm": [
		54045,
		9,
		77425,
		97914,
		85867,
		87369,
		54045
	],
	"./component/Settings/Promotions/PromotionsForm.jsx": [
		54045,
		9,
		77425,
		97914,
		85867,
		87369,
		54045
	],
	"./component/Settings/Promotions/PromotionsList": [
		43607,
		9,
		43607
	],
	"./component/Settings/Promotions/PromotionsList.jsx": [
		43607,
		9,
		43607
	],
	"./component/Settings/Promotions/PromotionsServices": [
		15783,
		9,
		85867,
		15783
	],
	"./component/Settings/Promotions/PromotionsServices.jsx": [
		15783,
		9,
		85867,
		15783
	],
	"./component/Settings/Promotions/SmsPromotionRecords": [
		35409,
		9,
		77425,
		54590,
		35409
	],
	"./component/Settings/Promotions/SmsPromotionRecords.jsx": [
		35409,
		9,
		77425,
		54590,
		35409
	],
	"./component/Settings/Sms/SmsSettingsForm": [
		78896,
		9,
		78896
	],
	"./component/Settings/Sms/SmsSettingsForm.jsx": [
		78896,
		9,
		78896
	],
	"./component/Settings/Staffs/AssignStaffOptions": [
		79159,
		9,
		77425,
		97914,
		79159
	],
	"./component/Settings/Staffs/AssignStaffOptions.jsx": [
		79159,
		9,
		77425,
		97914,
		79159
	],
	"./component/Settings/Staffs/ServiceStaffSpecialDurationForm": [
		71762,
		9,
		71762
	],
	"./component/Settings/Staffs/ServiceStaffSpecialDurationForm.jsx": [
		71762,
		9,
		71762
	],
	"./component/Settings/Staffs/ShiftForm": [
		69820,
		9,
		69820
	],
	"./component/Settings/Staffs/ShiftForm.jsx": [
		69820,
		9,
		69820
	],
	"./component/Settings/Staffs/StaffAccounts/StaffAccountDetails": [
		60398,
		9,
		77425,
		91614,
		60398
	],
	"./component/Settings/Staffs/StaffAccounts/StaffAccountDetails.jsx": [
		60398,
		9,
		77425,
		91614,
		60398
	],
	"./component/Settings/Staffs/StaffAccounts/StaffAccountList": [
		35370,
		9,
		35370
	],
	"./component/Settings/Staffs/StaffAccounts/StaffAccountList.jsx": [
		35370,
		9,
		35370
	],
	"./component/Settings/Staffs/StaffContactForm": [
		3172,
		9,
		97914,
		85867,
		9540,
		57692,
		26851,
		61580,
		3172,
		48218
	],
	"./component/Settings/Staffs/StaffContactForm.jsx": [
		3172,
		9,
		97914,
		85867,
		9540,
		57692,
		26851,
		61580,
		3172,
		48218
	],
	"./component/Settings/Staffs/StaffDetailTabs": [
		37043,
		9,
		97914,
		85867,
		9540,
		57692,
		26851,
		61580,
		15080,
		3172,
		37043
	],
	"./component/Settings/Staffs/StaffDetailTabs.jsx": [
		37043,
		9,
		97914,
		85867,
		9540,
		57692,
		26851,
		61580,
		15080,
		3172,
		37043
	],
	"./component/Settings/Staffs/StaffHours": [
		21783,
		9,
		21783
	],
	"./component/Settings/Staffs/StaffHours.jsx": [
		21783,
		9,
		21783
	],
	"./component/Settings/Staffs/StaffImage": [
		92893,
		9,
		9540,
		57692,
		26851,
		61580,
		92893
	],
	"./component/Settings/Staffs/StaffImage.jsx": [
		92893,
		9,
		9540,
		57692,
		26851,
		61580,
		92893
	],
	"./component/Settings/Staffs/StaffListDragDrop": [
		95797,
		9,
		20300,
		95797
	],
	"./component/Settings/Staffs/StaffListDragDrop.jsx": [
		95797,
		9,
		20300,
		95797
	],
	"./component/Settings/Staffs/StaffServiceSpecialDuration": [
		37394,
		9,
		85867,
		37394
	],
	"./component/Settings/Staffs/StaffServiceSpecialDuration.jsx": [
		37394,
		9,
		85867,
		37394
	],
	"./component/Settings/Staffs/StaffServices": [
		20372,
		9,
		20372
	],
	"./component/Settings/Staffs/StaffServices.jsx": [
		20372,
		9,
		20372
	],
	"./component/Settings/Taxes/TaxForm": [
		80207,
		9,
		97914,
		80207
	],
	"./component/Settings/Taxes/TaxForm.jsx": [
		80207,
		9,
		97914,
		80207
	],
	"./component/Settings/Taxes/TaxList": [
		25681,
		9,
		25681
	],
	"./component/Settings/Taxes/TaxList.jsx": [
		25681,
		9,
		25681
	],
	"./component/TimeClock/AddTimeClock": [
		16528,
		9,
		87369,
		16528
	],
	"./component/TimeClock/AddTimeClock.jsx": [
		16528,
		9,
		87369,
		16528
	],
	"./component/TimeClock/TimeClockContainer": [
		14328,
		9,
		85867,
		87369,
		22961,
		14328
	],
	"./component/TimeClock/TimeClockContainer.jsx": [
		14328,
		9,
		85867,
		87369,
		22961,
		14328
	],
	"./component/TimeClock/TimeClockHistory": [
		22961,
		9,
		85867,
		87369,
		22961
	],
	"./component/TimeClock/TimeClockHistory.jsx": [
		22961,
		9,
		85867,
		87369,
		22961
	],
	"./component/TimeClock/TimeClockStaff": [
		83879,
		9,
		87369,
		83879
	],
	"./component/TimeClock/TimeClockStaff.jsx": [
		83879,
		9,
		87369,
		83879
	],
	"./component/common/AdminPasscodeModal/AdminPasscodeModal": [
		61987,
		9,
		61987
	],
	"./component/common/AdminPasscodeModal/AdminPasscodeModal.jsx": [
		61987,
		9,
		61987
	],
	"./component/common/CardPopover/CardPopover": [
		8757,
		9,
		8757
	],
	"./component/common/CardPopover/CardPopover.jsx": [
		8757,
		9,
		8757
	],
	"./component/common/ClientPhoneNumber/ClientPhoneNumber": [
		75921,
		9,
		75921
	],
	"./component/common/ClientPhoneNumber/ClientPhoneNumber.jsx": [
		75921,
		9,
		75921
	],
	"./component/common/ClientTypeIcon/ClientTypeIcon": [
		42255,
		9,
		42255
	],
	"./component/common/ClientTypeIcon/ClientTypeIcon.jsx": [
		42255,
		9,
		42255
	],
	"./component/common/Icons/Icons": [
		65777,
		9,
		88158
	],
	"./component/common/Icons/Icons.jsx": [
		65777,
		9,
		88158
	],
	"./component/common/Loading/Loading": [
		34673,
		9
	],
	"./component/common/Loading/Loading.css": [
		89840,
		9
	],
	"./component/common/Loading/Loading.jsx": [
		34673,
		9
	],
	"./component/common/MessageError/MessageError": [
		96301,
		9,
		96301
	],
	"./component/common/MessageError/MessageError.jsx": [
		96301,
		9,
		96301
	],
	"./component/common/MessageError/NewMessageError": [
		62909,
		9
	],
	"./component/common/MessageError/NewMessageError.jsx": [
		62909,
		9
	],
	"./component/common/ModalFullPage/ModalFullPage": [
		50853,
		9,
		50853
	],
	"./component/common/ModalFullPage/ModalFullPage.jsx": [
		50853,
		9,
		50853
	],
	"./component/common/MonthDate/MonthDate": [
		83661,
		9,
		83661
	],
	"./component/common/MonthDate/MonthDate.jsx": [
		83661,
		9,
		83661
	],
	"./component/common/Notification/ActivityNotificationList": [
		49860,
		9
	],
	"./component/common/Notification/ActivityNotificationList.jsx": [
		49860,
		9
	],
	"./component/common/Notification/Notification.css": [
		72844,
		9
	],
	"./component/common/Notification/NotificationDrawer": [
		85670,
		9
	],
	"./component/common/Notification/NotificationDrawer.jsx": [
		85670,
		9
	],
	"./component/common/Notification/SoundIcons": [
		35697,
		9
	],
	"./component/common/Notification/SoundIcons.jsx": [
		35697,
		9
	],
	"./component/common/Notification/SystemNotificationList": [
		22466,
		9
	],
	"./component/common/Notification/SystemNotificationList.jsx": [
		22466,
		9
	],
	"./component/common/useScreenWidth": [
		27771,
		9,
		27771
	],
	"./component/common/useScreenWidth.js": [
		27771,
		9,
		27771
	],
	"./componentMobile/Appointment/AppoimentBlockTime/AppointmentBlockTimeAlert": [
		73941,
		9,
		73941
	],
	"./componentMobile/Appointment/AppoimentBlockTime/AppointmentBlockTimeAlert.jsx": [
		73941,
		9,
		73941
	],
	"./componentMobile/Appointment/AppoimentBlockTime/AppointmentBlockTimeForm": [
		74657,
		9,
		87369,
		74657
	],
	"./componentMobile/Appointment/AppoimentBlockTime/AppointmentBlockTimeForm.jsx": [
		74657,
		9,
		87369,
		74657
	],
	"./componentMobile/Appointment/AppointmentCalendar/AgendaView": [
		98705,
		9,
		77425,
		54590,
		846,
		98705
	],
	"./componentMobile/Appointment/AppointmentCalendar/AgendaView.jsx": [
		98705,
		9,
		77425,
		54590,
		846,
		98705
	],
	"./componentMobile/Appointment/AppointmentCalendar/CurrentTimeIndicator": [
		1897,
		9,
		1897
	],
	"./componentMobile/Appointment/AppointmentCalendar/CurrentTimeIndicator.jsx": [
		1897,
		9,
		1897
	],
	"./componentMobile/Appointment/AppointmentCalendar/Filter/AddNew": [
		93916,
		9,
		93916
	],
	"./componentMobile/Appointment/AppointmentCalendar/Filter/AddNew.jsx": [
		93916,
		9,
		93916
	],
	"./componentMobile/Appointment/AppointmentCalendar/Filter/AgendaFilter": [
		52419,
		9,
		52419
	],
	"./componentMobile/Appointment/AppointmentCalendar/Filter/AgendaFilter.jsx": [
		52419,
		9,
		52419
	],
	"./componentMobile/Appointment/AppointmentCalendar/Filter/DateSelect": [
		15549,
		9,
		87369,
		15549
	],
	"./componentMobile/Appointment/AppointmentCalendar/Filter/DateSelect.jsx": [
		15549,
		9,
		87369,
		15549
	],
	"./componentMobile/Appointment/AppointmentCalendar/Filter/StaffDropdown": [
		47544,
		9,
		47544
	],
	"./componentMobile/Appointment/AppointmentCalendar/Filter/StaffDropdown.jsx": [
		47544,
		9,
		47544
	],
	"./componentMobile/Appointment/AppointmentCalendar/Filter/styles.module.css": [
		82021,
		9,
		4402
	],
	"./componentMobile/Appointment/AppointmentCalendar/StaffCalendarColumn": [
		9546,
		9,
		85867,
		59221,
		846,
		9546
	],
	"./componentMobile/Appointment/AppointmentCalendar/StaffCalendarColumn.jsx": [
		9546,
		9,
		85867,
		59221,
		846,
		9546
	],
	"./componentMobile/Appointment/AppointmentStatus/AppointmentStatus": [
		98749,
		9,
		846,
		98749
	],
	"./componentMobile/Appointment/AppointmentStatus/AppointmentStatus.jsx": [
		98749,
		9,
		846,
		98749
	],
	"./componentMobile/Appointment/AppointmentStatus/AppointmentStatusDropdown": [
		33578,
		9,
		846,
		33578
	],
	"./componentMobile/Appointment/AppointmentStatus/AppointmentStatusDropdown.jsx": [
		33578,
		9,
		846,
		33578
	],
	"./componentMobile/Appointment/AppointmentType": [
		12959,
		9,
		35340
	],
	"./componentMobile/Appointment/AppointmentType.jsx": [
		12959,
		9,
		35340
	],
	"./componentMobile/Appointment/CreateAppointment/ClientColumn/ClientCard": [
		63075,
		9,
		59221,
		70712,
		90115,
		66431
	],
	"./componentMobile/Appointment/CreateAppointment/ClientColumn/ClientCard.jsx": [
		63075,
		9,
		59221,
		70712,
		90115,
		66431
	],
	"./componentMobile/Appointment/CreateAppointment/ClientColumn/ClientQuickSearch": [
		93460,
		9,
		59221,
		70712,
		886
	],
	"./componentMobile/Appointment/CreateAppointment/ClientColumn/ClientQuickSearch.jsx": [
		93460,
		9,
		59221,
		70712,
		886
	],
	"./componentMobile/Appointment/CreateAppointment/ClientColumn/ClientSearchListResult": [
		34018,
		9,
		59221,
		34018
	],
	"./componentMobile/Appointment/CreateAppointment/ClientColumn/ClientSearchListResult.jsx": [
		34018,
		9,
		59221,
		34018
	],
	"./componentMobile/Appointment/CreateAppointment/ClientColumn/DateCard": [
		73962,
		9,
		73962
	],
	"./componentMobile/Appointment/CreateAppointment/ClientColumn/DateCard.jsx": [
		73962,
		9,
		73962
	],
	"./componentMobile/Appointment/CreateAppointment/ConfirmAppointmentModal": [
		23052,
		9,
		23052
	],
	"./componentMobile/Appointment/CreateAppointment/ConfirmAppointmentModal.jsx": [
		23052,
		9,
		23052
	],
	"./componentMobile/Appointment/CreateAppointment/CreateAppointmentContainer": [
		66248,
		9,
		77425,
		85867,
		59221,
		87369,
		70712,
		90115,
		81583,
		66248,
		81701
	],
	"./componentMobile/Appointment/CreateAppointment/CreateAppointmentContainer.jsx": [
		66248,
		9,
		77425,
		85867,
		59221,
		87369,
		70712,
		90115,
		81583,
		66248,
		81701
	],
	"./componentMobile/Appointment/CreateAppointment/DateSelectDropdown": [
		91735,
		9,
		87369,
		91735
	],
	"./componentMobile/Appointment/CreateAppointment/DateSelectDropdown.jsx": [
		91735,
		9,
		87369,
		91735
	],
	"./componentMobile/Appointment/CreateAppointment/DurationSelectDropdown": [
		99271,
		9,
		85867,
		99271
	],
	"./componentMobile/Appointment/CreateAppointment/DurationSelectDropdown.jsx": [
		99271,
		9,
		85867,
		99271
	],
	"./componentMobile/Appointment/CreateAppointment/NewAppointmentAlert": [
		70311,
		9,
		70311
	],
	"./componentMobile/Appointment/CreateAppointment/NewAppointmentAlert.jsx": [
		70311,
		9,
		70311
	],
	"./componentMobile/Appointment/CreateAppointment/NewAppointmentForm": [
		81583,
		9,
		85867,
		81583,
		27817
	],
	"./componentMobile/Appointment/CreateAppointment/NewAppointmentForm.jsx": [
		81583,
		9,
		85867,
		81583,
		27817
	],
	"./componentMobile/Appointment/CreateAppointment/NewSelectServiceModal": [
		91424,
		9,
		91424
	],
	"./componentMobile/Appointment/CreateAppointment/NewSelectServiceModal.jsx": [
		91424,
		9,
		91424
	],
	"./componentMobile/Appointment/CreateAppointment/NewSelectStaffModal": [
		34201,
		9,
		34201
	],
	"./componentMobile/Appointment/CreateAppointment/NewSelectStaffModal.jsx": [
		34201,
		9,
		34201
	],
	"./componentMobile/Appointment/CreateAppointment/SelectServiceModal": [
		14435,
		9,
		36816
	],
	"./componentMobile/Appointment/CreateAppointment/SelectServiceModal.jsx": [
		14435,
		9,
		36816
	],
	"./componentMobile/Appointment/CreateAppointment/StaffNotice": [
		95088,
		9,
		95088
	],
	"./componentMobile/Appointment/CreateAppointment/StaffNotice.jsx": [
		95088,
		9,
		95088
	],
	"./componentMobile/Appointment/CreateAppointment/StaffSelectDropdown": [
		36047,
		9,
		36047
	],
	"./componentMobile/Appointment/CreateAppointment/StaffSelectDropdown.jsx": [
		36047,
		9,
		36047
	],
	"./componentMobile/Appointment/CreateAppointment/StarttimeSelectDropdown": [
		8878,
		9,
		85867,
		8878
	],
	"./componentMobile/Appointment/CreateAppointment/StarttimeSelectDropdown.jsx": [
		8878,
		9,
		85867,
		8878
	],
	"./componentMobile/Appointment/CreateWalkedinAppointment/CreateWalkedinAppointmentContainer": [
		86124,
		9,
		85867,
		59221,
		70712,
		90115,
		86124,
		86357
	],
	"./componentMobile/Appointment/CreateWalkedinAppointment/CreateWalkedinAppointmentContainer.jsx": [
		86124,
		9,
		85867,
		59221,
		70712,
		90115,
		86124,
		86357
	],
	"./componentMobile/Appointment/CreateWalkedinAppointment/WalkinForm": [
		53961,
		9,
		85867,
		53961
	],
	"./componentMobile/Appointment/CreateWalkedinAppointment/WalkinForm.jsx": [
		53961,
		9,
		85867,
		53961
	],
	"./componentMobile/Appointment/EditAppointment/EditAppointmentContainer": [
		37472,
		9,
		85867,
		59221,
		87369,
		70712,
		90115,
		81583,
		37472,
		47017
	],
	"./componentMobile/Appointment/EditAppointment/EditAppointmentContainer.jsx": [
		37472,
		9,
		85867,
		59221,
		87369,
		70712,
		90115,
		81583,
		37472,
		47017
	],
	"./componentMobile/Appointment/RebookAppointment/RebookAppointmentContainer": [
		15028,
		9,
		77425,
		85867,
		59221,
		87369,
		70712,
		90115,
		81583,
		15028,
		76010
	],
	"./componentMobile/Appointment/RebookAppointment/RebookAppointmentContainer.jsx": [
		15028,
		9,
		77425,
		85867,
		59221,
		87369,
		70712,
		90115,
		81583,
		15028,
		76010
	],
	"./componentMobile/Appointment/ViewAppointment/AppoinmentFooterActions": [
		78810,
		9,
		78810
	],
	"./componentMobile/Appointment/ViewAppointment/AppoinmentFooterActions.jsx": [
		78810,
		9,
		78810
	],
	"./componentMobile/Appointment/ViewAppointment/AppointmentDetail": [
		76207,
		9,
		85867,
		59221,
		846,
		47393,
		84180,
		42644,
		79881,
		63111,
		88312,
		76207,
		71757
	],
	"./componentMobile/Appointment/ViewAppointment/AppointmentDetail.jsx": [
		76207,
		9,
		85867,
		59221,
		846,
		47393,
		84180,
		42644,
		79881,
		63111,
		88312,
		76207,
		71757
	],
	"./componentMobile/Appointment/ViewAppointment/AppointmentEditStaff": [
		88312,
		9,
		88312,
		18737
	],
	"./componentMobile/Appointment/ViewAppointment/AppointmentEditStaff.jsx": [
		88312,
		9,
		88312,
		18737
	],
	"./componentMobile/Appointment/ViewAppointment/AppointmentHistory": [
		4194,
		9,
		4194
	],
	"./componentMobile/Appointment/ViewAppointment/AppointmentHistory.jsx": [
		4194,
		9,
		4194
	],
	"./componentMobile/Appointment/ViewAppointment/AppointmentImages": [
		24518,
		9,
		47393,
		37548
	],
	"./componentMobile/Appointment/ViewAppointment/AppointmentImages.jsx": [
		24518,
		9,
		47393,
		37548
	],
	"./componentMobile/Appointment/ViewAppointment/AppointmentReview": [
		29920,
		9,
		59221,
		84180,
		79881,
		63111,
		6771
	],
	"./componentMobile/Appointment/ViewAppointment/AppointmentReview.jsx": [
		29920,
		9,
		59221,
		84180,
		79881,
		63111,
		6771
	],
	"./componentMobile/Appointment/ViewAppointment/CancelAppointmentModal": [
		36575,
		9,
		36575
	],
	"./componentMobile/Appointment/ViewAppointment/CancelAppointmentModal.jsx": [
		36575,
		9,
		36575
	],
	"./componentMobile/Appointment/ViewAppointment/NoShowModal": [
		67162,
		9,
		67162
	],
	"./componentMobile/Appointment/ViewAppointment/NoShowModal.jsx": [
		67162,
		9,
		67162
	],
	"./componentMobile/Appointment/ViewAppointment/ResponseModal": [
		85492,
		9,
		59221,
		79881,
		63111,
		32451
	],
	"./componentMobile/Appointment/ViewAppointment/ResponseModal.jsx": [
		85492,
		9,
		59221,
		79881,
		63111,
		32451
	],
	"./componentMobile/Appointment/ViewAppointment/ViewAppointmentContainer": [
		25144,
		9,
		97914,
		85867,
		59221,
		846,
		70712,
		47393,
		93494,
		84180,
		42644,
		90115,
		79881,
		63305,
		63111,
		88312,
		76207,
		19471
	],
	"./componentMobile/Appointment/ViewAppointment/ViewAppointmentContainer.jsx": [
		25144,
		9,
		97914,
		85867,
		59221,
		846,
		70712,
		47393,
		93494,
		84180,
		42644,
		90115,
		79881,
		63305,
		63111,
		88312,
		76207,
		19471
	],
	"./componentMobile/Appointment/ViewAppointment/ViewAppointmentDrawer": [
		55694,
		9,
		97914,
		85867,
		59221,
		846,
		70712,
		47393,
		93494,
		84180,
		42644,
		90780,
		90115,
		79881,
		63305,
		63111,
		88312,
		76207,
		19423
	],
	"./componentMobile/Appointment/ViewAppointment/ViewAppointmentDrawer.jsx": [
		55694,
		9,
		97914,
		85867,
		59221,
		846,
		70712,
		47393,
		93494,
		84180,
		42644,
		90780,
		90115,
		79881,
		63305,
		63111,
		88312,
		76207,
		19423
	],
	"./componentMobile/Appointment/ViewAppointment/useAppointmentMenuItems": [
		55224,
		9,
		55224
	],
	"./componentMobile/Appointment/ViewAppointment/useAppointmentMenuItems.jsx": [
		55224,
		9,
		55224
	],
	"./componentMobile/CheckedIn/CheckedInContainer": [
		33914,
		9,
		20300,
		55819,
		18585,
		33914
	],
	"./componentMobile/CheckedIn/CheckedInContainer.jsx": [
		33914,
		9,
		20300,
		55819,
		18585,
		33914
	],
	"./componentMobile/CheckedIn/CheckedInFilter": [
		52421,
		9,
		52421
	],
	"./componentMobile/CheckedIn/CheckedInFilter.jsx": [
		52421,
		9,
		52421
	],
	"./componentMobile/CheckedIn/CheckedInStaffList": [
		18585,
		9,
		20300,
		18585,
		92644
	],
	"./componentMobile/CheckedIn/CheckedInStaffList.jsx": [
		18585,
		9,
		20300,
		18585,
		92644
	],
	"./componentMobile/Checkout/AddDiscountAfterTax": [
		85212,
		9,
		77425,
		97914,
		85212
	],
	"./componentMobile/Checkout/AddDiscountAfterTax.jsx": [
		85212,
		9,
		77425,
		97914,
		85212
	],
	"./componentMobile/Checkout/AddGiftCardToSale": [
		89646,
		9,
		77425,
		97914,
		87369,
		89646
	],
	"./componentMobile/Checkout/AddGiftCardToSale.jsx": [
		89646,
		9,
		77425,
		97914,
		87369,
		89646
	],
	"./componentMobile/Checkout/AddItemToSale": [
		87387,
		9,
		85867,
		87387
	],
	"./componentMobile/Checkout/AddItemToSale.jsx": [
		87387,
		9,
		85867,
		87387
	],
	"./componentMobile/Checkout/AddLoyaltyProgram": [
		70878,
		9,
		97914,
		70878
	],
	"./componentMobile/Checkout/AddLoyaltyProgram.jsx": [
		70878,
		9,
		97914,
		70878
	],
	"./componentMobile/Checkout/AddProductToSale": [
		33161,
		9,
		33161
	],
	"./componentMobile/Checkout/AddProductToSale.jsx": [
		33161,
		9,
		33161
	],
	"./componentMobile/Checkout/AddTipModal": [
		60162,
		9,
		77425,
		97914,
		60162
	],
	"./componentMobile/Checkout/AddTipModal.jsx": [
		60162,
		9,
		77425,
		97914,
		60162
	],
	"./componentMobile/Checkout/BalanceDetail": [
		46762,
		9,
		77425,
		97914,
		46762
	],
	"./componentMobile/Checkout/BalanceDetail.jsx": [
		46762,
		9,
		77425,
		97914,
		46762
	],
	"./componentMobile/Checkout/CardPaymentModal/CloverPayment": [
		47612,
		9,
		47612
	],
	"./componentMobile/Checkout/CardPaymentModal/CloverPayment.jsx": [
		47612,
		9,
		47612
	],
	"./componentMobile/Checkout/CardPaymentModal/PoyntPayment": [
		86939,
		9,
		42104,
		86939
	],
	"./componentMobile/Checkout/CardPaymentModal/PoyntPayment.jsx": [
		86939,
		9,
		42104,
		86939
	],
	"./componentMobile/Checkout/CardPaymentModal/SelectPaymentTerminalModal": [
		97490,
		9,
		85867,
		361,
		42104,
		82146,
		89381,
		38286
	],
	"./componentMobile/Checkout/CardPaymentModal/SelectPaymentTerminalModal.jsx": [
		97490,
		9,
		85867,
		361,
		42104,
		82146,
		89381,
		38286
	],
	"./componentMobile/Checkout/CardPaymentModal/TerminalOptions": [
		89381,
		9,
		85867,
		361,
		42104,
		82146,
		89381,
		41705
	],
	"./componentMobile/Checkout/CardPaymentModal/TerminalOptions.jsx": [
		89381,
		9,
		85867,
		361,
		42104,
		82146,
		89381,
		41705
	],
	"./componentMobile/Checkout/CardPaymentModal/TerminalsSection": [
		1567,
		9,
		1567
	],
	"./componentMobile/Checkout/CardPaymentModal/TerminalsSection.jsx": [
		1567,
		9,
		1567
	],
	"./componentMobile/Checkout/CheckoutContainer": [
		51088,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		70712,
		361,
		42104,
		93494,
		30059,
		90115,
		82146,
		89381,
		63305,
		40729,
		51088,
		18281
	],
	"./componentMobile/Checkout/CheckoutContainer.jsx": [
		51088,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		70712,
		361,
		42104,
		93494,
		30059,
		90115,
		82146,
		89381,
		63305,
		40729,
		51088,
		18281
	],
	"./componentMobile/Checkout/GiftCardPaymentForm": [
		90625,
		9,
		97914,
		90625
	],
	"./componentMobile/Checkout/GiftCardPaymentForm.jsx": [
		90625,
		9,
		97914,
		90625
	],
	"./componentMobile/Checkout/PaymentColumn": [
		40729,
		9,
		97914,
		85867,
		59221,
		70712,
		361,
		42104,
		93494,
		30059,
		90115,
		82146,
		89381,
		63305,
		40729,
		24310
	],
	"./componentMobile/Checkout/PaymentColumn.jsx": [
		40729,
		9,
		97914,
		85867,
		59221,
		70712,
		361,
		42104,
		93494,
		30059,
		90115,
		82146,
		89381,
		63305,
		40729,
		24310
	],
	"./componentMobile/Checkout/PromotionsCheckout": [
		33895,
		9,
		33895
	],
	"./componentMobile/Checkout/PromotionsCheckout.jsx": [
		33895,
		9,
		33895
	],
	"./componentMobile/Checkout/SaleForm": [
		35590,
		9,
		77425,
		97914,
		35590
	],
	"./componentMobile/Checkout/SaleForm.jsx": [
		35590,
		9,
		77425,
		97914,
		35590
	],
	"./componentMobile/Client/BlockClientModal/BlockClientModal": [
		97473,
		9,
		97473
	],
	"./componentMobile/Client/BlockClientModal/BlockClientModal.jsx": [
		97473,
		9,
		97473
	],
	"./componentMobile/Client/ClientDetails/ClientAppointments": [
		44837,
		9,
		846,
		44837
	],
	"./componentMobile/Client/ClientDetails/ClientAppointments.jsx": [
		44837,
		9,
		846,
		44837
	],
	"./componentMobile/Client/ClientDetails/ClientContactCard": [
		63305,
		9,
		97914,
		59221,
		70712,
		93494,
		90115,
		63305,
		99145
	],
	"./componentMobile/Client/ClientDetails/ClientContactCard.jsx": [
		63305,
		9,
		97914,
		59221,
		70712,
		93494,
		90115,
		63305,
		99145
	],
	"./componentMobile/Client/ClientDetails/ClientGeneralInfo": [
		31931,
		9,
		31931
	],
	"./componentMobile/Client/ClientDetails/ClientGeneralInfo.jsx": [
		31931,
		9,
		31931
	],
	"./componentMobile/Client/ClientDetails/ClientStatistics": [
		49966,
		9,
		49966
	],
	"./componentMobile/Client/ClientDetails/ClientStatistics.jsx": [
		49966,
		9,
		49966
	],
	"./componentMobile/Client/ClientDetails/ClientType": [
		12763,
		9,
		97914,
		12763
	],
	"./componentMobile/Client/ClientDetails/ClientType.jsx": [
		12763,
		9,
		97914,
		12763
	],
	"./componentMobile/Client/ClientDetails/DateCard": [
		67584,
		9,
		67584
	],
	"./componentMobile/Client/ClientDetails/DateCard.jsx": [
		67584,
		9,
		67584
	],
	"./componentMobile/Client/ClientDetails/LoyaltyProgramCard": [
		43326,
		9,
		97914,
		43326
	],
	"./componentMobile/Client/ClientDetails/LoyaltyProgramCard.jsx": [
		43326,
		9,
		97914,
		43326
	],
	"./componentMobile/Client/ClientDetails/LoyaltyProgramDetail": [
		15099,
		9,
		15099
	],
	"./componentMobile/Client/ClientDetails/LoyaltyProgramDetail.jsx": [
		15099,
		9,
		15099
	],
	"./componentMobile/Client/ClientDetails/LoyaltyProgramForm": [
		51514,
		9,
		97914,
		51514
	],
	"./componentMobile/Client/ClientDetails/LoyaltyProgramForm.jsx": [
		51514,
		9,
		97914,
		51514
	],
	"./componentMobile/Client/ClientDetails/UpdateClientModal": [
		60777,
		9,
		59221,
		70712,
		84593
	],
	"./componentMobile/Client/ClientDetails/UpdateClientModal.jsx": [
		60777,
		9,
		59221,
		70712,
		84593
	],
	"./componentMobile/Client/ClientSearch/ClientFilterForm": [
		79489,
		9,
		77425,
		97914,
		16371,
		79489
	],
	"./componentMobile/Client/ClientSearch/ClientFilterForm.jsx": [
		79489,
		9,
		77425,
		97914,
		16371,
		79489
	],
	"./componentMobile/Client/ClientSearch/ClientSearchBox": [
		12770,
		9,
		77425,
		97914,
		59221,
		16371,
		12770
	],
	"./componentMobile/Client/ClientSearch/ClientSearchBox.jsx": [
		12770,
		9,
		77425,
		97914,
		59221,
		16371,
		12770
	],
	"./componentMobile/Client/ClientSearch/ClientSearchResult": [
		21970,
		9,
		77425,
		59221,
		54590,
		21970
	],
	"./componentMobile/Client/ClientSearch/ClientSearchResult.jsx": [
		21970,
		9,
		77425,
		59221,
		54590,
		21970
	],
	"./componentMobile/Client/CreateClient/ClientForm": [
		90731,
		9,
		59221,
		70712,
		91907
	],
	"./componentMobile/Client/CreateClient/ClientForm.jsx": [
		90731,
		9,
		59221,
		70712,
		91907
	],
	"./componentMobile/Client/CreateClient/CreateClientModal": [
		54830,
		9,
		59221,
		70712,
		56888
	],
	"./componentMobile/Client/CreateClient/CreateClientModal.jsx": [
		54830,
		9,
		59221,
		70712,
		56888
	],
	"./componentMobile/Client/RemoveClientModal/RemoveClientModal": [
		85785,
		9,
		85785
	],
	"./componentMobile/Client/RemoveClientModal/RemoveClientModal.jsx": [
		85785,
		9,
		85785
	],
	"./componentMobile/Client/RequiredDepositModal/RequiredDepositModal": [
		80987,
		9,
		80987
	],
	"./componentMobile/Client/RequiredDepositModal/RequiredDepositModal.jsx": [
		80987,
		9,
		80987
	],
	"./componentMobile/FastCheckout/Checkout/AddDiscountAfterTaxFastCheckout": [
		31777,
		9,
		77425,
		97914,
		31777
	],
	"./componentMobile/FastCheckout/Checkout/AddDiscountAfterTaxFastCheckout.jsx": [
		31777,
		9,
		77425,
		97914,
		31777
	],
	"./componentMobile/FastCheckout/Checkout/AddGiftCardToSaleFastCheckout": [
		71523,
		9,
		77425,
		97914,
		87369,
		71523
	],
	"./componentMobile/FastCheckout/Checkout/AddGiftCardToSaleFastCheckout.jsx": [
		71523,
		9,
		77425,
		97914,
		87369,
		71523
	],
	"./componentMobile/FastCheckout/Checkout/AddItemToSaleFastCheckout": [
		98722,
		9,
		85867,
		98722
	],
	"./componentMobile/FastCheckout/Checkout/AddItemToSaleFastCheckout.jsx": [
		98722,
		9,
		85867,
		98722
	],
	"./componentMobile/FastCheckout/Checkout/AddProductToSaleFastCheckout": [
		66522,
		9,
		66522
	],
	"./componentMobile/FastCheckout/Checkout/AddProductToSaleFastCheckout.jsx": [
		66522,
		9,
		66522
	],
	"./componentMobile/FastCheckout/Checkout/AddTipModal": [
		88130,
		9,
		77425,
		97914,
		65749
	],
	"./componentMobile/FastCheckout/Checkout/AddTipModal.jsx": [
		88130,
		9,
		77425,
		97914,
		65749
	],
	"./componentMobile/FastCheckout/Checkout/BalanceDetailFastCheckout": [
		27863,
		9,
		77425,
		97914,
		27863
	],
	"./componentMobile/FastCheckout/Checkout/BalanceDetailFastCheckout.jsx": [
		27863,
		9,
		77425,
		97914,
		27863
	],
	"./componentMobile/FastCheckout/Checkout/CheckoutContainerForNoAppointment": [
		28632,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		75058,
		82146,
		89381,
		23864,
		74557,
		21447,
		46691
	],
	"./componentMobile/FastCheckout/Checkout/CheckoutContainerForNoAppointment.jsx": [
		28632,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		75058,
		82146,
		89381,
		23864,
		74557,
		21447,
		46691
	],
	"./componentMobile/FastCheckout/Checkout/GiftCardPaymentFormFastCheckout": [
		48676,
		9,
		97914,
		48676
	],
	"./componentMobile/FastCheckout/Checkout/GiftCardPaymentFormFastCheckout.jsx": [
		48676,
		9,
		97914,
		48676
	],
	"./componentMobile/FastCheckout/Checkout/PaymentColumnFastCheckout": [
		23864,
		9,
		97914,
		85867,
		361,
		42104,
		82146,
		89381,
		23864,
		19532
	],
	"./componentMobile/FastCheckout/Checkout/PaymentColumnFastCheckout.jsx": [
		23864,
		9,
		97914,
		85867,
		361,
		42104,
		82146,
		89381,
		23864,
		19532
	],
	"./componentMobile/FastCheckout/Checkout/PromotionsFastCheckout": [
		52636,
		9,
		52636
	],
	"./componentMobile/FastCheckout/Checkout/PromotionsFastCheckout.jsx": [
		52636,
		9,
		52636
	],
	"./componentMobile/FastCheckout/Checkout/SaleFormFastCheckout": [
		74557,
		9,
		77425,
		97914,
		74557,
		51659
	],
	"./componentMobile/FastCheckout/Checkout/SaleFormFastCheckout.jsx": [
		74557,
		9,
		77425,
		97914,
		74557,
		51659
	],
	"./componentMobile/FastCheckout/Invoice/AddPaymentFastCheckout": [
		53432,
		9,
		97914,
		361,
		82146,
		53432
	],
	"./componentMobile/FastCheckout/Invoice/AddPaymentFastCheckout.jsx": [
		53432,
		9,
		97914,
		361,
		82146,
		53432
	],
	"./componentMobile/FastCheckout/Invoice/InvoiceContainerFastCheckout": [
		48491,
		9,
		97914,
		85867,
		93141,
		361,
		42104,
		82146,
		89381,
		23864,
		10844,
		679
	],
	"./componentMobile/FastCheckout/Invoice/InvoiceContainerFastCheckout.jsx": [
		48491,
		9,
		97914,
		85867,
		93141,
		361,
		42104,
		82146,
		89381,
		23864,
		10844,
		679
	],
	"./componentMobile/FastCheckout/Invoice/InvoiceGiftcardsEmailsFormFastCheckout": [
		27656,
		9,
		27656
	],
	"./componentMobile/FastCheckout/Invoice/InvoiceGiftcardsEmailsFormFastCheckout.jsx": [
		27656,
		9,
		27656
	],
	"./componentMobile/FastCheckout/Invoice/InvoiceGiftcardsEmailsModalFastCheckout": [
		68175,
		9,
		68175
	],
	"./componentMobile/FastCheckout/Invoice/InvoiceGiftcardsEmailsModalFastCheckout.jsx": [
		68175,
		9,
		68175
	],
	"./componentMobile/FastCheckout/Invoice/InvoicePaperFastCheckout": [
		2696,
		9,
		85867,
		2696
	],
	"./componentMobile/FastCheckout/Invoice/InvoicePaperFastCheckout.jsx": [
		2696,
		9,
		85867,
		2696
	],
	"./componentMobile/FastCheckout/Invoice/InvoicePaymentColumnFastCheckout": [
		92970,
		9,
		97914,
		85867,
		93141,
		361,
		42104,
		82146,
		89381,
		23864,
		10844,
		67974
	],
	"./componentMobile/FastCheckout/Invoice/InvoicePaymentColumnFastCheckout.jsx": [
		92970,
		9,
		97914,
		85867,
		93141,
		361,
		42104,
		82146,
		89381,
		23864,
		10844,
		67974
	],
	"./componentMobile/FastCheckout/Invoice/InvoiceStatusColumnFastCheckout": [
		10844,
		9,
		85867,
		93141,
		10844,
		50904
	],
	"./componentMobile/FastCheckout/Invoice/InvoiceStatusColumnFastCheckout.jsx": [
		10844,
		9,
		85867,
		93141,
		10844,
		50904
	],
	"./componentMobile/FastCheckout/Invoice/InvoiceStatusFastCheckout": [
		59758,
		9,
		59758
	],
	"./componentMobile/FastCheckout/Invoice/InvoiceStatusFastCheckout.jsx": [
		59758,
		9,
		59758
	],
	"./componentMobile/FastCheckout/Invoice/RefundPaymentsModalFastCheckout": [
		35351,
		9,
		35351
	],
	"./componentMobile/FastCheckout/Invoice/RefundPaymentsModalFastCheckout.jsx": [
		35351,
		9,
		35351
	],
	"./componentMobile/GiftCardHistory/GiftCardHistoryForm": [
		66421,
		9,
		77425,
		97914,
		54590,
		87369,
		66421
	],
	"./componentMobile/GiftCardHistory/GiftCardHistoryForm.jsx": [
		66421,
		9,
		77425,
		97914,
		54590,
		87369,
		66421
	],
	"./componentMobile/GiftCardHistory/GiftCardHistoryHistory": [
		64131,
		9,
		77425,
		54590,
		64131
	],
	"./componentMobile/GiftCardHistory/GiftCardHistoryHistory.jsx": [
		64131,
		9,
		77425,
		54590,
		64131
	],
	"./componentMobile/GiftCardHistory/GiftCardHistoryList": [
		28111,
		9,
		77425,
		97914,
		54590,
		87369,
		66421,
		28111
	],
	"./componentMobile/GiftCardHistory/GiftCardHistoryList.jsx": [
		28111,
		9,
		77425,
		97914,
		54590,
		87369,
		66421,
		28111
	],
	"./componentMobile/GiftCardHistory/GiftCardHistorySearchBox": [
		11264,
		9,
		77425,
		97914,
		54590,
		87369,
		66421,
		11264
	],
	"./componentMobile/GiftCardHistory/GiftCardHistorySearchBox.jsx": [
		11264,
		9,
		77425,
		97914,
		54590,
		87369,
		66421,
		11264
	],
	"./componentMobile/History/AiCallHistory/AiCallDetails": [
		72288,
		9,
		59221,
		20691,
		72288
	],
	"./componentMobile/History/AiCallHistory/AiCallDetails.jsx": [
		72288,
		9,
		59221,
		20691,
		72288
	],
	"./componentMobile/History/AiCallHistory/AiCalls": [
		71621,
		9,
		77425,
		85867,
		59221,
		54590,
		20691,
		71621
	],
	"./componentMobile/History/AiCallHistory/AiCalls.jsx": [
		71621,
		9,
		77425,
		85867,
		59221,
		54590,
		20691,
		71621
	],
	"./componentMobile/History/Appointments/HistoryAppointmentByDate": [
		34642,
		9,
		77425,
		54590,
		93141,
		34642
	],
	"./componentMobile/History/Appointments/HistoryAppointmentByDate.jsx": [
		34642,
		9,
		77425,
		54590,
		93141,
		34642
	],
	"./componentMobile/History/Appointments/HistoryAppointmentByStatus": [
		16320,
		9,
		77425,
		54590,
		93141,
		846,
		16320
	],
	"./componentMobile/History/Appointments/HistoryAppointmentByStatus.jsx": [
		16320,
		9,
		77425,
		54590,
		93141,
		846,
		16320
	],
	"./componentMobile/History/Appointments/HistoryAppointmentByType": [
		25670,
		9,
		77425,
		54590,
		93141,
		25670
	],
	"./componentMobile/History/Appointments/HistoryAppointmentByType.jsx": [
		25670,
		9,
		77425,
		54590,
		93141,
		25670
	],
	"./componentMobile/History/Appointments/HistoryAppointmentTable": [
		49397,
		9,
		77425,
		54590,
		93141,
		846,
		49397
	],
	"./componentMobile/History/Appointments/HistoryAppointmentTable.jsx": [
		49397,
		9,
		77425,
		54590,
		93141,
		846,
		49397
	],
	"./componentMobile/History/Appointments/NewHistoryAppointment": [
		36501,
		9,
		77425,
		54590,
		93141,
		846,
		36501,
		98638
	],
	"./componentMobile/History/Appointments/NewHistoryAppointment.jsx": [
		36501,
		9,
		77425,
		54590,
		93141,
		846,
		36501,
		98638
	],
	"./componentMobile/History/Charts/HistoryBarChart": [
		51516,
		9,
		26989,
		17867,
		82291,
		51516
	],
	"./componentMobile/History/Charts/HistoryBarChart.jsx": [
		51516,
		9,
		26989,
		17867,
		82291,
		51516
	],
	"./componentMobile/History/Charts/HistoryPieChart": [
		81047,
		9,
		26989,
		17867,
		60163,
		81047
	],
	"./componentMobile/History/Charts/HistoryPieChart.jsx": [
		81047,
		9,
		26989,
		17867,
		60163,
		81047
	],
	"./componentMobile/History/Filter/HistoryDateInputSelect": [
		217,
		9,
		87369,
		22598
	],
	"./componentMobile/History/Filter/HistoryDateInputSelect.jsx": [
		217,
		9,
		87369,
		22598
	],
	"./componentMobile/History/Filter/HistoryDateMonthSelect": [
		90548,
		9,
		87369,
		90548
	],
	"./componentMobile/History/Filter/HistoryDateMonthSelect.jsx": [
		90548,
		9,
		87369,
		90548
	],
	"./componentMobile/History/Filter/HistoryDateRangeSelect": [
		35149,
		9,
		87369,
		35149
	],
	"./componentMobile/History/Filter/HistoryDateRangeSelect.jsx": [
		35149,
		9,
		87369,
		35149
	],
	"./componentMobile/History/Filter/HistoryDateSelect": [
		6251,
		9,
		87369,
		28632
	],
	"./componentMobile/History/Filter/HistoryDateSelect.jsx": [
		6251,
		9,
		87369,
		28632
	],
	"./componentMobile/History/Filter/HistorySearchButton": [
		81876,
		9,
		81876
	],
	"./componentMobile/History/Filter/HistorySearchButton.jsx": [
		81876,
		9,
		81876
	],
	"./componentMobile/History/HistoryAppointments": [
		34653,
		9,
		77425,
		54590,
		93141,
		846,
		26989,
		17867,
		60163,
		64927,
		34653
	],
	"./componentMobile/History/HistoryAppointments.jsx": [
		34653,
		9,
		77425,
		54590,
		93141,
		846,
		26989,
		17867,
		60163,
		64927,
		34653
	],
	"./componentMobile/History/HistoryContainer": [
		93346,
		9,
		77425,
		85867,
		59221,
		54590,
		87369,
		93141,
		846,
		26989,
		17867,
		82291,
		20691,
		10370,
		91080,
		48296,
		79881,
		63111,
		38557,
		42979,
		36501,
		93346,
		69072
	],
	"./componentMobile/History/HistoryContainer.jsx": [
		93346,
		9,
		77425,
		85867,
		59221,
		54590,
		87369,
		93141,
		846,
		26989,
		17867,
		82291,
		20691,
		10370,
		91080,
		48296,
		79881,
		63111,
		38557,
		42979,
		36501,
		93346,
		69072
	],
	"./componentMobile/History/HistoryInvoices": [
		65431,
		9,
		77425,
		54590,
		26989,
		17867,
		60163,
		65431
	],
	"./componentMobile/History/HistoryInvoices.jsx": [
		65431,
		9,
		77425,
		54590,
		26989,
		17867,
		60163,
		65431
	],
	"./componentMobile/History/HistoryPayments": [
		94741,
		9,
		77425,
		54590,
		26989,
		17867,
		60163,
		17122
	],
	"./componentMobile/History/HistoryPayments.jsx": [
		94741,
		9,
		77425,
		54590,
		26989,
		17867,
		60163,
		17122
	],
	"./componentMobile/History/HistoryReport": [
		91321,
		9,
		77425,
		54590,
		91321
	],
	"./componentMobile/History/HistoryReport.jsx": [
		91321,
		9,
		77425,
		54590,
		91321
	],
	"./componentMobile/History/HistoryReportPrintButton": [
		3080,
		9,
		77425,
		54590,
		93141,
		3080
	],
	"./componentMobile/History/HistoryReportPrintButton.jsx": [
		3080,
		9,
		77425,
		54590,
		93141,
		3080
	],
	"./componentMobile/History/HistoryRevenues/HistoryDeposits": [
		40388,
		9,
		77425,
		85867,
		54590,
		93141,
		40388
	],
	"./componentMobile/History/HistoryRevenues/HistoryDeposits.jsx": [
		40388,
		9,
		77425,
		85867,
		54590,
		93141,
		40388
	],
	"./componentMobile/History/HistoryRevenues/HistoryDiscounts": [
		14309,
		9,
		77425,
		85867,
		54590,
		93141,
		14309
	],
	"./componentMobile/History/HistoryRevenues/HistoryDiscounts.jsx": [
		14309,
		9,
		77425,
		85867,
		54590,
		93141,
		14309
	],
	"./componentMobile/History/HistoryRevenues/HistoryGiftCard": [
		92369,
		9,
		77425,
		54590,
		93141,
		92369
	],
	"./componentMobile/History/HistoryRevenues/HistoryGiftCard.jsx": [
		92369,
		9,
		77425,
		54590,
		93141,
		92369
	],
	"./componentMobile/History/HistoryRevenues/HistoryInvoices": [
		38557,
		9,
		77425,
		85867,
		54590,
		93141,
		38557,
		70943
	],
	"./componentMobile/History/HistoryRevenues/HistoryInvoices.jsx": [
		38557,
		9,
		77425,
		85867,
		54590,
		93141,
		38557,
		70943
	],
	"./componentMobile/History/HistoryRevenues/HistorySaleByPayment": [
		73,
		9,
		77425,
		54590,
		93141,
		73
	],
	"./componentMobile/History/HistoryRevenues/HistorySaleByPayment.jsx": [
		73,
		9,
		77425,
		54590,
		93141,
		73
	],
	"./componentMobile/History/HistoryRevenues/HistorySalesByDate": [
		182,
		9,
		77425,
		85867,
		54590,
		93141,
		182
	],
	"./componentMobile/History/HistoryRevenues/HistorySalesByDate.jsx": [
		182,
		9,
		77425,
		85867,
		54590,
		93141,
		182
	],
	"./componentMobile/History/HistoryRevenues/HistorySalesByMenu": [
		39567,
		9,
		77425,
		85867,
		54590,
		93141,
		39567
	],
	"./componentMobile/History/HistoryRevenues/HistorySalesByMenu.jsx": [
		39567,
		9,
		77425,
		85867,
		54590,
		93141,
		39567
	],
	"./componentMobile/History/HistoryRevenues/HistorySalesByProduct": [
		11593,
		9,
		77425,
		85867,
		54590,
		93141,
		11593
	],
	"./componentMobile/History/HistoryRevenues/HistorySalesByProduct.jsx": [
		11593,
		9,
		77425,
		85867,
		54590,
		93141,
		11593
	],
	"./componentMobile/History/HistoryRevenues/HistorySalesByStaff": [
		84102,
		9,
		77425,
		54590,
		93141,
		84102
	],
	"./componentMobile/History/HistoryRevenues/HistorySalesByStaff.jsx": [
		84102,
		9,
		77425,
		54590,
		93141,
		84102
	],
	"./componentMobile/History/HistoryRevenues/HistorySalesByStore": [
		93555,
		9,
		77425,
		54590,
		93141,
		10370,
		93555
	],
	"./componentMobile/History/HistoryRevenues/HistorySalesByStore.jsx": [
		93555,
		9,
		77425,
		54590,
		93141,
		10370,
		93555
	],
	"./componentMobile/History/HistoryRevenues/HistoryTaxes": [
		54822,
		9,
		77425,
		54590,
		93141,
		54822
	],
	"./componentMobile/History/HistoryRevenues/HistoryTaxes.jsx": [
		54822,
		9,
		77425,
		54590,
		93141,
		54822
	],
	"./componentMobile/History/HistoryRevenues/HistoryTips": [
		6815,
		9,
		77425,
		54590,
		93141,
		6815
	],
	"./componentMobile/History/HistoryRevenues/HistoryTips.jsx": [
		6815,
		9,
		77425,
		54590,
		93141,
		6815
	],
	"./componentMobile/History/HistoryRevenues/NewHistoryRevenue": [
		42979,
		9,
		77425,
		85867,
		54590,
		93141,
		10370,
		38557,
		42979,
		30311
	],
	"./componentMobile/History/HistoryRevenues/NewHistoryRevenue.jsx": [
		42979,
		9,
		77425,
		85867,
		54590,
		93141,
		10370,
		38557,
		42979,
		30311
	],
	"./componentMobile/History/HistoryRevenues/useFetchGiftCardData": [
		44938,
		9,
		44938
	],
	"./componentMobile/History/HistoryRevenues/useFetchGiftCardData.js": [
		44938,
		9,
		44938
	],
	"./componentMobile/History/HistoryReviews": [
		22820,
		9,
		59221,
		26989,
		17867,
		82291,
		91080,
		79881,
		63111,
		91670
	],
	"./componentMobile/History/HistoryReviews.jsx": [
		22820,
		9,
		59221,
		26989,
		17867,
		82291,
		91080,
		79881,
		63111,
		91670
	],
	"./componentMobile/History/HistorySales": [
		66023,
		9,
		77425,
		54590,
		846,
		26989,
		17867,
		60163,
		66023
	],
	"./componentMobile/History/HistorySales.jsx": [
		66023,
		9,
		77425,
		54590,
		846,
		26989,
		17867,
		60163,
		66023
	],
	"./componentMobile/Invoice/AddPayment": [
		893,
		9,
		97914,
		361,
		82146,
		893
	],
	"./componentMobile/Invoice/AddPayment.jsx": [
		893,
		9,
		97914,
		361,
		82146,
		893
	],
	"./componentMobile/Invoice/CloverReceiptPrint": [
		6098,
		9,
		85867,
		6098
	],
	"./componentMobile/Invoice/CloverReceiptPrint.jsx": [
		6098,
		9,
		85867,
		6098
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceAddDiscountAfterTax": [
		72994,
		9,
		77425,
		97914,
		72994
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceAddDiscountAfterTax.jsx": [
		72994,
		9,
		77425,
		97914,
		72994
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceAddItemToSale": [
		3009,
		9,
		85867,
		3009
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceAddItemToSale.jsx": [
		3009,
		9,
		85867,
		3009
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceAddProductToSale": [
		48239,
		9,
		48239
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceAddProductToSale.jsx": [
		48239,
		9,
		48239
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceAddTipModal": [
		91644,
		9,
		77425,
		97914,
		91644
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceAddTipModal.jsx": [
		91644,
		9,
		77425,
		97914,
		91644
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceBalanceDetail": [
		52324,
		9,
		77425,
		97914,
		52324
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceBalanceDetail.jsx": [
		52324,
		9,
		77425,
		97914,
		52324
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceContainer": [
		26662,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		26237,
		82146,
		89381,
		52324,
		26662,
		28757
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceContainer.jsx": [
		26662,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		26237,
		82146,
		89381,
		52324,
		26662,
		28757
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoicePaymentColumn": [
		83191,
		9,
		97914,
		85867,
		361,
		42104,
		26237,
		82146,
		89381,
		86871
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoicePaymentColumn.jsx": [
		83191,
		9,
		97914,
		85867,
		361,
		42104,
		26237,
		82146,
		89381,
		86871
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceSaleForm": [
		12208,
		9,
		77425,
		97914,
		12208
	],
	"./componentMobile/Invoice/EditInvoice/EditInvoiceSaleForm.jsx": [
		12208,
		9,
		77425,
		97914,
		12208
	],
	"./componentMobile/Invoice/InvoiceContainer": [
		1330,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		361,
		42104,
		93494,
		30059,
		90115,
		82146,
		89381,
		63305,
		40729,
		27263,
		51397
	],
	"./componentMobile/Invoice/InvoiceContainer.jsx": [
		1330,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		361,
		42104,
		93494,
		30059,
		90115,
		82146,
		89381,
		63305,
		40729,
		27263,
		51397
	],
	"./componentMobile/Invoice/InvoiceGiftcardsEmailsForm": [
		86365,
		9,
		86365
	],
	"./componentMobile/Invoice/InvoiceGiftcardsEmailsForm.jsx": [
		86365,
		9,
		86365
	],
	"./componentMobile/Invoice/InvoiceGiftcardsEmailsModal": [
		77148,
		9,
		77148
	],
	"./componentMobile/Invoice/InvoiceGiftcardsEmailsModal.jsx": [
		77148,
		9,
		77148
	],
	"./componentMobile/Invoice/InvoicePaper": [
		84469,
		9,
		84469
	],
	"./componentMobile/Invoice/InvoicePaper.jsx": [
		84469,
		9,
		84469
	],
	"./componentMobile/Invoice/InvoicePaymentColumn": [
		92211,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		361,
		42104,
		93494,
		30059,
		90115,
		82146,
		89381,
		63305,
		40729,
		27263,
		3489
	],
	"./componentMobile/Invoice/InvoicePaymentColumn.jsx": [
		92211,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		361,
		42104,
		93494,
		30059,
		90115,
		82146,
		89381,
		63305,
		40729,
		27263,
		3489
	],
	"./componentMobile/Invoice/InvoiceStatus": [
		43005,
		9,
		43005
	],
	"./componentMobile/Invoice/InvoiceStatus.jsx": [
		43005,
		9,
		43005
	],
	"./componentMobile/Invoice/InvoiceStatusColumn": [
		27263,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		93494,
		90115,
		63305,
		27263,
		74727
	],
	"./componentMobile/Invoice/InvoiceStatusColumn.jsx": [
		27263,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		93494,
		90115,
		63305,
		27263,
		74727
	],
	"./componentMobile/Invoice/RefundPaymentsModal": [
		58988,
		9,
		58988
	],
	"./componentMobile/Invoice/RefundPaymentsModal.jsx": [
		58988,
		9,
		58988
	],
	"./componentMobile/Report/AppointmentGraphReport": [
		79940,
		9,
		26989,
		17867,
		82291,
		79940
	],
	"./componentMobile/Report/AppointmentGraphReport.jsx": [
		79940,
		9,
		26989,
		17867,
		82291,
		79940
	],
	"./componentMobile/Report/Billing/BillingContainer": [
		65101,
		9,
		77425,
		59221,
		54590,
		93141,
		20036,
		18061
	],
	"./componentMobile/Report/Billing/BillingContainer.jsx": [
		65101,
		9,
		77425,
		59221,
		54590,
		93141,
		20036,
		18061
	],
	"./componentMobile/Report/Billing/BillingDetailsColumn": [
		20036,
		9,
		77425,
		59221,
		54590,
		93141,
		20036,
		51138
	],
	"./componentMobile/Report/Billing/BillingDetailsColumn.jsx": [
		20036,
		9,
		77425,
		59221,
		54590,
		93141,
		20036,
		51138
	],
	"./componentMobile/Report/Billing/BillingHistoryColumn": [
		22274,
		9,
		22274
	],
	"./componentMobile/Report/Billing/BillingHistoryColumn.jsx": [
		22274,
		9,
		22274
	],
	"./componentMobile/Report/Billing/CreditCardForm": [
		6712,
		9,
		6712
	],
	"./componentMobile/Report/Billing/CreditCardForm.jsx": [
		6712,
		9,
		6712
	],
	"./componentMobile/Report/Billing/UpdatePaymentMethodModal": [
		89660,
		9,
		77425,
		89660
	],
	"./componentMobile/Report/Billing/UpdatePaymentMethodModal.jsx": [
		89660,
		9,
		77425,
		89660
	],
	"./componentMobile/Report/Billing/VoidChequeCaForm": [
		94570,
		9,
		94570
	],
	"./componentMobile/Report/Billing/VoidChequeCaForm.jsx": [
		94570,
		9,
		94570
	],
	"./componentMobile/Report/Billing/VoidChequeUsForm": [
		53274,
		9,
		53274
	],
	"./componentMobile/Report/Billing/VoidChequeUsForm.jsx": [
		53274,
		9,
		53274
	],
	"./componentMobile/Report/Billing/visa-mastercard-logos.jpg": [
		52998,
		1,
		52998
	],
	"./componentMobile/Report/ClientsStats/ClientsStatsByLastVisit": [
		90244,
		9,
		26989,
		17867,
		60163,
		90244
	],
	"./componentMobile/Report/ClientsStats/ClientsStatsByLastVisit.jsx": [
		90244,
		9,
		26989,
		17867,
		60163,
		90244
	],
	"./componentMobile/Report/ClientsStats/ClientsStatsByType": [
		23609,
		9,
		26989,
		17867,
		60163,
		23609
	],
	"./componentMobile/Report/ClientsStats/ClientsStatsByType.jsx": [
		23609,
		9,
		26989,
		17867,
		60163,
		23609
	],
	"./componentMobile/Report/ClientsStats/NewClientsStatsByMonth": [
		7949,
		9,
		26989,
		17867,
		82291,
		7949
	],
	"./componentMobile/Report/ClientsStats/NewClientsStatsByMonth.jsx": [
		7949,
		9,
		26989,
		17867,
		82291,
		7949
	],
	"./componentMobile/Report/MonthlyBillingReport": [
		47881,
		9,
		93141,
		47881
	],
	"./componentMobile/Report/MonthlyBillingReport.jsx": [
		47881,
		9,
		93141,
		47881
	],
	"./componentMobile/Report/SaleGraphReport": [
		57086,
		9,
		26989,
		17867,
		82291,
		57086
	],
	"./componentMobile/Report/SaleGraphReport.jsx": [
		57086,
		9,
		26989,
		17867,
		82291,
		57086
	],
	"./componentMobile/Report/SaleStatisticReport": [
		23824,
		9,
		23824
	],
	"./componentMobile/Report/SaleStatisticReport.jsx": [
		23824,
		9,
		23824
	],
	"./componentMobile/Settings/AiReceptionist/AiOnlineSchedule/AiHourForm": [
		88107,
		9,
		88107
	],
	"./componentMobile/Settings/AiReceptionist/AiOnlineSchedule/AiHourForm.jsx": [
		88107,
		9,
		88107
	],
	"./componentMobile/Settings/AiReceptionist/AiOnlineSchedule/AiOnlineHour": [
		50536,
		9,
		77425,
		50536
	],
	"./componentMobile/Settings/AiReceptionist/AiOnlineSchedule/AiOnlineHour.jsx": [
		50536,
		9,
		77425,
		50536
	],
	"./componentMobile/Settings/AiReceptionist/AiOnlineSchedule/AiOnlineSchedule": [
		18973,
		9,
		77425,
		18973
	],
	"./componentMobile/Settings/AiReceptionist/AiOnlineSchedule/AiOnlineSchedule.jsx": [
		18973,
		9,
		77425,
		18973
	],
	"./componentMobile/Settings/AiReceptionist/AiOnlineSchedule/AiTransferHour": [
		62040,
		9,
		77425,
		62040
	],
	"./componentMobile/Settings/AiReceptionist/AiOnlineSchedule/AiTransferHour.jsx": [
		62040,
		9,
		77425,
		62040
	],
	"./componentMobile/Settings/AiReceptionist/AiPolicyAlert": [
		33020,
		9,
		33020
	],
	"./componentMobile/Settings/AiReceptionist/AiPolicyAlert.jsx": [
		33020,
		9,
		33020
	],
	"./componentMobile/Settings/AiReceptionist/AiReceptionistGeneral": [
		1515,
		9,
		85867,
		59221,
		1515,
		993
	],
	"./componentMobile/Settings/AiReceptionist/AiReceptionistGeneral.jsx": [
		1515,
		9,
		85867,
		59221,
		1515,
		993
	],
	"./componentMobile/Settings/AiReceptionist/ForwardingInstructions": [
		11922,
		9,
		11922
	],
	"./componentMobile/Settings/AiReceptionist/ForwardingInstructions.jsx": [
		11922,
		9,
		11922
	],
	"./componentMobile/Settings/Appointments/AppointmentConfirmationForm": [
		94217,
		9,
		59221,
		94217,
		25509
	],
	"./componentMobile/Settings/Appointments/AppointmentConfirmationForm.jsx": [
		94217,
		9,
		59221,
		94217,
		25509
	],
	"./componentMobile/Settings/Appointments/BusinessLinks": [
		79774,
		9,
		93141,
		91614,
		79774
	],
	"./componentMobile/Settings/Appointments/BusinessLinks.jsx": [
		79774,
		9,
		93141,
		91614,
		79774
	],
	"./componentMobile/Settings/ClientType/ClientTypeCategory": [
		31751,
		9,
		97914,
		31751
	],
	"./componentMobile/Settings/ClientType/ClientTypeCategory.jsx": [
		31751,
		9,
		97914,
		31751
	],
	"./componentMobile/Settings/ClientType/ClientTypePoint": [
		53729,
		9,
		97914,
		53729
	],
	"./componentMobile/Settings/ClientType/ClientTypePoint.jsx": [
		53729,
		9,
		97914,
		53729
	],
	"./componentMobile/Settings/Clover/NewCloverTerminals": [
		35628,
		9,
		77425,
		97914,
		54590,
		35628
	],
	"./componentMobile/Settings/Clover/NewCloverTerminals.jsx": [
		35628,
		9,
		77425,
		97914,
		54590,
		35628
	],
	"./componentMobile/Settings/Clover/PayModal": [
		12571,
		9,
		361,
		82146,
		12571
	],
	"./componentMobile/Settings/Clover/PayModal.js": [
		12571,
		9,
		361,
		82146,
		12571
	],
	"./componentMobile/Settings/Deposit/DepositClients": [
		34332,
		9,
		77425,
		54590,
		11951
	],
	"./componentMobile/Settings/Deposit/DepositClients.jsx": [
		34332,
		9,
		77425,
		54590,
		11951
	],
	"./componentMobile/Settings/Deposit/DepositServices": [
		46167,
		9,
		77425,
		54590,
		46167
	],
	"./componentMobile/Settings/Deposit/DepositServices.jsx": [
		46167,
		9,
		77425,
		54590,
		46167
	],
	"./componentMobile/Settings/Deposit/GeneralSettings": [
		69050,
		9,
		97914,
		69050
	],
	"./componentMobile/Settings/Deposit/GeneralSettings.jsx": [
		69050,
		9,
		97914,
		69050
	],
	"./componentMobile/Settings/Deposit/SpecialSettings": [
		24339,
		9,
		77425,
		54590,
		24339
	],
	"./componentMobile/Settings/Deposit/SpecialSettings.jsx": [
		24339,
		9,
		77425,
		54590,
		24339
	],
	"./componentMobile/Settings/Flyers/FlyersItem": [
		68130,
		9,
		87369,
		47393,
		20300,
		34480
	],
	"./componentMobile/Settings/Flyers/FlyersItem.jsx": [
		68130,
		9,
		87369,
		47393,
		20300,
		34480
	],
	"./componentMobile/Settings/GiftCard/GiftCardDetails": [
		2575,
		9,
		77425,
		97914,
		54590,
		87369,
		29142,
		2575
	],
	"./componentMobile/Settings/GiftCard/GiftCardDetails.jsx": [
		2575,
		9,
		77425,
		97914,
		54590,
		87369,
		29142,
		2575
	],
	"./componentMobile/Settings/GiftCard/GiftCardFilter": [
		35563,
		9,
		35563
	],
	"./componentMobile/Settings/GiftCard/GiftCardFilter.jsx": [
		35563,
		9,
		35563
	],
	"./componentMobile/Settings/GiftCard/GiftCardForm": [
		98175,
		9,
		77425,
		97914,
		87369,
		98175
	],
	"./componentMobile/Settings/GiftCard/GiftCardForm.jsx": [
		98175,
		9,
		77425,
		97914,
		87369,
		98175
	],
	"./componentMobile/Settings/GiftCard/GiftCardHistory": [
		79249,
		9,
		77425,
		54590,
		79249
	],
	"./componentMobile/Settings/GiftCard/GiftCardHistory.jsx": [
		79249,
		9,
		77425,
		54590,
		79249
	],
	"./componentMobile/Settings/GiftCard/GiftCardList": [
		71969,
		9,
		71969
	],
	"./componentMobile/Settings/GiftCard/GiftCardList.jsx": [
		71969,
		9,
		71969
	],
	"./componentMobile/Settings/GoogleProfile/GoogleAccounts/GoogleAccounts": [
		12966,
		9,
		12966
	],
	"./componentMobile/Settings/GoogleProfile/GoogleAccounts/GoogleAccounts.jsx": [
		12966,
		9,
		12966
	],
	"./componentMobile/Settings/GoogleProfile/GoogleGeneralInfo/GoogleAddressAutoComplete": [
		94726,
		9,
		87086,
		94726
	],
	"./componentMobile/Settings/GoogleProfile/GoogleGeneralInfo/GoogleAddressAutoComplete.jsx": [
		94726,
		9,
		87086,
		94726
	],
	"./componentMobile/Settings/GoogleProfile/GoogleGeneralInfo/GoogleGeneralInfo": [
		21830,
		9,
		87086,
		21830
	],
	"./componentMobile/Settings/GoogleProfile/GoogleGeneralInfo/GoogleGeneralInfo.jsx": [
		21830,
		9,
		87086,
		21830
	],
	"./componentMobile/Settings/GoogleProfile/GoogleHour/GoogleHour": [
		52986,
		9,
		25176,
		52986
	],
	"./componentMobile/Settings/GoogleProfile/GoogleHour/GoogleHour.jsx": [
		52986,
		9,
		25176,
		52986
	],
	"./componentMobile/Settings/GoogleProfile/GoogleHour/GoogleHourSelect": [
		35410,
		9,
		35410
	],
	"./componentMobile/Settings/GoogleProfile/GoogleHour/GoogleHourSelect.jsx": [
		35410,
		9,
		35410
	],
	"./componentMobile/Settings/GoogleProfile/GoogleReviews/GoogleResponseModal": [
		72877,
		9,
		79881,
		72877
	],
	"./componentMobile/Settings/GoogleProfile/GoogleReviews/GoogleResponseModal.jsx": [
		72877,
		9,
		79881,
		72877
	],
	"./componentMobile/Settings/GoogleProfile/GoogleReviews/GoogleReviews": [
		1898,
		9,
		47393,
		40882,
		79881,
		1898
	],
	"./componentMobile/Settings/GoogleProfile/GoogleReviews/GoogleReviews.jsx": [
		1898,
		9,
		47393,
		40882,
		79881,
		1898
	],
	"./componentMobile/Settings/Holidays/HolidaysApppointments": [
		24395,
		9,
		24395
	],
	"./componentMobile/Settings/Holidays/HolidaysApppointments.jsx": [
		24395,
		9,
		24395
	],
	"./componentMobile/Settings/Holidays/HolidaysForm": [
		6541,
		9,
		77425,
		87369,
		6541,
		54890
	],
	"./componentMobile/Settings/Holidays/HolidaysForm.jsx": [
		6541,
		9,
		77425,
		87369,
		6541,
		54890
	],
	"./componentMobile/Settings/Holidays/HolidaysList": [
		93223,
		9,
		93223
	],
	"./componentMobile/Settings/Holidays/HolidaysList.jsx": [
		93223,
		9,
		93223
	],
	"./componentMobile/Settings/Hours/HourForm": [
		14840,
		9,
		14840
	],
	"./componentMobile/Settings/Hours/HourForm.jsx": [
		14840,
		9,
		14840
	],
	"./componentMobile/Settings/Hours/HoursSelect": [
		42003,
		9,
		42003
	],
	"./componentMobile/Settings/Hours/HoursSelect.jsx": [
		42003,
		9,
		42003
	],
	"./componentMobile/Settings/Loyalty/CheckInSettings": [
		12295,
		9,
		85867,
		12295
	],
	"./componentMobile/Settings/Loyalty/CheckInSettings.jsx": [
		12295,
		9,
		85867,
		12295
	],
	"./componentMobile/Settings/Loyalty/LoyaltyConfig": [
		27453,
		9,
		77425,
		27453
	],
	"./componentMobile/Settings/Loyalty/LoyaltyConfig.jsx": [
		27453,
		9,
		77425,
		27453
	],
	"./componentMobile/Settings/Loyalty/LoyaltyFlyers": [
		92661,
		9,
		47393,
		57692,
		26851,
		17584
	],
	"./componentMobile/Settings/Loyalty/LoyaltyFlyers.jsx": [
		92661,
		9,
		47393,
		57692,
		26851,
		17584
	],
	"./componentMobile/Settings/Loyalty/LoyaltyForm": [
		72917,
		9,
		77425,
		97914,
		72917
	],
	"./componentMobile/Settings/Loyalty/LoyaltyForm.jsx": [
		72917,
		9,
		77425,
		97914,
		72917
	],
	"./componentMobile/Settings/Menu/CategoryColumn": [
		14604,
		9,
		85867,
		20300,
		14604
	],
	"./componentMobile/Settings/Menu/CategoryColumn.jsx": [
		14604,
		9,
		85867,
		20300,
		14604
	],
	"./componentMobile/Settings/Menu/CategoryForm": [
		81804,
		9,
		81804
	],
	"./componentMobile/Settings/Menu/CategoryForm.jsx": [
		81804,
		9,
		81804
	],
	"./componentMobile/Settings/Menu/CategoryList": [
		46681,
		9,
		20300,
		69062
	],
	"./componentMobile/Settings/Menu/CategoryList.jsx": [
		46681,
		9,
		20300,
		69062
	],
	"./componentMobile/Settings/Menu/CategoryModal": [
		55051,
		9,
		55051
	],
	"./componentMobile/Settings/Menu/CategoryModal.jsx": [
		55051,
		9,
		55051
	],
	"./componentMobile/Settings/Menu/ComboDetailContainer": [
		51563,
		9,
		97914,
		85867,
		67075,
		6775,
		52095,
		87744
	],
	"./componentMobile/Settings/Menu/ComboDetailContainer.jsx": [
		51563,
		9,
		97914,
		85867,
		67075,
		6775,
		52095,
		87744
	],
	"./componentMobile/Settings/Menu/ComboDetailForm": [
		52095,
		9,
		97914,
		85867,
		52095,
		62237
	],
	"./componentMobile/Settings/Menu/ComboDetailForm.jsx": [
		52095,
		9,
		97914,
		85867,
		52095,
		62237
	],
	"./componentMobile/Settings/Menu/ComboResources": [
		35359,
		9,
		97914,
		67075,
		6775,
		35359
	],
	"./componentMobile/Settings/Menu/ComboResources.jsx": [
		35359,
		9,
		97914,
		67075,
		6775,
		35359
	],
	"./componentMobile/Settings/Menu/ComboServiceForm": [
		80031,
		9,
		97914,
		80031
	],
	"./componentMobile/Settings/Menu/ComboServiceForm.jsx": [
		80031,
		9,
		97914,
		80031
	],
	"./componentMobile/Settings/Menu/MenuContainer": [
		73426,
		9,
		85867,
		20300,
		73426
	],
	"./componentMobile/Settings/Menu/MenuContainer.jsx": [
		73426,
		9,
		85867,
		20300,
		73426
	],
	"./componentMobile/Settings/Menu/ResourcesList": [
		6775,
		9,
		97914,
		67075,
		6775
	],
	"./componentMobile/Settings/Menu/ResourcesList.jsx": [
		6775,
		9,
		97914,
		67075,
		6775
	],
	"./componentMobile/Settings/Menu/ServiceAddOnsList": [
		11876,
		9,
		85867,
		11876
	],
	"./componentMobile/Settings/Menu/ServiceAddOnsList.jsx": [
		11876,
		9,
		85867,
		11876
	],
	"./componentMobile/Settings/Menu/ServiceColumn": [
		68703,
		9,
		85867,
		20300,
		68703
	],
	"./componentMobile/Settings/Menu/ServiceColumn.jsx": [
		68703,
		9,
		85867,
		20300,
		68703
	],
	"./componentMobile/Settings/Menu/ServiceDetailContainer": [
		53681,
		9,
		97914,
		85867,
		67075,
		6775,
		53681,
		56907
	],
	"./componentMobile/Settings/Menu/ServiceDetailContainer.jsx": [
		53681,
		9,
		97914,
		85867,
		67075,
		6775,
		53681,
		56907
	],
	"./componentMobile/Settings/Menu/ServiceDetailForm": [
		11416,
		9,
		97914,
		85867,
		11416
	],
	"./componentMobile/Settings/Menu/ServiceDetailForm.jsx": [
		11416,
		9,
		97914,
		85867,
		11416
	],
	"./componentMobile/Settings/Menu/ServiceList": [
		50213,
		9,
		85867,
		20300,
		50213
	],
	"./componentMobile/Settings/Menu/ServiceList.jsx": [
		50213,
		9,
		85867,
		20300,
		50213
	],
	"./componentMobile/Settings/Menu/ServiceResources": [
		56058,
		9,
		97914,
		67075,
		6775,
		56058
	],
	"./componentMobile/Settings/Menu/ServiceResources.jsx": [
		56058,
		9,
		97914,
		67075,
		6775,
		56058
	],
	"./componentMobile/Settings/Menu/ServiceStaffDuration": [
		53895,
		9,
		85867,
		53895
	],
	"./componentMobile/Settings/Menu/ServiceStaffDuration.jsx": [
		53895,
		9,
		85867,
		53895
	],
	"./componentMobile/Settings/Menu/ServiceStaffDurationForm": [
		59057,
		9,
		85867,
		59057
	],
	"./componentMobile/Settings/Menu/ServiceStaffDurationForm.jsx": [
		59057,
		9,
		85867,
		59057
	],
	"./componentMobile/Settings/Menu/ServiceStaffs": [
		81012,
		9,
		81012
	],
	"./componentMobile/Settings/Menu/ServiceStaffs.jsx": [
		81012,
		9,
		81012
	],
	"./componentMobile/Settings/Menu/ServiceTaxes": [
		70614,
		9,
		70614
	],
	"./componentMobile/Settings/Menu/ServiceTaxes.jsx": [
		70614,
		9,
		70614
	],
	"./componentMobile/Settings/NewGiftCard/GiftCardForm": [
		39615,
		9,
		77425,
		97914,
		54590,
		39615
	],
	"./componentMobile/Settings/NewGiftCard/GiftCardForm.jsx": [
		39615,
		9,
		77425,
		97914,
		54590,
		39615
	],
	"./componentMobile/Settings/PaymentIntegration/TerminalOrderModal": [
		43734,
		9,
		47393,
		69938,
		37884
	],
	"./componentMobile/Settings/PaymentIntegration/TerminalOrderModal.jsx": [
		43734,
		9,
		47393,
		69938,
		37884
	],
	"./componentMobile/Settings/Poynt/PoyntTerminals": [
		78336,
		9,
		77425,
		54590,
		78336
	],
	"./componentMobile/Settings/Poynt/PoyntTerminals.jsx": [
		78336,
		9,
		77425,
		54590,
		78336
	],
	"./componentMobile/Settings/Products/ProductCaregoryColumn": [
		31164,
		9,
		85867,
		20300,
		31164
	],
	"./componentMobile/Settings/Products/ProductCaregoryColumn.jsx": [
		31164,
		9,
		85867,
		20300,
		31164
	],
	"./componentMobile/Settings/Products/ProductCategoryForm": [
		24410,
		9,
		85867,
		24410
	],
	"./componentMobile/Settings/Products/ProductCategoryForm.jsx": [
		24410,
		9,
		85867,
		24410
	],
	"./componentMobile/Settings/Products/ProductCategoryList": [
		99260,
		9,
		20300,
		99260
	],
	"./componentMobile/Settings/Products/ProductCategoryList.jsx": [
		99260,
		9,
		20300,
		99260
	],
	"./componentMobile/Settings/Products/ProductForm": [
		45246,
		9,
		97914,
		85867,
		59221,
		45246
	],
	"./componentMobile/Settings/Products/ProductForm.jsx": [
		45246,
		9,
		97914,
		85867,
		59221,
		45246
	],
	"./componentMobile/Settings/Products/ProductList": [
		18552,
		9,
		20300,
		18552
	],
	"./componentMobile/Settings/Products/ProductList.jsx": [
		18552,
		9,
		20300,
		18552
	],
	"./componentMobile/Settings/Products/ProductManage/ProductHistory": [
		49370,
		9,
		49370
	],
	"./componentMobile/Settings/Products/ProductManage/ProductHistory.jsx": [
		49370,
		9,
		49370
	],
	"./componentMobile/Settings/Products/ProductManage/ProductStock": [
		37747,
		9,
		97914,
		37747
	],
	"./componentMobile/Settings/Products/ProductManage/ProductStock.jsx": [
		37747,
		9,
		97914,
		37747
	],
	"./componentMobile/Settings/Products/ProductManage/ProductSupplierInfo": [
		85737,
		9,
		59221,
		85737
	],
	"./componentMobile/Settings/Products/ProductManage/ProductSupplierInfo.jsx": [
		85737,
		9,
		59221,
		85737
	],
	"./componentMobile/Settings/Products/ProductManageModal": [
		56450,
		9,
		97914,
		59221,
		56450
	],
	"./componentMobile/Settings/Products/ProductManageModal.jsx": [
		56450,
		9,
		97914,
		59221,
		56450
	],
	"./componentMobile/Settings/Promotions/DefaultEmailPromotion/DefaultClientEmailFilter": [
		88172,
		9,
		97914,
		87369,
		88172
	],
	"./componentMobile/Settings/Promotions/DefaultEmailPromotion/DefaultClientEmailFilter.jsx": [
		88172,
		9,
		97914,
		87369,
		88172
	],
	"./componentMobile/Settings/Promotions/DefaultEmailPromotion/DefaultPromotionEmailPreviewer": [
		9944,
		9,
		97914,
		87369,
		87563,
		6823
	],
	"./componentMobile/Settings/Promotions/DefaultEmailPromotion/DefaultPromotionEmailPreviewer.jsx": [
		9944,
		9,
		97914,
		87369,
		87563,
		6823
	],
	"./componentMobile/Settings/Promotions/EmailPromotion/ClientEmailFilter": [
		81300,
		9,
		97914,
		87369,
		57692,
		12179,
		81300,
		86246
	],
	"./componentMobile/Settings/Promotions/EmailPromotion/ClientEmailFilter.jsx": [
		81300,
		9,
		97914,
		87369,
		57692,
		12179,
		81300,
		86246
	],
	"./componentMobile/Settings/Promotions/EmailPromotion/PromotionEmailPreviewer": [
		85491,
		9,
		97914,
		87369,
		9540,
		57692,
		26851,
		12179,
		57332,
		11032,
		81300,
		76795
	],
	"./componentMobile/Settings/Promotions/EmailPromotion/PromotionEmailPreviewer.jsx": [
		85491,
		9,
		97914,
		87369,
		9540,
		57692,
		26851,
		12179,
		57332,
		11032,
		81300,
		76795
	],
	"./componentMobile/Settings/Promotions/PromotionsAutoSms": [
		1989,
		9,
		1989
	],
	"./componentMobile/Settings/Promotions/PromotionsAutoSms.jsx": [
		1989,
		9,
		1989
	],
	"./componentMobile/Settings/Promotions/PromotionsAutoSmsDetail": [
		43622,
		9,
		59221,
		43622
	],
	"./componentMobile/Settings/Promotions/PromotionsAutoSmsDetail.jsx": [
		43622,
		9,
		59221,
		43622
	],
	"./componentMobile/Settings/Promotions/PromotionsClientFilter": [
		86537,
		9,
		97914,
		87369,
		57692,
		12179,
		21317,
		8918
	],
	"./componentMobile/Settings/Promotions/PromotionsClientFilter.jsx": [
		86537,
		9,
		97914,
		87369,
		57692,
		12179,
		21317,
		8918
	],
	"./componentMobile/Settings/Promotions/PromotionsDetails": [
		18827,
		9,
		77425,
		97914,
		85867,
		87369,
		57692,
		12179,
		21317,
		18827,
		98826
	],
	"./componentMobile/Settings/Promotions/PromotionsDetails.jsx": [
		18827,
		9,
		77425,
		97914,
		85867,
		87369,
		57692,
		12179,
		21317,
		18827,
		98826
	],
	"./componentMobile/Settings/Promotions/PromotionsForm": [
		58715,
		9,
		77425,
		97914,
		85867,
		87369,
		58715
	],
	"./componentMobile/Settings/Promotions/PromotionsForm.jsx": [
		58715,
		9,
		77425,
		97914,
		85867,
		87369,
		58715
	],
	"./componentMobile/Settings/Promotions/PromotionsList": [
		71797,
		9,
		71797
	],
	"./componentMobile/Settings/Promotions/PromotionsList.jsx": [
		71797,
		9,
		71797
	],
	"./componentMobile/Settings/Promotions/PromotionsServices": [
		29813,
		9,
		85867,
		29813
	],
	"./componentMobile/Settings/Promotions/PromotionsServices.jsx": [
		29813,
		9,
		85867,
		29813
	],
	"./componentMobile/Settings/Sms/SmsSettingsForm": [
		12822,
		9,
		12822
	],
	"./componentMobile/Settings/Sms/SmsSettingsForm.jsx": [
		12822,
		9,
		12822
	],
	"./componentMobile/Settings/Staffs/AssignStaffOptions": [
		5301,
		9,
		77425,
		97914,
		5301,
		63991
	],
	"./componentMobile/Settings/Staffs/AssignStaffOptions.jsx": [
		5301,
		9,
		77425,
		97914,
		5301,
		63991
	],
	"./componentMobile/Settings/Staffs/ServiceStaffSpecialDurationForm": [
		2876,
		9,
		2876
	],
	"./componentMobile/Settings/Staffs/ServiceStaffSpecialDurationForm.jsx": [
		2876,
		9,
		2876
	],
	"./componentMobile/Settings/Staffs/ShiftForm": [
		90318,
		9,
		90318
	],
	"./componentMobile/Settings/Staffs/ShiftForm.jsx": [
		90318,
		9,
		90318
	],
	"./componentMobile/Settings/Staffs/StaffContactForm": [
		78030,
		9,
		97914,
		85867,
		59221,
		9540,
		57692,
		26851,
		61580,
		78030
	],
	"./componentMobile/Settings/Staffs/StaffContactForm.jsx": [
		78030,
		9,
		97914,
		85867,
		59221,
		9540,
		57692,
		26851,
		61580,
		78030
	],
	"./componentMobile/Settings/Staffs/StaffHours": [
		64041,
		9,
		64041
	],
	"./componentMobile/Settings/Staffs/StaffHours.jsx": [
		64041,
		9,
		64041
	],
	"./componentMobile/Settings/Staffs/StaffImage": [
		18231,
		9,
		9540,
		57692,
		26851,
		61580,
		18231
	],
	"./componentMobile/Settings/Staffs/StaffImage.jsx": [
		18231,
		9,
		9540,
		57692,
		26851,
		61580,
		18231
	],
	"./componentMobile/Settings/Staffs/StaffListDragDrop": [
		47667,
		9,
		20300,
		47667
	],
	"./componentMobile/Settings/Staffs/StaffListDragDrop.jsx": [
		47667,
		9,
		20300,
		47667
	],
	"./componentMobile/Settings/Staffs/StaffServiceSpecialDuration": [
		95544,
		9,
		85867,
		95544
	],
	"./componentMobile/Settings/Staffs/StaffServiceSpecialDuration.jsx": [
		95544,
		9,
		85867,
		95544
	],
	"./componentMobile/Settings/Staffs/StaffServices": [
		89530,
		9,
		89530
	],
	"./componentMobile/Settings/Staffs/StaffServices.jsx": [
		89530,
		9,
		89530
	],
	"./componentMobile/Settings/Staffs/StaffWorkingDetails": [
		4491,
		7,
		4491
	],
	"./componentMobile/Settings/Staffs/StaffWorkingDetails.jsx": [
		4491,
		7,
		4491
	],
	"./componentMobile/Settings/Taxes/TaxForm": [
		57033,
		9,
		97914,
		57033
	],
	"./componentMobile/Settings/Taxes/TaxForm.jsx": [
		57033,
		9,
		97914,
		57033
	],
	"./componentMobile/Settings/Taxes/TaxList": [
		83915,
		9,
		83915
	],
	"./componentMobile/Settings/Taxes/TaxList.jsx": [
		83915,
		9,
		83915
	],
	"./componentMobile/TimeClock/AddTimeClock": [
		25966,
		9,
		87369,
		25966
	],
	"./componentMobile/TimeClock/AddTimeClock.jsx": [
		25966,
		9,
		87369,
		25966
	],
	"./componentMobile/TimeClock/TimeClockContainer": [
		28674,
		9,
		85867,
		87369,
		62915,
		28674,
		73519
	],
	"./componentMobile/TimeClock/TimeClockContainer.jsx": [
		28674,
		9,
		85867,
		87369,
		62915,
		28674,
		73519
	],
	"./componentMobile/TimeClock/TimeClockHistory": [
		62915,
		9,
		85867,
		62915
	],
	"./componentMobile/TimeClock/TimeClockHistory.jsx": [
		62915,
		9,
		85867,
		62915
	],
	"./componentMobile/TimeClock/TimeClockStaff": [
		40537,
		9,
		87369,
		40537
	],
	"./componentMobile/TimeClock/TimeClockStaff.jsx": [
		40537,
		9,
		87369,
		40537
	],
	"./componentMobile/common/ClientTypeIcon/ClientTypeIcon": [
		6585,
		9,
		6585
	],
	"./componentMobile/common/ClientTypeIcon/ClientTypeIcon.jsx": [
		6585,
		9,
		6585
	],
	"./componentMobile/common/Icons/Icons": [
		13027,
		9,
		13027
	],
	"./componentMobile/common/Icons/Icons.jsx": [
		13027,
		9,
		13027
	],
	"./componentMobile/common/Loading/Loading": [
		51523,
		9,
		51523
	],
	"./componentMobile/common/Loading/Loading.css": [
		26950,
		9,
		26950
	],
	"./componentMobile/common/Loading/Loading.jsx": [
		51523,
		9,
		51523
	],
	"./componentMobile/common/MessageError/MessageError": [
		60503,
		9,
		60503
	],
	"./componentMobile/common/MessageError/MessageError.jsx": [
		60503,
		9,
		60503
	],
	"./componentMobile/common/MessageError/NewMessageError": [
		98515,
		9,
		98515
	],
	"./componentMobile/common/MessageError/NewMessageError.jsx": [
		98515,
		9,
		98515
	],
	"./componentMobile/common/ModalFullPage/ModalFullPage": [
		73903,
		9,
		73903
	],
	"./componentMobile/common/ModalFullPage/ModalFullPage.jsx": [
		73903,
		9,
		73903
	],
	"./componentMobile/common/MonthDate/MonthDate": [
		57311,
		9,
		57311
	],
	"./componentMobile/common/MonthDate/MonthDate.jsx": [
		57311,
		9,
		57311
	],
	"./index": [
		72812,
		9
	],
	"./index.css": [
		59555,
		9
	],
	"./index.js": [
		72812,
		9
	],
	"./layouts/Content/ClearLocalStorage": [
		98621,
		9
	],
	"./layouts/Content/ClearLocalStorage.jsx": [
		98621,
		9
	],
	"./layouts/Content/ContentContainer": [
		76612,
		9
	],
	"./layouts/Content/ContentContainer.jsx": [
		76612,
		9
	],
	"./layouts/Navigation/DashBookingLogo": [
		61641,
		9
	],
	"./layouts/Navigation/DashBookingLogo.jsx": [
		61641,
		9
	],
	"./layouts/Navigation/MenuContainer": [
		24688,
		9
	],
	"./layouts/Navigation/MenuContainer.css": [
		88038,
		9
	],
	"./layouts/Navigation/MenuContainer.jsx": [
		24688,
		9
	],
	"./layouts/Navigation/PageHeader/AccountSetting": [
		61039,
		9
	],
	"./layouts/Navigation/PageHeader/AccountSetting.jsx": [
		61039,
		9
	],
	"./layouts/Navigation/PageHeader/Locations": [
		5466,
		9
	],
	"./layouts/Navigation/PageHeader/Locations.jsx": [
		5466,
		9
	],
	"./layouts/Navigation/PageHeader/Notifications": [
		22194,
		9
	],
	"./layouts/Navigation/PageHeader/Notifications.jsx": [
		22194,
		9
	],
	"./layouts/Navigation/PageHeader/PageHeaderContainer": [
		1481,
		9
	],
	"./layouts/Navigation/PageHeader/PageHeaderContainer.jsx": [
		1481,
		9
	],
	"./layouts/Navigation/PageHeader/notification-sound.wav": [
		98981,
		1,
		98981
	],
	"./layouts/Navigation/PageHeader/sms_notification.mp3": [
		75809,
		1
	],
	"./layouts/Navigation/SideMenu": [
		7545,
		9
	],
	"./layouts/Navigation/SideMenu.jsx": [
		7545,
		9
	],
	"./logo.svg": [
		69445,
		1,
		69445
	],
	"./page/Account/Profile": [
		75317,
		9,
		59221,
		75317
	],
	"./page/Account/Profile.css": [
		20348,
		9,
		20348
	],
	"./page/Account/Profile.jsx": [
		75317,
		9,
		59221,
		75317
	],
	"./page/AccountActivation/AccountActivation": [
		79135,
		9
	],
	"./page/AccountActivation/AccountActivation.css": [
		10394,
		9,
		10394
	],
	"./page/AccountActivation/AccountActivation.jsx": [
		79135,
		9
	],
	"./page/AccountActivation/ActivationModal": [
		61293,
		9
	],
	"./page/AccountActivation/ActivationModal.jsx": [
		61293,
		9
	],
	"./page/Appointment/AppoimentBlockTime/AppointmentBlockTime": [
		69315,
		9,
		85867,
		87369,
		69315
	],
	"./page/Appointment/AppoimentBlockTime/AppointmentBlockTime.jsx": [
		69315,
		9,
		85867,
		87369,
		69315
	],
	"./page/Appointment/AppointmentCalendar/AppointmentCalendar": [
		76257,
		9,
		85867,
		59221,
		87369,
		846,
		9540,
		89596,
		76257
	],
	"./page/Appointment/AppointmentCalendar/AppointmentCalendar.jsx": [
		76257,
		9,
		85867,
		59221,
		87369,
		846,
		9540,
		89596,
		76257
	],
	"./page/Appointment/AppointmentCalendar/appointmentCalendar.css": [
		8204,
		9,
		8204
	],
	"./page/Appointment/AppointmentRoutes": [
		43097,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		93141,
		846,
		70712,
		9540,
		42104,
		47393,
		11542,
		57332,
		76702,
		36571,
		90115,
		79881,
		48885,
		87753,
		76422,
		14893,
		94349,
		31027,
		91723,
		44183,
		72854,
		6944,
		766,
		72145
	],
	"./page/Appointment/AppointmentRoutes.jsx": [
		43097,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		93141,
		846,
		70712,
		9540,
		42104,
		47393,
		11542,
		57332,
		76702,
		36571,
		90115,
		79881,
		48885,
		87753,
		76422,
		14893,
		94349,
		31027,
		91723,
		44183,
		72854,
		6944,
		766,
		72145
	],
	"./page/Appointment/CreateAppointment/CreateNewAppointment": [
		16469,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		14893,
		766,
		51866
	],
	"./page/Appointment/CreateAppointment/CreateNewAppointment.jsx": [
		16469,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		14893,
		766,
		51866
	],
	"./page/Appointment/CreateWalkedinAppointment/CreateWalkedInAppointment": [
		98153,
		9,
		97914,
		85867,
		59221,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		94106,
		87445
	],
	"./page/Appointment/CreateWalkedinAppointment/CreateWalkedInAppointment.jsx": [
		98153,
		9,
		97914,
		85867,
		59221,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		94106,
		87445
	],
	"./page/Appointment/EditAppointment/EditAppointment": [
		83789,
		9,
		97914,
		85867,
		59221,
		87369,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		14893,
		72854,
		66128
	],
	"./page/Appointment/EditAppointment/EditAppointment.jsx": [
		83789,
		9,
		97914,
		85867,
		59221,
		87369,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		14893,
		72854,
		66128
	],
	"./page/Appointment/NewAppointmentCalendar/AppointmentCard": [
		32401,
		9,
		85867,
		59221,
		846,
		32401
	],
	"./page/Appointment/NewAppointmentCalendar/AppointmentCard.jsx": [
		32401,
		9,
		85867,
		59221,
		846,
		32401
	],
	"./page/Appointment/NewAppointmentCalendar/AppointmentIcons": [
		87485,
		9,
		87485
	],
	"./page/Appointment/NewAppointmentCalendar/AppointmentIcons.jsx": [
		87485,
		9,
		87485
	],
	"./page/Appointment/NewAppointmentCalendar/ConfirmAppointmentChange": [
		35973,
		9,
		35973
	],
	"./page/Appointment/NewAppointmentCalendar/ConfirmAppointmentChange.jsx": [
		35973,
		9,
		35973
	],
	"./page/Appointment/NewAppointmentCalendar/DragDropAppointmentList": [
		6944,
		9,
		85867,
		59221,
		846,
		36571,
		6944,
		98257
	],
	"./page/Appointment/NewAppointmentCalendar/DragDropAppointmentList.jsx": [
		6944,
		9,
		85867,
		59221,
		846,
		36571,
		6944,
		98257
	],
	"./page/Appointment/NewAppointmentCalendar/HourCanva": [
		56011,
		9,
		56011
	],
	"./page/Appointment/NewAppointmentCalendar/HourCanva.jsx": [
		56011,
		9,
		56011
	],
	"./page/Appointment/NewAppointmentCalendar/NewAppointmentCalendar": [
		39257,
		9,
		77425,
		85867,
		59221,
		54590,
		87369,
		846,
		9540,
		36571,
		6944,
		59109
	],
	"./page/Appointment/NewAppointmentCalendar/NewAppointmentCalendar.jsx": [
		39257,
		9,
		77425,
		85867,
		59221,
		54590,
		87369,
		846,
		9540,
		36571,
		6944,
		59109
	],
	"./page/Appointment/NewAppointmentCalendar/NewCurrentTimeIndicator": [
		51173,
		9,
		51173
	],
	"./page/Appointment/NewAppointmentCalendar/NewCurrentTimeIndicator.jsx": [
		51173,
		9,
		51173
	],
	"./page/Appointment/NewAppointmentCalendar/dragAndDropStyle.css": [
		30770,
		9,
		30770
	],
	"./page/Appointment/NewAppointmentCalendar/newAppointmentCalendar.css": [
		95776,
		9,
		95776
	],
	"./page/Appointment/RebookAppointment/RebookAppointment": [
		79617,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		14893,
		63810,
		63699
	],
	"./page/Appointment/RebookAppointment/RebookAppointment.jsx": [
		79617,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		846,
		70712,
		9540,
		11542,
		90115,
		48885,
		14893,
		63810,
		63699
	],
	"./page/Appointment/ViewAppointment/ViewAppointmentPage": [
		58648,
		9,
		97914,
		85867,
		59221,
		93141,
		846,
		70712,
		9540,
		47393,
		11542,
		76702,
		90115,
		79881,
		48885,
		87753,
		76422,
		94349,
		94787
	],
	"./page/Appointment/ViewAppointment/ViewAppointmentPage.css": [
		85257,
		9,
		85257
	],
	"./page/Appointment/ViewAppointment/ViewAppointmentPage.jsx": [
		58648,
		9,
		97914,
		85867,
		59221,
		93141,
		846,
		70712,
		9540,
		47393,
		11542,
		76702,
		90115,
		79881,
		48885,
		87753,
		76422,
		94349,
		94787
	],
	"./page/Appointment/ViewPassedAppointment/ViewPassedAppointment": [
		22009,
		9,
		97914,
		85867,
		59221,
		93141,
		846,
		70712,
		9540,
		47393,
		11542,
		76702,
		90115,
		79881,
		48885,
		87753,
		76422,
		94349,
		43158
	],
	"./page/Appointment/ViewPassedAppointment/ViewPassedAppointment.jsx": [
		22009,
		9,
		97914,
		85867,
		59221,
		93141,
		846,
		70712,
		9540,
		47393,
		11542,
		76702,
		90115,
		79881,
		48885,
		87753,
		76422,
		94349,
		43158
	],
	"./page/CalendarPage/AppointmentCard": [
		31027,
		9,
		85867,
		59221,
		846,
		31027,
		92564
	],
	"./page/CalendarPage/AppointmentCard.jsx": [
		31027,
		9,
		85867,
		59221,
		846,
		31027,
		92564
	],
	"./page/CalendarPage/AppointmentIcons": [
		58555,
		9,
		58555
	],
	"./page/CalendarPage/AppointmentIcons.jsx": [
		58555,
		9,
		58555
	],
	"./page/CalendarPage/BlockedTimeCard": [
		12319,
		9,
		12319
	],
	"./page/CalendarPage/BlockedTimeCard.jsx": [
		12319,
		9,
		12319
	],
	"./page/CalendarPage/CalendarAlert": [
		34554,
		9,
		34554
	],
	"./page/CalendarPage/CalendarAlert.jsx": [
		34554,
		9,
		34554
	],
	"./page/CalendarPage/CalendarDuplicateModal": [
		74480,
		9,
		77425,
		87369,
		74480
	],
	"./page/CalendarPage/CalendarDuplicateModal.jsx": [
		74480,
		9,
		77425,
		87369,
		74480
	],
	"./page/CalendarPage/CalendarPage": [
		44183,
		9,
		77425,
		85867,
		59221,
		87369,
		846,
		9540,
		42104,
		57332,
		31027,
		91723,
		44183,
		90241
	],
	"./page/CalendarPage/CalendarPage.jsx": [
		44183,
		9,
		77425,
		85867,
		59221,
		87369,
		846,
		9540,
		42104,
		57332,
		31027,
		91723,
		44183,
		90241
	],
	"./page/CalendarPage/CalendarToolbar": [
		1945,
		9,
		87369,
		9540,
		57332,
		1945
	],
	"./page/CalendarPage/CalendarToolbar.jsx": [
		1945,
		9,
		87369,
		9540,
		57332,
		1945
	],
	"./page/CalendarPage/Calendarpageexample": [
		90041,
		9,
		77425,
		85867,
		59221,
		87369,
		846,
		9540,
		42104,
		57332,
		31027,
		91723,
		44183,
		13945
	],
	"./page/CalendarPage/Calendarpageexample.jsx": [
		90041,
		9,
		77425,
		85867,
		59221,
		87369,
		846,
		9540,
		42104,
		57332,
		31027,
		91723,
		44183,
		13945
	],
	"./page/CalendarPage/ConfirmAppointmentChangeModal": [
		30996,
		9,
		30996
	],
	"./page/CalendarPage/ConfirmAppointmentChangeModal.jsx": [
		30996,
		9,
		30996
	],
	"./page/CalendarPage/ConfirmWeekMoveModal": [
		54346,
		9,
		54346
	],
	"./page/CalendarPage/ConfirmWeekMoveModal.jsx": [
		54346,
		9,
		54346
	],
	"./page/CalendarPage/NowTimeBar": [
		37678,
		9,
		37678
	],
	"./page/CalendarPage/NowTimeBar.jsx": [
		37678,
		9,
		37678
	],
	"./page/CalendarPage/WeekView": [
		91723,
		9,
		85867,
		59221,
		846,
		31027,
		91723,
		70183
	],
	"./page/CalendarPage/WeekView.jsx": [
		91723,
		9,
		85867,
		59221,
		846,
		31027,
		91723,
		70183
	],
	"./page/CheckedIn/CheckedIn": [
		86743,
		9,
		9540,
		20300,
		97787,
		86743
	],
	"./page/CheckedIn/CheckedIn.css": [
		71202,
		9,
		71202
	],
	"./page/CheckedIn/CheckedIn.jsx": [
		86743,
		9,
		9540,
		20300,
		97787,
		86743
	],
	"./page/Checkout/Checkout": [
		54749,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		70712,
		9540,
		361,
		42104,
		71443,
		18630,
		90115,
		82146,
		51215,
		35467,
		74851,
		1798,
		54749
	],
	"./page/Checkout/Checkout.css": [
		53812,
		9,
		53812
	],
	"./page/Checkout/Checkout.jsx": [
		54749,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		70712,
		9540,
		361,
		42104,
		71443,
		18630,
		90115,
		82146,
		51215,
		35467,
		74851,
		1798,
		54749
	],
	"./page/Client/ClientCreateContainer/ClientCreateContainer": [
		73089,
		9,
		59221,
		70712,
		9817
	],
	"./page/Client/ClientCreateContainer/ClientCreateContainer.jsx": [
		73089,
		9,
		59221,
		70712,
		9817
	],
	"./page/Client/ClientDetailContainer/ClientDetailContainer": [
		29025,
		9,
		97914,
		59221,
		846,
		70712,
		9540,
		47866,
		90115,
		35467,
		29025,
		32550
	],
	"./page/Client/ClientDetailContainer/ClientDetailContainer.jsx": [
		29025,
		9,
		97914,
		59221,
		846,
		70712,
		9540,
		47866,
		90115,
		35467,
		29025,
		32550
	],
	"./page/Client/ClientRoutes": [
		44089,
		9,
		77425,
		97914,
		59221,
		54590,
		87369,
		846,
		70712,
		9540,
		12536,
		47866,
		90115,
		35467,
		63284,
		29025,
		44089
	],
	"./page/Client/ClientRoutes.jsx": [
		44089,
		9,
		77425,
		97914,
		59221,
		54590,
		87369,
		846,
		70712,
		9540,
		12536,
		47866,
		90115,
		35467,
		63284,
		29025,
		44089
	],
	"./page/Client/ClientSearchContainer/ClientSearchContainer": [
		37433,
		9,
		77425,
		97914,
		59221,
		54590,
		87369,
		12536,
		63284,
		11105
	],
	"./page/Client/ClientSearchContainer/ClientSearchContainer.jsx": [
		37433,
		9,
		77425,
		97914,
		59221,
		54590,
		87369,
		12536,
		63284,
		11105
	],
	"./page/FastCheckOut/FastCheckOut": [
		63277,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		12959,
		82146,
		51215,
		30394,
		54155,
		27563,
		63277
	],
	"./page/FastCheckOut/FastCheckOut.jsx": [
		63277,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		12959,
		82146,
		51215,
		30394,
		54155,
		27563,
		63277
	],
	"./page/ForgotPassword/ForgotPassword": [
		41253,
		9
	],
	"./page/ForgotPassword/ForgotPassword.jsx": [
		41253,
		9
	],
	"./page/ForgotPassword/ResetPassword": [
		68233,
		9
	],
	"./page/ForgotPassword/ResetPassword.jsx": [
		68233,
		9
	],
	"./page/ForgotPassword/resetPassword.css": [
		87686,
		9
	],
	"./page/GiftCardHistory/GiftCardHistory": [
		81087,
		9,
		77425,
		97914,
		54590,
		87369,
		73183,
		81087
	],
	"./page/GiftCardHistory/GiftCardHistory.jsx": [
		81087,
		9,
		77425,
		97914,
		54590,
		87369,
		73183,
		81087
	],
	"./page/History/History": [
		22015,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		93141,
		846,
		26989,
		17867,
		82291,
		20691,
		27841,
		10370,
		56672,
		18872,
		79881,
		87753,
		6124,
		51190,
		30893,
		75079,
		22015
	],
	"./page/History/History.css": [
		25082,
		9,
		25082
	],
	"./page/History/History.jsx": [
		22015,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		93141,
		846,
		26989,
		17867,
		82291,
		20691,
		27841,
		10370,
		56672,
		18872,
		79881,
		87753,
		6124,
		51190,
		30893,
		75079,
		22015
	],
	"./page/Invoice/EditInvoice": [
		49675,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		48618,
		82146,
		51215,
		79038,
		48232,
		49675
	],
	"./page/Invoice/EditInvoice.jsx": [
		49675,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		48618,
		82146,
		51215,
		79038,
		48232,
		49675
	],
	"./page/Invoice/Invoice": [
		24255,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		9540,
		361,
		42104,
		71443,
		18630,
		90115,
		82146,
		51215,
		35467,
		74851,
		30394,
		62366,
		21753,
		24255
	],
	"./page/Invoice/Invoice.jsx": [
		24255,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		9540,
		361,
		42104,
		71443,
		18630,
		90115,
		82146,
		51215,
		35467,
		74851,
		30394,
		62366,
		21753,
		24255
	],
	"./page/Invoice/invoice.css": [
		32666,
		9,
		32666
	],
	"./page/Login/Login": [
		35019,
		9
	],
	"./page/Login/Login.jsx": [
		35019,
		9
	],
	"./page/Login/login.css": [
		10846,
		9,
		10846
	],
	"./page/MetaSocialMedia/MetaSocialMedia": [
		83311,
		9,
		77425,
		87369,
		47393,
		57692,
		26851,
		69938,
		79638,
		98213,
		3462,
		47338,
		83311
	],
	"./page/MetaSocialMedia/MetaSocialMedia.jsx": [
		83311,
		9,
		77425,
		87369,
		47393,
		57692,
		26851,
		69938,
		79638,
		98213,
		3462,
		47338,
		83311
	],
	"./page/PinAuth/PinAuth": [
		96363,
		9,
		96363
	],
	"./page/PinAuth/PinAuth.jsx": [
		96363,
		9,
		96363
	],
	"./page/Referral/Referral": [
		82879,
		9,
		59221,
		82879
	],
	"./page/Referral/Referral.jsx": [
		82879,
		9,
		59221,
		82879
	],
	"./page/Report/Billing": [
		40186,
		9,
		77425,
		59221,
		54590,
		93141,
		20691,
		74030,
		40186
	],
	"./page/Report/Billing.css": [
		6909,
		9,
		6909
	],
	"./page/Report/Billing.jsx": [
		40186,
		9,
		77425,
		59221,
		54590,
		93141,
		20691,
		74030,
		40186
	],
	"./page/Report/ClientsStats": [
		41202,
		9,
		26989,
		17867,
		82291,
		60163,
		41202
	],
	"./page/Report/ClientsStats.jsx": [
		41202,
		9,
		26989,
		17867,
		82291,
		60163,
		41202
	],
	"./page/Report/Sales": [
		59795,
		9,
		59795
	],
	"./page/Report/Sales.jsx": [
		59795,
		9,
		59795
	],
	"./page/Settings/AiReceptionist/AiReceptionist": [
		12711,
		9,
		77425,
		85867,
		59221,
		26989,
		65701,
		22947,
		79377,
		21635
	],
	"./page/Settings/AiReceptionist/AiReceptionist.jsx": [
		12711,
		9,
		77425,
		85867,
		59221,
		26989,
		65701,
		22947,
		79377,
		21635
	],
	"./page/Settings/Appointment/AppointmentSettings": [
		17816,
		9,
		59221,
		93141,
		91614,
		9047,
		72191
	],
	"./page/Settings/Appointment/AppointmentSettings.jsx": [
		17816,
		9,
		59221,
		93141,
		91614,
		9047,
		72191
	],
	"./page/Settings/ClientType/ClientType": [
		43939,
		9,
		97914,
		43939
	],
	"./page/Settings/ClientType/ClientType.jsx": [
		43939,
		9,
		97914,
		43939
	],
	"./page/Settings/Clover/CloverIntergration": [
		64363,
		9,
		361,
		82146,
		64363
	],
	"./page/Settings/Clover/CloverIntergration.jsx": [
		64363,
		9,
		361,
		82146,
		64363
	],
	"./page/Settings/Clover/NewCloverSettings": [
		80484,
		9,
		77425,
		97914,
		54590,
		80484
	],
	"./page/Settings/Clover/NewCloverSettings.jsx": [
		80484,
		9,
		77425,
		97914,
		54590,
		80484
	],
	"./page/Settings/Deposit/Deposit": [
		9343,
		9,
		77425,
		97914,
		59221,
		54590,
		9343
	],
	"./page/Settings/Deposit/Deposit.jsx": [
		9343,
		9,
		77425,
		97914,
		59221,
		54590,
		9343
	],
	"./page/Settings/Flyers/Flyers": [
		5711,
		9,
		87369,
		47393,
		20300,
		57692,
		26851,
		46453
	],
	"./page/Settings/Flyers/Flyers.jsx": [
		5711,
		9,
		87369,
		47393,
		20300,
		57692,
		26851,
		46453
	],
	"./page/Settings/GiftCards/GiftCards": [
		95547,
		9,
		77425,
		97914,
		54590,
		87369,
		6761,
		95547
	],
	"./page/Settings/GiftCards/GiftCards.jsx": [
		95547,
		9,
		77425,
		97914,
		54590,
		87369,
		6761,
		95547
	],
	"./page/Settings/GiftCards/giftCards.css": [
		42864,
		9,
		42864
	],
	"./page/Settings/GoogleProfile/GoogleProfile": [
		39667,
		9,
		77425,
		54590,
		47393,
		87086,
		32769,
		53847,
		79881,
		83240,
		39667
	],
	"./page/Settings/GoogleProfile/GoogleProfile.jsx": [
		39667,
		9,
		77425,
		54590,
		47393,
		87086,
		32769,
		53847,
		79881,
		83240,
		39667
	],
	"./page/Settings/GoogleProfile/GoogleProfilePage": [
		68442,
		9,
		77425,
		54590,
		47393,
		87086,
		32769,
		79881,
		83240,
		53231,
		59741
	],
	"./page/Settings/GoogleProfile/GoogleProfilePage.jsx": [
		68442,
		9,
		77425,
		54590,
		47393,
		87086,
		32769,
		79881,
		83240,
		53231,
		59741
	],
	"./page/Settings/Holidays/Holidays": [
		38639,
		9,
		77425,
		87369,
		63567,
		75691
	],
	"./page/Settings/Holidays/Holidays.css": [
		56336,
		9,
		56336
	],
	"./page/Settings/Holidays/Holidays.jsx": [
		38639,
		9,
		77425,
		87369,
		63567,
		75691
	],
	"./page/Settings/Hours/Hours": [
		5663,
		9,
		5663
	],
	"./page/Settings/Hours/Hours.jsx": [
		5663,
		9,
		5663
	],
	"./page/Settings/Loyalty/Loyalty": [
		33047,
		9,
		77425,
		97914,
		85867,
		47393,
		57692,
		26851,
		71325
	],
	"./page/Settings/Loyalty/Loyalty.jsx": [
		33047,
		9,
		77425,
		97914,
		85867,
		47393,
		57692,
		26851,
		71325
	],
	"./page/Settings/Menu/AddNewCombo": [
		62881,
		9,
		97914,
		85867,
		89456,
		40689,
		52545,
		539
	],
	"./page/Settings/Menu/AddNewCombo.jsx": [
		62881,
		9,
		97914,
		85867,
		89456,
		40689,
		52545,
		539
	],
	"./page/Settings/Menu/AddNewService": [
		5262,
		9,
		97914,
		85867,
		89456,
		40689,
		29362,
		94648
	],
	"./page/Settings/Menu/AddNewService.jsx": [
		5262,
		9,
		97914,
		85867,
		89456,
		40689,
		29362,
		94648
	],
	"./page/Settings/Menu/ComboDetail": [
		31005,
		9,
		97914,
		85867,
		89456,
		40689,
		52545,
		75615
	],
	"./page/Settings/Menu/ComboDetail.jsx": [
		31005,
		9,
		97914,
		85867,
		89456,
		40689,
		52545,
		75615
	],
	"./page/Settings/Menu/Menu": [
		31207,
		9,
		85867,
		20300,
		41871,
		31138
	],
	"./page/Settings/Menu/Menu.css": [
		57708,
		9,
		57708
	],
	"./page/Settings/Menu/Menu.jsx": [
		31207,
		9,
		85867,
		20300,
		41871,
		31138
	],
	"./page/Settings/Menu/ServiceDetail": [
		50325,
		9,
		97914,
		85867,
		89456,
		40689,
		29362,
		7548
	],
	"./page/Settings/Menu/ServiceDetail.jsx": [
		50325,
		9,
		97914,
		85867,
		89456,
		40689,
		29362,
		7548
	],
	"./page/Settings/NewGiftCard/GiftCard": [
		6701,
		9,
		77425,
		97914,
		54590,
		6701
	],
	"./page/Settings/NewGiftCard/GiftCard.jsx": [
		6701,
		9,
		77425,
		97914,
		54590,
		6701
	],
	"./page/Settings/PaymentIntegration/PaymentIntegration": [
		9977,
		9,
		85867,
		47393,
		69938,
		93919
	],
	"./page/Settings/PaymentIntegration/PaymentIntegration.jsx": [
		9977,
		9,
		85867,
		47393,
		69938,
		93919
	],
	"./page/Settings/Poynt/Poynt": [
		79955,
		9,
		77425,
		54590,
		79955
	],
	"./page/Settings/Poynt/Poynt.jsx": [
		79955,
		9,
		77425,
		54590,
		79955
	],
	"./page/Settings/Products/ProductDetail": [
		46355,
		9,
		97914,
		85867,
		59221,
		46355
	],
	"./page/Settings/Products/ProductDetail.jsx": [
		46355,
		9,
		97914,
		85867,
		59221,
		46355
	],
	"./page/Settings/Products/ProductMenu": [
		80869,
		9,
		97914,
		85867,
		59221,
		20300,
		32172,
		80869
	],
	"./page/Settings/Products/ProductMenu.jsx": [
		80869,
		9,
		97914,
		85867,
		59221,
		20300,
		32172,
		80869
	],
	"./page/Settings/Promotions/DefaultEmailPromotion": [
		54723,
		9,
		97914,
		87369,
		13653,
		94522
	],
	"./page/Settings/Promotions/DefaultEmailPromotion.jsx": [
		54723,
		9,
		97914,
		87369,
		13653,
		94522
	],
	"./page/Settings/Promotions/EditEmailPromotion": [
		62420,
		9,
		97914,
		87369,
		9540,
		57692,
		26851,
		12179,
		57332,
		11032,
		33386,
		62420
	],
	"./page/Settings/Promotions/EditEmailPromotion.jsx": [
		62420,
		9,
		97914,
		87369,
		9540,
		57692,
		26851,
		12179,
		57332,
		11032,
		33386,
		62420
	],
	"./page/Settings/Promotions/Promotions": [
		85937,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		57692,
		12179,
		21317,
		70457,
		70617
	],
	"./page/Settings/Promotions/Promotions.css": [
		21378,
		9,
		21378
	],
	"./page/Settings/Promotions/Promotions.jsx": [
		85937,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		57692,
		12179,
		21317,
		70457,
		70617
	],
	"./page/Settings/Setting.css": [
		45449,
		9,
		45449
	],
	"./page/Settings/SettingMenu": [
		191,
		9,
		48223,
		191
	],
	"./page/Settings/SettingMenu.jsx": [
		191,
		9,
		48223,
		191
	],
	"./page/Settings/SettingRoutes": [
		36996,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		93141,
		9540,
		361,
		47393,
		20300,
		26989,
		57692,
		26851,
		12179,
		57332,
		69938,
		87086,
		89456,
		61580,
		91614,
		21317,
		11032,
		32769,
		65701,
		48223,
		22947,
		70361,
		82146,
		70457,
		36996
	],
	"./page/Settings/SettingRoutes.jsx": [
		36996,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		93141,
		9540,
		361,
		47393,
		20300,
		26989,
		57692,
		26851,
		12179,
		57332,
		69938,
		87086,
		89456,
		61580,
		91614,
		21317,
		11032,
		32769,
		65701,
		48223,
		22947,
		70361,
		82146,
		70457,
		36996
	],
	"./page/Settings/Sms/SmsSettings": [
		55428,
		9,
		55428
	],
	"./page/Settings/Sms/SmsSettings.jsx": [
		55428,
		9,
		55428
	],
	"./page/Settings/Staffs/StaffAccounts": [
		86550,
		9,
		77425,
		91614,
		86550
	],
	"./page/Settings/Staffs/StaffAccounts.jsx": [
		86550,
		9,
		77425,
		91614,
		86550
	],
	"./page/Settings/Staffs/StaffDetail": [
		3261,
		9,
		97914,
		85867,
		9540,
		57692,
		26851,
		61580,
		3172,
		63726
	],
	"./page/Settings/Staffs/StaffDetail.jsx": [
		3261,
		9,
		97914,
		85867,
		9540,
		57692,
		26851,
		61580,
		3172,
		63726
	],
	"./page/Settings/Staffs/Staffs": [
		88155,
		9,
		77425,
		97914,
		20300,
		88155
	],
	"./page/Settings/Staffs/Staffs.jsx": [
		88155,
		9,
		77425,
		97914,
		20300,
		88155
	],
	"./page/Settings/Taxes/Taxes": [
		26507,
		9,
		97914,
		26507
	],
	"./page/Settings/Taxes/Taxes.jsx": [
		26507,
		9,
		97914,
		26507
	],
	"./page/Settings/Taxes/taxes.css": [
		89816,
		9,
		89816
	],
	"./page/Settings/ThermalPrinter/ThermalPrinter": [
		687,
		9,
		687
	],
	"./page/Settings/ThermalPrinter/ThermalPrinter.jsx": [
		687,
		9,
		687
	],
	"./page/TimeClock/TimeClock": [
		49007,
		9,
		85867,
		87369,
		22961,
		49007
	],
	"./page/TimeClock/TimeClock.css": [
		55138,
		9,
		55138
	],
	"./page/TimeClock/TimeClock.jsx": [
		49007,
		9,
		85867,
		87369,
		22961,
		49007
	],
	"./page/UpcomingAppointments/UpcomingAppointments": [
		78533,
		9,
		77425,
		87369,
		79638,
		78533
	],
	"./page/UpcomingAppointments/UpcomingAppointments.css": [
		29540,
		9,
		29540
	],
	"./page/UpcomingAppointments/UpcomingAppointments.jsx": [
		78533,
		9,
		77425,
		87369,
		79638,
		78533
	],
	"./pageMobile/Account/Profile": [
		90723,
		9,
		59221,
		90723
	],
	"./pageMobile/Account/Profile.jsx": [
		90723,
		9,
		59221,
		90723
	],
	"./pageMobile/AccountActivation/AccountActivation": [
		51641,
		9
	],
	"./pageMobile/AccountActivation/AccountActivation.css": [
		44464,
		9,
		44464
	],
	"./pageMobile/AccountActivation/AccountActivation.jsx": [
		51641,
		9
	],
	"./pageMobile/AccountActivation/ActivationModal": [
		17627,
		9
	],
	"./pageMobile/AccountActivation/ActivationModal.jsx": [
		17627,
		9
	],
	"./pageMobile/Appointment/AppoimentBlockTime/AppointmentBlockTime": [
		73697,
		9,
		87369,
		73697
	],
	"./pageMobile/Appointment/AppoimentBlockTime/AppointmentBlockTime.jsx": [
		73697,
		9,
		87369,
		73697
	],
	"./pageMobile/Appointment/AppointmentCalendar/AppointmentCalendar": [
		49379,
		9,
		77425,
		85867,
		59221,
		54590,
		87369,
		846,
		89596,
		49379
	],
	"./pageMobile/Appointment/AppointmentCalendar/AppointmentCalendar.jsx": [
		49379,
		9,
		77425,
		85867,
		59221,
		54590,
		87369,
		846,
		89596,
		49379
	],
	"./pageMobile/Appointment/AppointmentCalendar/appointmentCalendar.css": [
		76186,
		9,
		76186
	],
	"./pageMobile/Appointment/AppointmentRoutes": [
		16199,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		846,
		70712,
		47393,
		57332,
		93494,
		36571,
		84180,
		42644,
		19473,
		14665,
		90115,
		79881,
		63305,
		63111,
		81583,
		88312,
		76207,
		73757,
		70677,
		56345,
		66248,
		15028,
		37472,
		85955,
		73045
	],
	"./pageMobile/Appointment/AppointmentRoutes.jsx": [
		16199,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		846,
		70712,
		47393,
		57332,
		93494,
		36571,
		84180,
		42644,
		19473,
		14665,
		90115,
		79881,
		63305,
		63111,
		81583,
		88312,
		76207,
		73757,
		70677,
		56345,
		66248,
		15028,
		37472,
		85955,
		73045
	],
	"./pageMobile/Appointment/CreateAppointment/CreateNewAppointment": [
		48355,
		9,
		77425,
		85867,
		59221,
		87369,
		70712,
		90115,
		81583,
		66248,
		46783
	],
	"./pageMobile/Appointment/CreateAppointment/CreateNewAppointment.jsx": [
		48355,
		9,
		77425,
		85867,
		59221,
		87369,
		70712,
		90115,
		81583,
		66248,
		46783
	],
	"./pageMobile/Appointment/CreateWalkedinAppointment/CreateWalkedInAppointment": [
		55811,
		9,
		85867,
		59221,
		70712,
		90115,
		86124,
		54247
	],
	"./pageMobile/Appointment/CreateWalkedinAppointment/CreateWalkedInAppointment.jsx": [
		55811,
		9,
		85867,
		59221,
		70712,
		90115,
		86124,
		54247
	],
	"./pageMobile/Appointment/EditAppointment/EditAppointment": [
		37807,
		9,
		85867,
		59221,
		87369,
		70712,
		90115,
		81583,
		37472,
		56998
	],
	"./pageMobile/Appointment/EditAppointment/EditAppointment.jsx": [
		37807,
		9,
		85867,
		59221,
		87369,
		70712,
		90115,
		81583,
		37472,
		56998
	],
	"./pageMobile/Appointment/NewAppointmentCalendar/DragDropAppointmentList": [
		81094,
		9,
		85867,
		59221,
		846,
		36571,
		19473,
		81094
	],
	"./pageMobile/Appointment/NewAppointmentCalendar/DragDropAppointmentList.jsx": [
		81094,
		9,
		85867,
		59221,
		846,
		36571,
		19473,
		81094
	],
	"./pageMobile/Appointment/NewAppointmentCalendar/HourCanva": [
		51533,
		9,
		51533
	],
	"./pageMobile/Appointment/NewAppointmentCalendar/HourCanva.jsx": [
		51533,
		9,
		51533
	],
	"./pageMobile/Appointment/NewAppointmentCalendar/NewAppointmentCalendar": [
		85955,
		9,
		77425,
		85867,
		59221,
		54590,
		87369,
		846,
		36571,
		19473,
		85955,
		92918
	],
	"./pageMobile/Appointment/NewAppointmentCalendar/NewAppointmentCalendar.jsx": [
		85955,
		9,
		77425,
		85867,
		59221,
		54590,
		87369,
		846,
		36571,
		19473,
		85955,
		92918
	],
	"./pageMobile/Appointment/NewAppointmentCalendar/NewCurrentTimeIndicator": [
		48899,
		9,
		48899
	],
	"./pageMobile/Appointment/NewAppointmentCalendar/NewCurrentTimeIndicator.jsx": [
		48899,
		9,
		48899
	],
	"./pageMobile/Appointment/NewAppointmentCalendar/dragAndDropStyle.css": [
		43048,
		9,
		43048
	],
	"./pageMobile/Appointment/NewAppointmentCalendar/newAppointmentCalendar.css": [
		73814,
		9,
		73814
	],
	"./pageMobile/Appointment/RebookAppointment/RebookAppointment": [
		79963,
		9,
		77425,
		85867,
		59221,
		87369,
		70712,
		90115,
		81583,
		15028,
		93387
	],
	"./pageMobile/Appointment/RebookAppointment/RebookAppointment.jsx": [
		79963,
		9,
		77425,
		85867,
		59221,
		87369,
		70712,
		90115,
		81583,
		15028,
		93387
	],
	"./pageMobile/Appointment/ViewAppointment/ViewAppointmentPage": [
		81990,
		9,
		97914,
		85867,
		59221,
		846,
		70712,
		47393,
		93494,
		84180,
		42644,
		90115,
		79881,
		63305,
		63111,
		88312,
		76207,
		87275
	],
	"./pageMobile/Appointment/ViewAppointment/ViewAppointmentPage.css": [
		16875,
		9,
		16875
	],
	"./pageMobile/Appointment/ViewAppointment/ViewAppointmentPage.jsx": [
		81990,
		9,
		97914,
		85867,
		59221,
		846,
		70712,
		47393,
		93494,
		84180,
		42644,
		90115,
		79881,
		63305,
		63111,
		88312,
		76207,
		87275
	],
	"./pageMobile/Appointment/ViewPassedAppointment/ViewPassedAppointment": [
		80963,
		9,
		97914,
		85867,
		59221,
		93141,
		846,
		70712,
		9540,
		47393,
		11542,
		76702,
		67638,
		90115,
		79881,
		48885,
		87753,
		76422,
		94349,
		34632
	],
	"./pageMobile/Appointment/ViewPassedAppointment/ViewPassedAppointment.jsx": [
		80963,
		9,
		97914,
		85867,
		59221,
		93141,
		846,
		70712,
		9540,
		47393,
		11542,
		76702,
		67638,
		90115,
		79881,
		48885,
		87753,
		76422,
		94349,
		34632
	],
	"./pageMobile/CalendarPage/AppointmentCard": [
		73757,
		9,
		846,
		73757,
		77952
	],
	"./pageMobile/CalendarPage/AppointmentCard.jsx": [
		73757,
		9,
		846,
		73757,
		77952
	],
	"./pageMobile/CalendarPage/AppointmentIcons": [
		71225,
		9,
		71225
	],
	"./pageMobile/CalendarPage/AppointmentIcons.jsx": [
		71225,
		9,
		71225
	],
	"./pageMobile/CalendarPage/BlockedTimeCard": [
		47965,
		9,
		47965
	],
	"./pageMobile/CalendarPage/BlockedTimeCard.jsx": [
		47965,
		9,
		47965
	],
	"./pageMobile/CalendarPage/CalendarAlert": [
		52288,
		9,
		52288
	],
	"./pageMobile/CalendarPage/CalendarAlert.jsx": [
		52288,
		9,
		52288
	],
	"./pageMobile/CalendarPage/CalendarDuplicateModal": [
		17830,
		9,
		77425,
		87369,
		17830
	],
	"./pageMobile/CalendarPage/CalendarDuplicateModal.jsx": [
		17830,
		9,
		77425,
		87369,
		17830
	],
	"./pageMobile/CalendarPage/CalendarPage": [
		56345,
		9,
		77425,
		87369,
		846,
		57332,
		73757,
		70677,
		56345,
		4923
	],
	"./pageMobile/CalendarPage/CalendarPage.jsx": [
		56345,
		9,
		77425,
		87369,
		846,
		57332,
		73757,
		70677,
		56345,
		4923
	],
	"./pageMobile/CalendarPage/CalendarToolbar": [
		33523,
		9,
		87369,
		57332,
		33523
	],
	"./pageMobile/CalendarPage/CalendarToolbar.jsx": [
		33523,
		9,
		87369,
		57332,
		33523
	],
	"./pageMobile/CalendarPage/Calendarpageexample": [
		55735,
		9,
		77425,
		87369,
		846,
		57332,
		73757,
		70677,
		56345,
		44144
	],
	"./pageMobile/CalendarPage/Calendarpageexample.jsx": [
		55735,
		9,
		77425,
		87369,
		846,
		57332,
		73757,
		70677,
		56345,
		44144
	],
	"./pageMobile/CalendarPage/ConfirmAppointmentChangeModal": [
		52226,
		9,
		52226
	],
	"./pageMobile/CalendarPage/ConfirmAppointmentChangeModal.jsx": [
		52226,
		9,
		52226
	],
	"./pageMobile/CalendarPage/ConfirmWeekMoveModal": [
		59188,
		9,
		59188
	],
	"./pageMobile/CalendarPage/ConfirmWeekMoveModal.jsx": [
		59188,
		9,
		59188
	],
	"./pageMobile/CalendarPage/NowTimeBar": [
		85004,
		9,
		85004
	],
	"./pageMobile/CalendarPage/NowTimeBar.jsx": [
		85004,
		9,
		85004
	],
	"./pageMobile/CalendarPage/WeekView": [
		70677,
		9,
		846,
		73757,
		70677,
		70854
	],
	"./pageMobile/CalendarPage/WeekView.jsx": [
		70677,
		9,
		846,
		73757,
		70677,
		70854
	],
	"./pageMobile/CheckedIn/CheckedIn": [
		30329,
		9,
		20300,
		55819,
		18585,
		30329
	],
	"./pageMobile/CheckedIn/CheckedIn.css": [
		98896,
		9,
		98896
	],
	"./pageMobile/CheckedIn/CheckedIn.jsx": [
		30329,
		9,
		20300,
		55819,
		18585,
		30329
	],
	"./pageMobile/Checkout/Checkout": [
		3935,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		70712,
		361,
		42104,
		93494,
		30059,
		90115,
		82146,
		89381,
		63305,
		40729,
		51088,
		35423
	],
	"./pageMobile/Checkout/Checkout.css": [
		33786,
		9,
		33786
	],
	"./pageMobile/Checkout/Checkout.jsx": [
		3935,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		70712,
		361,
		42104,
		93494,
		30059,
		90115,
		82146,
		89381,
		63305,
		40729,
		51088,
		35423
	],
	"./pageMobile/Client/ClientCreateContainer/ClientCreateContainer": [
		74179,
		9,
		59221,
		70712,
		63179
	],
	"./pageMobile/Client/ClientCreateContainer/ClientCreateContainer.jsx": [
		74179,
		9,
		59221,
		70712,
		63179
	],
	"./pageMobile/Client/ClientDetailContainer/ClientDetailContainer": [
		66880,
		9,
		97914,
		59221,
		846,
		70712,
		93494,
		81912,
		90115,
		63305,
		44499,
		41857
	],
	"./pageMobile/Client/ClientDetailContainer/ClientDetailContainer.jsx": [
		66880,
		9,
		97914,
		59221,
		846,
		70712,
		93494,
		81912,
		90115,
		63305,
		44499,
		41857
	],
	"./pageMobile/Client/ClientRoutes": [
		80052,
		9,
		77425,
		97914,
		59221,
		54590,
		846,
		70712,
		93494,
		16371,
		81912,
		90115,
		63305,
		44499,
		86151
	],
	"./pageMobile/Client/ClientRoutes.jsx": [
		80052,
		9,
		77425,
		97914,
		59221,
		54590,
		846,
		70712,
		93494,
		16371,
		81912,
		90115,
		63305,
		44499,
		86151
	],
	"./pageMobile/Client/ClientSearchContainer/ClientSearchContainer": [
		7539,
		9,
		77425,
		97914,
		59221,
		54590,
		16371,
		7539
	],
	"./pageMobile/Client/ClientSearchContainer/ClientSearchContainer.jsx": [
		7539,
		9,
		77425,
		97914,
		59221,
		54590,
		16371,
		7539
	],
	"./pageMobile/FastCheckOut/FastCheckOut": [
		72775,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		75058,
		82146,
		89381,
		23864,
		74557,
		21447,
		87591
	],
	"./pageMobile/FastCheckOut/FastCheckOut.jsx": [
		72775,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		75058,
		82146,
		89381,
		23864,
		74557,
		21447,
		87591
	],
	"./pageMobile/ForgotPassword/ForgotPassword": [
		28799,
		9
	],
	"./pageMobile/ForgotPassword/ForgotPassword.jsx": [
		28799,
		9
	],
	"./pageMobile/ForgotPassword/ResetPassword": [
		32459,
		9
	],
	"./pageMobile/ForgotPassword/ResetPassword.jsx": [
		32459,
		9
	],
	"./pageMobile/ForgotPassword/resetPassword.css": [
		17164,
		9
	],
	"./pageMobile/GiftCardHistory/GiftCardHistory": [
		24833,
		9,
		77425,
		97914,
		54590,
		87369,
		66421,
		24833
	],
	"./pageMobile/GiftCardHistory/GiftCardHistory.jsx": [
		24833,
		9,
		77425,
		97914,
		54590,
		87369,
		66421,
		24833
	],
	"./pageMobile/History/History": [
		53873,
		9,
		77425,
		85867,
		59221,
		54590,
		87369,
		93141,
		846,
		26989,
		17867,
		82291,
		20691,
		10370,
		91080,
		48296,
		79881,
		63111,
		38557,
		42979,
		36501,
		93346,
		75641
	],
	"./pageMobile/History/History.css": [
		57832,
		9,
		57832
	],
	"./pageMobile/History/History.jsx": [
		53873,
		9,
		77425,
		85867,
		59221,
		54590,
		87369,
		93141,
		846,
		26989,
		17867,
		82291,
		20691,
		10370,
		91080,
		48296,
		79881,
		63111,
		38557,
		42979,
		36501,
		93346,
		75641
	],
	"./pageMobile/Invoice/EditInvoice": [
		62245,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		26237,
		82146,
		89381,
		52324,
		26662,
		75941
	],
	"./pageMobile/Invoice/EditInvoice.jsx": [
		62245,
		9,
		77425,
		97914,
		85867,
		87369,
		361,
		42104,
		26237,
		82146,
		89381,
		52324,
		26662,
		75941
	],
	"./pageMobile/Invoice/Invoice": [
		9137,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		361,
		42104,
		93494,
		30059,
		90115,
		82146,
		89381,
		63305,
		40729,
		23864,
		10844,
		27263,
		9305
	],
	"./pageMobile/Invoice/Invoice.jsx": [
		9137,
		9,
		97914,
		85867,
		59221,
		93141,
		70712,
		361,
		42104,
		93494,
		30059,
		90115,
		82146,
		89381,
		63305,
		40729,
		23864,
		10844,
		27263,
		9305
	],
	"./pageMobile/Invoice/invoice.css": [
		61272,
		9,
		61272
	],
	"./pageMobile/Login/Login": [
		57669,
		9
	],
	"./pageMobile/Login/Login.jsx": [
		57669,
		9
	],
	"./pageMobile/PinAuth/PinAuth": [
		54973,
		9,
		54973
	],
	"./pageMobile/PinAuth/PinAuth.jsx": [
		54973,
		9,
		54973
	],
	"./pageMobile/Referral/Referral": [
		24721,
		9,
		59221,
		24721
	],
	"./pageMobile/Referral/Referral.jsx": [
		24721,
		9,
		59221,
		24721
	],
	"./pageMobile/Report/Billing": [
		43624,
		9,
		77425,
		59221,
		54590,
		93141,
		20036,
		70746
	],
	"./pageMobile/Report/Billing.css": [
		50695,
		9,
		50695
	],
	"./pageMobile/Report/Billing.jsx": [
		43624,
		9,
		77425,
		59221,
		54590,
		93141,
		20036,
		70746
	],
	"./pageMobile/Report/ClientsStats": [
		77404,
		9,
		26989,
		17867,
		82291,
		60163,
		77404
	],
	"./pageMobile/Report/ClientsStats.jsx": [
		77404,
		9,
		26989,
		17867,
		82291,
		60163,
		77404
	],
	"./pageMobile/Report/Sales": [
		79957,
		9,
		26989,
		17867,
		82291,
		79957
	],
	"./pageMobile/Report/Sales.jsx": [
		79957,
		9,
		26989,
		17867,
		82291,
		79957
	],
	"./pageMobile/Settings/AiReceptionist/AiReceptionist": [
		17713,
		9,
		77425,
		85867,
		59221,
		1515,
		63037
	],
	"./pageMobile/Settings/AiReceptionist/AiReceptionist.jsx": [
		17713,
		9,
		77425,
		85867,
		59221,
		1515,
		63037
	],
	"./pageMobile/Settings/Appointment/AppointmentSettings": [
		92066,
		9,
		59221,
		93141,
		91614,
		94217,
		59513
	],
	"./pageMobile/Settings/Appointment/AppointmentSettings.jsx": [
		92066,
		9,
		59221,
		93141,
		91614,
		94217,
		59513
	],
	"./pageMobile/Settings/ClientType/ClientType": [
		97269,
		9,
		97914,
		97269
	],
	"./pageMobile/Settings/ClientType/ClientType.jsx": [
		97269,
		9,
		97914,
		97269
	],
	"./pageMobile/Settings/Clover/CloverIntergration": [
		38261,
		9,
		361,
		82146,
		38261
	],
	"./pageMobile/Settings/Clover/CloverIntergration.jsx": [
		38261,
		9,
		361,
		82146,
		38261
	],
	"./pageMobile/Settings/Clover/NewCloverSettings": [
		54034,
		9,
		77425,
		97914,
		54590,
		54034
	],
	"./pageMobile/Settings/Clover/NewCloverSettings.jsx": [
		54034,
		9,
		77425,
		97914,
		54590,
		54034
	],
	"./pageMobile/Settings/Deposit/Deposit": [
		28745,
		9,
		77425,
		97914,
		54590,
		28745
	],
	"./pageMobile/Settings/Deposit/Deposit.jsx": [
		28745,
		9,
		77425,
		97914,
		54590,
		28745
	],
	"./pageMobile/Settings/Flyers/Flyers": [
		41489,
		9,
		87369,
		47393,
		20300,
		57692,
		26851,
		32279
	],
	"./pageMobile/Settings/Flyers/Flyers.jsx": [
		41489,
		9,
		87369,
		47393,
		20300,
		57692,
		26851,
		32279
	],
	"./pageMobile/Settings/GiftCards/GiftCards": [
		19349,
		9,
		77425,
		97914,
		54590,
		87369,
		29142,
		19349
	],
	"./pageMobile/Settings/GiftCards/GiftCards.jsx": [
		19349,
		9,
		77425,
		97914,
		54590,
		87369,
		29142,
		19349
	],
	"./pageMobile/Settings/GiftCards/giftCards.css": [
		12974,
		9,
		12974
	],
	"./pageMobile/Settings/GoogleProfile/GoogleProfile": [
		46781,
		9,
		47393,
		87086,
		25176,
		40882,
		79881,
		46781
	],
	"./pageMobile/Settings/GoogleProfile/GoogleProfile.jsx": [
		46781,
		9,
		47393,
		87086,
		25176,
		40882,
		79881,
		46781
	],
	"./pageMobile/Settings/GoogleProfile/GoogleProfilePage": [
		5920,
		9,
		77425,
		54590,
		47393,
		87086,
		32769,
		79881,
		83240,
		53231,
		37879
	],
	"./pageMobile/Settings/GoogleProfile/GoogleProfilePage.jsx": [
		5920,
		9,
		77425,
		54590,
		47393,
		87086,
		32769,
		79881,
		83240,
		53231,
		37879
	],
	"./pageMobile/Settings/Holidays/Holidays": [
		1489,
		9,
		77425,
		87369,
		6541,
		20845
	],
	"./pageMobile/Settings/Holidays/Holidays.css": [
		57934,
		9,
		57934
	],
	"./pageMobile/Settings/Holidays/Holidays.jsx": [
		1489,
		9,
		77425,
		87369,
		6541,
		20845
	],
	"./pageMobile/Settings/Hours/Hours": [
		81809,
		9,
		81809
	],
	"./pageMobile/Settings/Hours/Hours.jsx": [
		81809,
		9,
		81809
	],
	"./pageMobile/Settings/Loyalty/Loyalty": [
		91225,
		9,
		77425,
		97914,
		85867,
		47393,
		57692,
		26851,
		29439
	],
	"./pageMobile/Settings/Loyalty/Loyalty.jsx": [
		91225,
		9,
		77425,
		97914,
		85867,
		47393,
		57692,
		26851,
		29439
	],
	"./pageMobile/Settings/Menu/AddNewCombo": [
		73203,
		9,
		97914,
		85867,
		67075,
		6775,
		52095,
		24769
	],
	"./pageMobile/Settings/Menu/AddNewCombo.jsx": [
		73203,
		9,
		97914,
		85867,
		67075,
		6775,
		52095,
		24769
	],
	"./pageMobile/Settings/Menu/AddNewService": [
		15720,
		9,
		97914,
		85867,
		67075,
		6775,
		53681,
		30706
	],
	"./pageMobile/Settings/Menu/AddNewService.jsx": [
		15720,
		9,
		97914,
		85867,
		67075,
		6775,
		53681,
		30706
	],
	"./pageMobile/Settings/Menu/ComboDetail": [
		76895,
		9,
		97914,
		85867,
		67075,
		6775,
		52095,
		66309
	],
	"./pageMobile/Settings/Menu/ComboDetail.jsx": [
		76895,
		9,
		97914,
		85867,
		67075,
		6775,
		52095,
		66309
	],
	"./pageMobile/Settings/Menu/Menu": [
		8169,
		9,
		85867,
		20300,
		8169
	],
	"./pageMobile/Settings/Menu/Menu.css": [
		63082,
		9,
		63082
	],
	"./pageMobile/Settings/Menu/Menu.jsx": [
		8169,
		9,
		85867,
		20300,
		8169
	],
	"./pageMobile/Settings/Menu/ServiceDetail": [
		77780,
		9,
		97914,
		85867,
		67075,
		6775,
		53681,
		41070
	],
	"./pageMobile/Settings/Menu/ServiceDetail.jsx": [
		77780,
		9,
		97914,
		85867,
		67075,
		6775,
		53681,
		41070
	],
	"./pageMobile/Settings/NewGiftCard/GiftCard": [
		95371,
		9,
		77425,
		97914,
		54590,
		95371
	],
	"./pageMobile/Settings/NewGiftCard/GiftCard.jsx": [
		95371,
		9,
		77425,
		97914,
		54590,
		95371
	],
	"./pageMobile/Settings/PaymentIntegration/PaymentIntegration": [
		24739,
		9,
		85867,
		47393,
		69938,
		73153
	],
	"./pageMobile/Settings/PaymentIntegration/PaymentIntegration.jsx": [
		24739,
		9,
		85867,
		47393,
		69938,
		73153
	],
	"./pageMobile/Settings/Poynt/Poynt": [
		84197,
		9,
		77425,
		54590,
		84197
	],
	"./pageMobile/Settings/Poynt/Poynt.jsx": [
		84197,
		9,
		77425,
		54590,
		84197
	],
	"./pageMobile/Settings/Products/ProductDetail": [
		4402,
		9,
		97914,
		85867,
		59221,
		82021
	],
	"./pageMobile/Settings/Products/ProductDetail.jsx": [
		4402,
		9,
		97914,
		85867,
		59221,
		82021
	],
	"./pageMobile/Settings/Products/ProductMenu": [
		4123,
		9,
		97914,
		85867,
		59221,
		20300,
		4123
	],
	"./pageMobile/Settings/Products/ProductMenu.jsx": [
		4123,
		9,
		97914,
		85867,
		59221,
		20300,
		4123
	],
	"./pageMobile/Settings/Promotions/DefaultEmailPromotion": [
		66569,
		9,
		97914,
		87369,
		87563,
		96751
	],
	"./pageMobile/Settings/Promotions/DefaultEmailPromotion.jsx": [
		66569,
		9,
		97914,
		87369,
		87563,
		96751
	],
	"./pageMobile/Settings/Promotions/EditEmailPromotion": [
		92450,
		9,
		97914,
		87369,
		9540,
		57692,
		26851,
		12179,
		57332,
		11032,
		81300,
		22196
	],
	"./pageMobile/Settings/Promotions/EditEmailPromotion.jsx": [
		92450,
		9,
		97914,
		87369,
		9540,
		57692,
		26851,
		12179,
		57332,
		11032,
		81300,
		22196
	],
	"./pageMobile/Settings/Promotions/Promotions": [
		61155,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		57692,
		12179,
		21317,
		18827,
		75395
	],
	"./pageMobile/Settings/Promotions/Promotions.css": [
		43920,
		9,
		43920
	],
	"./pageMobile/Settings/Promotions/Promotions.jsx": [
		61155,
		9,
		77425,
		97914,
		85867,
		59221,
		87369,
		57692,
		12179,
		21317,
		18827,
		75395
	],
	"./pageMobile/Settings/Setting.css": [
		85935,
		9,
		85935
	],
	"./pageMobile/Settings/SettingMenu": [
		72149,
		9,
		48223,
		72149
	],
	"./pageMobile/Settings/SettingMenu.jsx": [
		72149,
		9,
		48223,
		72149
	],
	"./pageMobile/Settings/SettingRoutes": [
		16186,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		93141,
		9540,
		361,
		47393,
		20300,
		57692,
		26851,
		12179,
		57332,
		69938,
		87086,
		67075,
		61580,
		91614,
		21317,
		11032,
		32769,
		48223,
		75330,
		82146,
		79881,
		6775,
		52095,
		18827,
		13247,
		42316
	],
	"./pageMobile/Settings/SettingRoutes.jsx": [
		16186,
		9,
		77425,
		97914,
		85867,
		59221,
		54590,
		87369,
		93141,
		9540,
		361,
		47393,
		20300,
		57692,
		26851,
		12179,
		57332,
		69938,
		87086,
		67075,
		61580,
		91614,
		21317,
		11032,
		32769,
		48223,
		75330,
		82146,
		79881,
		6775,
		52095,
		18827,
		13247,
		42316
	],
	"./pageMobile/Settings/Sms/SmsSettings": [
		40126,
		9,
		40126
	],
	"./pageMobile/Settings/Sms/SmsSettings.jsx": [
		40126,
		9,
		40126
	],
	"./pageMobile/Settings/Staffs/StaffDetail": [
		13247,
		9,
		97914,
		85867,
		59221,
		9540,
		57692,
		26851,
		61580,
		13247,
		85032
	],
	"./pageMobile/Settings/Staffs/StaffDetail.jsx": [
		13247,
		9,
		97914,
		85867,
		59221,
		9540,
		57692,
		26851,
		61580,
		13247,
		85032
	],
	"./pageMobile/Settings/Staffs/Staffs": [
		6437,
		9,
		77425,
		97914,
		20300,
		5301,
		57093
	],
	"./pageMobile/Settings/Staffs/Staffs.jsx": [
		6437,
		9,
		77425,
		97914,
		20300,
		5301,
		57093
	],
	"./pageMobile/Settings/Taxes/Taxes": [
		80069,
		9,
		97914,
		80069
	],
	"./pageMobile/Settings/Taxes/Taxes.jsx": [
		80069,
		9,
		97914,
		80069
	],
	"./pageMobile/Settings/Taxes/taxes.css": [
		8054,
		9,
		8054
	],
	"./pageMobile/Settings/ThermalPrinter/ThermalPrinter": [
		71153,
		9,
		71153
	],
	"./pageMobile/Settings/ThermalPrinter/ThermalPrinter.jsx": [
		71153,
		9,
		71153
	],
	"./pageMobile/TimeClock/TimeClock": [
		6369,
		9,
		85867,
		87369,
		62915,
		28674,
		65129
	],
	"./pageMobile/TimeClock/TimeClock.css": [
		9024,
		9,
		9024
	],
	"./pageMobile/TimeClock/TimeClock.jsx": [
		6369,
		9,
		85867,
		87369,
		62915,
		28674,
		65129
	],
	"./pageMobile/UpcomingAppointments/UpcomingAppointments": [
		73447,
		9,
		77425,
		87369,
		79638,
		73447
	],
	"./pageMobile/UpcomingAppointments/UpcomingAppointments.css": [
		20970,
		9,
		20970
	],
	"./pageMobile/UpcomingAppointments/UpcomingAppointments.jsx": [
		73447,
		9,
		77425,
		87369,
		79638,
		73447
	],
	"./redux/actions/ai-receptionist-settings/aiReceptionistSettings": [
		28500,
		9,
		28500
	],
	"./redux/actions/ai-receptionist-settings/aiReceptionistSettings.js": [
		28500,
		9,
		28500
	],
	"./redux/actions/appointment/appointment": [
		92034,
		9,
		92034
	],
	"./redux/actions/appointment/appointment.js": [
		92034,
		9,
		92034
	],
	"./redux/actions/appointment/availability/availability": [
		70184,
		9,
		70184
	],
	"./redux/actions/appointment/availability/availability.js": [
		70184,
		9,
		70184
	],
	"./redux/actions/autoPromotionSms/autoPromotionSms": [
		72706,
		9,
		72706
	],
	"./redux/actions/autoPromotionSms/autoPromotionSms.js": [
		72706,
		9,
		72706
	],
	"./redux/actions/billing/billing": [
		10862,
		9
	],
	"./redux/actions/billing/billing.js": [
		10862,
		9
	],
	"./redux/actions/business-client-settings/businessClientSettings": [
		72640,
		9,
		72640
	],
	"./redux/actions/business-client-settings/businessClientSettings.js": [
		72640,
		9,
		72640
	],
	"./redux/actions/business-client/businessClient": [
		30615,
		9,
		30615
	],
	"./redux/actions/business-client/businessClient.js": [
		30615,
		9,
		30615
	],
	"./redux/actions/business-hour/business-hour": [
		18990,
		9,
		18990
	],
	"./redux/actions/business-hour/business-hour.js": [
		18990,
		9,
		18990
	],
	"./redux/actions/check-in-settings/checkInSettings": [
		25890,
		9,
		25890
	],
	"./redux/actions/check-in-settings/checkInSettings.js": [
		25890,
		9,
		25890
	],
	"./redux/actions/clover/cloverStatus": [
		2640,
		9,
		2640
	],
	"./redux/actions/clover/cloverStatus.js": [
		2640,
		9,
		2640
	],
	"./redux/actions/depositSettings/depositSettings": [
		94606,
		9,
		94606
	],
	"./redux/actions/depositSettings/depositSettings.js": [
		94606,
		9,
		94606
	],
	"./redux/actions/gift-card-history/giftCardHistory": [
		49248,
		9,
		49248
	],
	"./redux/actions/gift-card-history/giftCardHistory.js": [
		49248,
		9,
		49248
	],
	"./redux/actions/gift-card-settings/giftCardSettings": [
		26428,
		9,
		26428
	],
	"./redux/actions/gift-card-settings/giftCardSettings.js": [
		26428,
		9,
		26428
	],
	"./redux/actions/gift-card/giftCard": [
		39181,
		9,
		39181
	],
	"./redux/actions/gift-card/giftCard.js": [
		39181,
		9,
		39181
	],
	"./redux/actions/gmb/gmb": [
		10498,
		9,
		10498
	],
	"./redux/actions/gmb/gmb.js": [
		10498,
		9,
		10498
	],
	"./redux/actions/googleProfile/googleProfile": [
		10594,
		9,
		10594
	],
	"./redux/actions/googleProfile/googleProfile.js": [
		10594,
		9,
		10594
	],
	"./redux/actions/history/history": [
		86558,
		9,
		86558
	],
	"./redux/actions/history/history.js": [
		86558,
		9,
		86558
	],
	"./redux/actions/holiday/holiday": [
		78038,
		9,
		78038
	],
	"./redux/actions/holiday/holiday.js": [
		78038,
		9,
		78038
	],
	"./redux/actions/invoice/invoice": [
		13966,
		9,
		13966
	],
	"./redux/actions/invoice/invoice.js": [
		13966,
		9,
		13966
	],
	"./redux/actions/loyaltySetting/loyaltySetting": [
		31388,
		9,
		31388
	],
	"./redux/actions/loyaltySetting/loyaltySetting.js": [
		31388,
		9,
		31388
	],
	"./redux/actions/menu/menu": [
		87590,
		9,
		87590
	],
	"./redux/actions/menu/menu.js": [
		87590,
		9,
		87590
	],
	"./redux/actions/meta/meta": [
		86018,
		9,
		86018
	],
	"./redux/actions/meta/meta.js": [
		86018,
		9,
		86018
	],
	"./redux/actions/new-calendar/newCalendar": [
		22297,
		9,
		22297
	],
	"./redux/actions/new-calendar/newCalendar.js": [
		22297,
		9,
		22297
	],
	"./redux/actions/newClover/newClover": [
		61726,
		9,
		61726
	],
	"./redux/actions/newClover/newClover.js": [
		61726,
		9,
		61726
	],
	"./redux/actions/notification/notification": [
		62830,
		9
	],
	"./redux/actions/notification/notification.js": [
		62830,
		9
	],
	"./redux/actions/payment-integration-settings/paymentIntegrationSettings": [
		3558,
		9,
		3558
	],
	"./redux/actions/payment-integration-settings/paymentIntegrationSettings.js": [
		3558,
		9,
		3558
	],
	"./redux/actions/poynt/poynt": [
		9306,
		9,
		9306
	],
	"./redux/actions/poynt/poynt.js": [
		9306,
		9,
		9306
	],
	"./redux/actions/product/product": [
		71358,
		9,
		71358
	],
	"./redux/actions/product/product.js": [
		71358,
		9,
		71358
	],
	"./redux/actions/promotion/promotion": [
		22594,
		9,
		22594
	],
	"./redux/actions/promotion/promotion.js": [
		22594,
		9,
		22594
	],
	"./redux/actions/report/billingReport": [
		40421,
		9,
		40421
	],
	"./redux/actions/report/billingReport.js": [
		40421,
		9,
		40421
	],
	"./redux/actions/report/saleReport": [
		9055,
		9,
		9055
	],
	"./redux/actions/report/saleReport.js": [
		9055,
		9,
		9055
	],
	"./redux/actions/responsive/responsive": [
		11220,
		9
	],
	"./redux/actions/responsive/responsive.js": [
		11220,
		9
	],
	"./redux/actions/sale/sale": [
		27022,
		9,
		27022
	],
	"./redux/actions/sale/sale.js": [
		27022,
		9,
		27022
	],
	"./redux/actions/salon-account/authenticate": [
		13136,
		9
	],
	"./redux/actions/salon-account/authenticate.js": [
		13136,
		9
	],
	"./redux/actions/salon-account/businessInfo": [
		98671,
		9,
		98671
	],
	"./redux/actions/salon-account/businessInfo.js": [
		98671,
		9,
		98671
	],
	"./redux/actions/sms-settings/smsSettings": [
		95091,
		9,
		95091
	],
	"./redux/actions/sms-settings/smsSettings.js": [
		95091,
		9,
		95091
	],
	"./redux/actions/staff/staff": [
		84566,
		9,
		84566
	],
	"./redux/actions/staff/staff.js": [
		84566,
		9,
		84566
	],
	"./redux/actions/staff/staffAccount": [
		57835,
		9,
		57835
	],
	"./redux/actions/staff/staffAccount.js": [
		57835,
		9,
		57835
	],
	"./redux/actions/tax/tax": [
		24038,
		9,
		24038
	],
	"./redux/actions/tax/tax.js": [
		24038,
		9,
		24038
	],
	"./redux/actions/thermal-printer/thermalPrinter": [
		93591,
		9,
		93591
	],
	"./redux/actions/thermal-printer/thermalPrinter.js": [
		93591,
		9,
		93591
	],
	"./redux/actions/time-clock/time-clock": [
		68396,
		9,
		68396
	],
	"./redux/actions/time-clock/time-clock.js": [
		68396,
		9,
		68396
	],
	"./redux/actions/upcomming-appointments/upcommingAppointments": [
		20755,
		9,
		20755
	],
	"./redux/actions/upcomming-appointments/upcommingAppointments.js": [
		20755,
		9,
		20755
	],
	"./redux/constants/ai-receptionist-settings/aiReceptionistSettings": [
		76834,
		9
	],
	"./redux/constants/ai-receptionist-settings/aiReceptionistSettings.js": [
		76834,
		9
	],
	"./redux/constants/appointment/appointment": [
		53640,
		9
	],
	"./redux/constants/appointment/appointment.js": [
		53640,
		9
	],
	"./redux/constants/appointment/availability/availability": [
		24078,
		9
	],
	"./redux/constants/appointment/availability/availability.js": [
		24078,
		9
	],
	"./redux/constants/autoPromotionSms/autoPromotionSms": [
		34968,
		9
	],
	"./redux/constants/autoPromotionSms/autoPromotionSms.js": [
		34968,
		9
	],
	"./redux/constants/billing/billing": [
		86532,
		9
	],
	"./redux/constants/billing/billing.js": [
		86532,
		9
	],
	"./redux/constants/business-client-settings/businessClientSettings": [
		96502,
		9
	],
	"./redux/constants/business-client-settings/businessClientSettings.js": [
		96502,
		9
	],
	"./redux/constants/business-client/businessClient": [
		66545,
		9
	],
	"./redux/constants/business-client/businessClient.js": [
		66545,
		9
	],
	"./redux/constants/business-hour/business-hour": [
		58884,
		9
	],
	"./redux/constants/business-hour/business-hour.js": [
		58884,
		9
	],
	"./redux/constants/check-in-settings/checkInSettings": [
		98576,
		9
	],
	"./redux/constants/check-in-settings/checkInSettings.js": [
		98576,
		9
	],
	"./redux/constants/clover/cloverStatus": [
		32806,
		9
	],
	"./redux/constants/clover/cloverStatus.js": [
		32806,
		9
	],
	"./redux/constants/depositSettings/depositSettings": [
		52332,
		9
	],
	"./redux/constants/depositSettings/depositSettings.js": [
		52332,
		9
	],
	"./redux/constants/gift-card-history/giftCardHistory": [
		86342,
		9
	],
	"./redux/constants/gift-card-history/giftCardHistory.js": [
		86342,
		9
	],
	"./redux/constants/gift-card-settings/giftCardSettings": [
		13066,
		9
	],
	"./redux/constants/gift-card-settings/giftCardSettings.js": [
		13066,
		9
	],
	"./redux/constants/gift-card/giftCard": [
		83839,
		9
	],
	"./redux/constants/gift-card/giftCard.js": [
		83839,
		9
	],
	"./redux/constants/gmb/gmb": [
		37232,
		9
	],
	"./redux/constants/gmb/gmb.js": [
		37232,
		9
	],
	"./redux/constants/googleProfile/googleProfile": [
		86528,
		9
	],
	"./redux/constants/googleProfile/googleProfile.js": [
		86528,
		9
	],
	"./redux/constants/history/history": [
		21412,
		9
	],
	"./redux/constants/history/history.js": [
		21412,
		9
	],
	"./redux/constants/holiday/holiday": [
		66108,
		9
	],
	"./redux/constants/holiday/holiday.js": [
		66108,
		9
	],
	"./redux/constants/invoice/invoice": [
		40788,
		9
	],
	"./redux/constants/invoice/invoice.js": [
		40788,
		9
	],
	"./redux/constants/loyaltySetting/loyaltySetting": [
		16834,
		9
	],
	"./redux/constants/loyaltySetting/loyaltySetting.js": [
		16834,
		9
	],
	"./redux/constants/menu/menu": [
		40676,
		9
	],
	"./redux/constants/menu/menu.js": [
		40676,
		9
	],
	"./redux/constants/meta/meta": [
		47520,
		9
	],
	"./redux/constants/meta/meta.js": [
		47520,
		9
	],
	"./redux/constants/new-calendar/newCalendar": [
		307,
		9
	],
	"./redux/constants/new-calendar/newCalendar.js": [
		307,
		9
	],
	"./redux/constants/newClover/newClover": [
		95100,
		9
	],
	"./redux/constants/newClover/newClover.js": [
		95100,
		9
	],
	"./redux/constants/notification/notification": [
		83764,
		9
	],
	"./redux/constants/notification/notification.js": [
		83764,
		9
	],
	"./redux/constants/payment-integration-settings/paymentIntegrationSettings": [
		90932,
		9
	],
	"./redux/constants/payment-integration-settings/paymentIntegrationSettings.js": [
		90932,
		9
	],
	"./redux/constants/poynt/poynt": [
		79744,
		9
	],
	"./redux/constants/poynt/poynt.js": [
		79744,
		9
	],
	"./redux/constants/product/product": [
		10980,
		9
	],
	"./redux/constants/product/product.js": [
		10980,
		9
	],
	"./redux/constants/promotion/promotion": [
		56192,
		9
	],
	"./redux/constants/promotion/promotion.js": [
		56192,
		9
	],
	"./redux/constants/report/billingReport": [
		94379,
		9
	],
	"./redux/constants/report/billingReport.js": [
		94379,
		9
	],
	"./redux/constants/report/saleReport": [
		66009,
		9
	],
	"./redux/constants/report/saleReport.js": [
		66009,
		9
	],
	"./redux/constants/responsive/responsive": [
		60850,
		9
	],
	"./redux/constants/responsive/responsive.js": [
		60850,
		9
	],
	"./redux/constants/sale/sale": [
		83884,
		9
	],
	"./redux/constants/sale/sale.js": [
		83884,
		9
	],
	"./redux/constants/salon-account/authenticate": [
		24094,
		9
	],
	"./redux/constants/salon-account/authenticate.js": [
		24094,
		9
	],
	"./redux/constants/salon-account/businessInfo": [
		58189,
		9
	],
	"./redux/constants/salon-account/businessInfo.js": [
		58189,
		9
	],
	"./redux/constants/sms-settings/smsSettings": [
		39677,
		9
	],
	"./redux/constants/sms-settings/smsSettings.js": [
		39677,
		9
	],
	"./redux/constants/staff/staff": [
		6196,
		9
	],
	"./redux/constants/staff/staff.js": [
		6196,
		9
	],
	"./redux/constants/staff/staffAccount": [
		62957,
		9
	],
	"./redux/constants/staff/staffAccount.js": [
		62957,
		9
	],
	"./redux/constants/tax/tax": [
		67852,
		9
	],
	"./redux/constants/tax/tax.js": [
		67852,
		9
	],
	"./redux/constants/thermal-printer/thermalPrinter": [
		65753,
		9
	],
	"./redux/constants/thermal-printer/thermalPrinter.js": [
		65753,
		9
	],
	"./redux/constants/time-clock/time-clock": [
		60858,
		9
	],
	"./redux/constants/time-clock/time-clock.js": [
		60858,
		9
	],
	"./redux/constants/upcomming-appointments/upcommingAppointments": [
		95533,
		9
	],
	"./redux/constants/upcomming-appointments/upcommingAppointments.js": [
		95533,
		9
	],
	"./redux/reducers": [
		31863,
		9
	],
	"./redux/reducers/": [
		31863,
		9
	],
	"./redux/reducers/ai-receptionist-settings/aiReceptionistSettings": [
		69470,
		9
	],
	"./redux/reducers/ai-receptionist-settings/aiReceptionistSettings.js": [
		69470,
		9
	],
	"./redux/reducers/appointment/appointment": [
		35460,
		9
	],
	"./redux/reducers/appointment/appointment.js": [
		35460,
		9
	],
	"./redux/reducers/appointment/availability/availability": [
		8890,
		9
	],
	"./redux/reducers/appointment/availability/availability.js": [
		8890,
		9
	],
	"./redux/reducers/autoPromotionSms/autoPromotionSms": [
		80596,
		9
	],
	"./redux/reducers/autoPromotionSms/autoPromotionSms.js": [
		80596,
		9
	],
	"./redux/reducers/billing/billing": [
		45616,
		9
	],
	"./redux/reducers/billing/billing.js": [
		45616,
		9
	],
	"./redux/reducers/business-client-settings/businessClientSettings": [
		71298,
		9
	],
	"./redux/reducers/business-client-settings/businessClientSettings.js": [
		71298,
		9
	],
	"./redux/reducers/business-client/businessClient": [
		39981,
		9
	],
	"./redux/reducers/business-client/businessClient.js": [
		39981,
		9
	],
	"./redux/reducers/business-hour/business-hour": [
		23744,
		9
	],
	"./redux/reducers/business-hour/business-hour.js": [
		23744,
		9
	],
	"./redux/reducers/check-in-settings/checkInSettings": [
		14636,
		9
	],
	"./redux/reducers/check-in-settings/checkInSettings.js": [
		14636,
		9
	],
	"./redux/reducers/clover/cloverStatus": [
		58986,
		9
	],
	"./redux/reducers/clover/cloverStatus.js": [
		58986,
		9
	],
	"./redux/reducers/depositSettings/depositSettings": [
		42216,
		9
	],
	"./redux/reducers/depositSettings/depositSettings.js": [
		42216,
		9
	],
	"./redux/reducers/gift-card-history/giftCardHistory": [
		15042,
		9
	],
	"./redux/reducers/gift-card-history/giftCardHistory.js": [
		15042,
		9
	],
	"./redux/reducers/gift-card-settings/giftCardSettings": [
		63798,
		9
	],
	"./redux/reducers/gift-card-settings/giftCardSettings.js": [
		63798,
		9
	],
	"./redux/reducers/gift-card/giftCard": [
		47547,
		9
	],
	"./redux/reducers/gift-card/giftCard.js": [
		47547,
		9
	],
	"./redux/reducers/gmb/gmb": [
		66044,
		9
	],
	"./redux/reducers/gmb/gmb.js": [
		66044,
		9
	],
	"./redux/reducers/googleProfile/googleProfile": [
		16364,
		9
	],
	"./redux/reducers/googleProfile/googleProfile.js": [
		16364,
		9
	],
	"./redux/reducers/history/history": [
		45824,
		9
	],
	"./redux/reducers/history/history.js": [
		45824,
		9
	],
	"./redux/reducers/holiday/holiday": [
		51992,
		9
	],
	"./redux/reducers/holiday/holiday.js": [
		51992,
		9
	],
	"./redux/reducers/index": [
		31863,
		9
	],
	"./redux/reducers/index.js": [
		31863,
		9
	],
	"./redux/reducers/invoice/invoice": [
		13632,
		9
	],
	"./redux/reducers/invoice/invoice.js": [
		13632,
		9
	],
	"./redux/reducers/loyaltySetting/loyaltySetting": [
		20558,
		9
	],
	"./redux/reducers/loyaltySetting/loyaltySetting.js": [
		20558,
		9
	],
	"./redux/reducers/menu/menu": [
		19056,
		9
	],
	"./redux/reducers/menu/menu.js": [
		19056,
		9
	],
	"./redux/reducers/meta/meta": [
		74604,
		9
	],
	"./redux/reducers/meta/meta.js": [
		74604,
		9
	],
	"./redux/reducers/new-calendar/newCalendar": [
		56943,
		9
	],
	"./redux/reducers/new-calendar/newCalendar.js": [
		56943,
		9
	],
	"./redux/reducers/newClover/newClover": [
		83163,
		9
	],
	"./redux/reducers/newClover/newClover.js": [
		83163,
		9
	],
	"./redux/reducers/notification/notification": [
		71648,
		9
	],
	"./redux/reducers/notification/notification.js": [
		71648,
		9
	],
	"./redux/reducers/payment-integration-settings/paymentIntegrationSettings": [
		87328,
		9
	],
	"./redux/reducers/payment-integration-settings/paymentIntegrationSettings.js": [
		87328,
		9
	],
	"./redux/reducers/poynt/poynt": [
		11916,
		9
	],
	"./redux/reducers/poynt/poynt.js": [
		11916,
		9
	],
	"./redux/reducers/product/product": [
		66912,
		9
	],
	"./redux/reducers/product/product.js": [
		66912,
		9
	],
	"./redux/reducers/promotion/promotion": [
		57468,
		9
	],
	"./redux/reducers/promotion/promotion.js": [
		57468,
		9
	],
	"./redux/reducers/report/billingReport": [
		10991,
		9
	],
	"./redux/reducers/report/billingReport.js": [
		10991,
		9
	],
	"./redux/reducers/report/saleReport": [
		9733,
		9
	],
	"./redux/reducers/report/saleReport.js": [
		9733,
		9
	],
	"./redux/reducers/responsive/responsive": [
		43774,
		9
	],
	"./redux/reducers/responsive/responsive.js": [
		43774,
		9
	],
	"./redux/reducers/sale/sale": [
		34568,
		9
	],
	"./redux/reducers/sale/sale.js": [
		34568,
		9
	],
	"./redux/reducers/salon-account/authenticate": [
		38090,
		9
	],
	"./redux/reducers/salon-account/authenticate.js": [
		38090,
		9
	],
	"./redux/reducers/salon-account/businessInfo": [
		6161,
		9
	],
	"./redux/reducers/salon-account/businessInfo.js": [
		6161,
		9
	],
	"./redux/reducers/sms-settings/smsSettings": [
		32697,
		9
	],
	"./redux/reducers/sms-settings/smsSettings.js": [
		32697,
		9
	],
	"./redux/reducers/staff/staff": [
		80928,
		9
	],
	"./redux/reducers/staff/staff.js": [
		80928,
		9
	],
	"./redux/reducers/staff/staffAccount": [
		48193,
		9
	],
	"./redux/reducers/staff/staffAccount.js": [
		48193,
		9
	],
	"./redux/reducers/tax/tax": [
		33032,
		9
	],
	"./redux/reducers/tax/tax.js": [
		33032,
		9
	],
	"./redux/reducers/thermal-printer/thermalPrinter": [
		56885,
		9
	],
	"./redux/reducers/thermal-printer/thermalPrinter.js": [
		56885,
		9
	],
	"./redux/reducers/time-clock/time-clock": [
		29446,
		9
	],
	"./redux/reducers/time-clock/time-clock.js": [
		29446,
		9
	],
	"./redux/reducers/upcomming-appointments/upcommingAppointments": [
		13497,
		9
	],
	"./redux/reducers/upcomming-appointments/upcommingAppointments.js": [
		13497,
		9
	],
	"./redux/store": [
		89095,
		9
	],
	"./redux/store/": [
		89095,
		9
	],
	"./redux/store/index": [
		89095,
		9
	],
	"./redux/store/index.js": [
		89095,
		9
	],
	"./serviceWorker": [
		47001,
		9
	],
	"./serviceWorker.js": [
		47001,
		9
	],
	"./setupTests": [
		89472,
		9,
		26989,
		87150,
		89472
	],
	"./setupTests.js": [
		89472,
		9,
		26989,
		87150,
		89472
	],
	"./socket": [
		52863,
		9,
		42104,
		52863
	],
	"./socket.js": [
		52863,
		9,
		42104,
		52863
	],
	"./utils/API/API": [
		78469,
		9
	],
	"./utils/API/API.js": [
		78469,
		9
	],
	"./utils/CheckOutHelper/checkOutHelperFunction": [
		47227,
		9,
		47227
	],
	"./utils/CheckOutHelper/checkOutHelperFunction.js": [
		47227,
		9,
		47227
	],
	"./utils/Clover/CardDataHelper": [
		83154,
		9,
		83154
	],
	"./utils/Clover/CardDataHelper.js": [
		83154,
		9,
		83154
	],
	"./utils/Clover/CloverConnection": [
		21737,
		9,
		361,
		82146,
		21737
	],
	"./utils/Clover/CloverConnection.js": [
		21737,
		9,
		361,
		82146,
		21737
	],
	"./utils/Clover/ConnectionHelper": [
		26424,
		9,
		26424
	],
	"./utils/Clover/ConnectionHelper.js": [
		26424,
		9,
		26424
	],
	"./utils/Clover/CurrencyFormatter": [
		91205,
		9,
		91205
	],
	"./utils/Clover/CurrencyFormatter.js": [
		91205,
		9,
		91205
	],
	"./utils/Clover/ImageHelper": [
		61819,
		9,
		61819
	],
	"./utils/Clover/ImageHelper.js": [
		61819,
		9,
		61819
	],
	"./utils/Clover/POSCloverConnectorListener": [
		82146,
		9,
		361,
		82146
	],
	"./utils/Clover/POSCloverConnectorListener.js": [
		82146,
		9,
		361,
		82146
	],
	"./utils/Clover/config": [
		93086,
		9,
		93086
	],
	"./utils/Clover/config.js": [
		93086,
		9,
		93086
	],
	"./utils/Clover/models/OrderPayment": [
		59939,
		9,
		59939
	],
	"./utils/Clover/models/OrderPayment.js": [
		59939,
		9,
		59939
	],
	"./utils/Clover/models/Transaction": [
		6765,
		9,
		6765
	],
	"./utils/Clover/models/Transaction.js": [
		6765,
		9,
		6765
	],
	"./utils/FormatPhoneNumber/FormatPhoneNumber": [
		78777,
		9,
		59221,
		78777
	],
	"./utils/FormatPhoneNumber/FormatPhoneNumber.js": [
		78777,
		9,
		59221,
		78777
	],
	"./utils/ReviewResponse/ReviewResponse": [
		79881,
		9,
		79881
	],
	"./utils/ReviewResponse/ReviewResponse.js": [
		79881,
		9,
		79881
	],
	"./utils/SortArray/SortArray": [
		21009,
		9
	],
	"./utils/SortArray/SortArray.js": [
		21009,
		9
	],
	"./utils/UnexcapeString/UnexcapeString": [
		24599,
		9
	],
	"./utils/UnexcapeString/UnexcapeString.js": [
		24599,
		9
	],
	"./utils/platform": [
		1535,
		9
	],
	"./utils/platform.js": [
		1535,
		9
	],
	"./utils/utility": [
		29934,
		9,
		85867,
		29934
	],
	"./utils/utility.js": [
		29934,
		9,
		85867,
		29934
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 59140;
module.exports = webpackAsyncContext;